var STARMINT_SVG_EYE = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M13 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-1.5 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" fill="#5C5F62"/><path fill-rule="evenodd" d="M10 4c-2.476 0-4.348 1.23-5.577 2.532a9.266 9.266 0 0 0-1.4 1.922 5.98 5.98 0 0 0-.37.818c-.082.227-.153.488-.153.728s.071.501.152.728c.088.246.213.524.371.818.317.587.784 1.27 1.4 1.922 1.229 1.302 3.1 2.532 5.577 2.532 2.476 0 4.348-1.23 5.577-2.532a9.265 9.265 0 0 0 1.4-1.922 5.98 5.98 0 0 0 .37-.818c.082-.227.153-.488.153-.728s-.071-.501-.152-.728a5.984 5.984 0 0 0-.371-.818 9.269 9.269 0 0 0-1.4-1.922c-1.229-1.302-3.1-2.532-5.577-2.532Zm-5.999 6.002v-.004c.004-.02.017-.09.064-.223a4.5 4.5 0 0 1 .278-.608 7.768 7.768 0 0 1 1.17-1.605c1.042-1.104 2.545-2.062 4.487-2.062 1.942 0 3.445.958 4.486 2.062a7.77 7.77 0 0 1 1.17 1.605c.13.24.221.447.279.608.047.132.06.203.064.223v.004c-.004.02-.017.09-.064.223a4.503 4.503 0 0 1-.278.608 7.768 7.768 0 0 1-1.17 1.605c-1.042 1.104-2.545 2.062-4.487 2.062-1.942 0-3.445-.958-4.486-2.062a7.766 7.766 0 0 1-1.17-1.605 4.5 4.5 0 0 1-.279-.608c-.047-.132-.06-.203-.064-.223Z" fill="#5C5F62"/></svg>';
var STARMINT_SVG_HIDE = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.977 4.751a7.598 7.598 0 0 0-1.977-.251c-2.444 0-4.196 1.045-5.325 2.233a7.188 7.188 0 0 0-1.243 1.773c-.26.532-.432 1.076-.432 1.494 0 .418.171.962.432 1.493.172.354.4.734.687 1.116l1.074-1.074a5.388 5.388 0 0 1-.414-.7c-.221-.453-.279-.753-.279-.835 0-.082.058-.382.279-.835a5.71 5.71 0 0 1 .983-1.398c.89-.937 2.264-1.767 4.238-1.767.24 0 .471.012.693.036l1.284-1.285Z" fill="#5C5F62"/><path fill-rule="evenodd" d="M4.25 14.6a.75.75 0 0 0 1.067 1.053l1.062-1.061c.975.543 2.177.908 3.621.908 2.45 0 4.142-1.05 5.24-2.242 1.078-1.17 1.588-2.476 1.738-3.076a.749.749 0 0 0 0-.364c-.15-.6-.66-1.906-1.738-3.076a7.245 7.245 0 0 0-.51-.502l.923-.923a.75.75 0 0 0-1.053-1.068l-.008.008-10.335 10.336-.008.007Zm5.75-.6c-.978 0-1.809-.204-2.506-.523l1.108-1.109a2.75 2.75 0 0 0 3.766-3.766l1.3-1.299c.169.147.325.3.469.455a6.387 6.387 0 0 1 1.332 2.242 6.387 6.387 0 0 1-1.332 2.242c-.86.933-2.17 1.758-4.137 1.758Zm0-2.75c-.087 0-.172-.01-.254-.026l1.478-1.478a1.25 1.25 0 0 1-1.224 1.504Z" fill="#5C5F62"/></svg>';

// Build marker — visible in DevTools Console so you can confirm the latest JS shipped.
console.log("[starmint] star-selectors-all.js build v2026-06-02-personalize-all-stars");

/** Show/hide elements that may use display:none !important in older theme HTML. */
function starmintSetStepDisplay(el, display) {
  if (!el) return;
  if (!display || display === "none") {
    el.style.removeProperty("display");
    el.style.display = "none";
    return;
  }
  el.style.setProperty("display", display, "important");
}

// Bulletproof safety net: watch for #star-select-confirm-results becoming visible,
// and auto-open the registration form whenever it is. This runs no matter which
// code path showed the confirm step (zodiac/constellation/random/identifier/night-sky/
// restored from refresh/etc.) so the right column will not stay empty.
(function () {
  function isVisibleEl(el) {
    if (!el) return false;
    if (el.style && el.style.display === "none") return false;
    var cs = window.getComputedStyle(el);
    return cs && cs.display !== "none" && cs.visibility !== "hidden";
  }

  function ensureFormVisible(reason) {
    var confirmEl = document.getElementById("star-select-confirm-results");
    if (!confirmEl || !isVisibleEl(confirmEl)) return;

    var giftCb = document.getElementById("gift");
    var recipientForm = document.getElementById("recipient-info-form");
    var giftAccountForm = document.getElementById("account-info-form");
    var giftFlowActive = typeof starmintIsGiftFlowActive === "function" ? starmintIsGiftFlowActive() :
      ((typeof is_gift !== "undefined" && is_gift) || (giftCb && giftCb.checked));
    if (giftFlowActive) {
      if (isVisibleEl(recipientForm) || isVisibleEl(giftAccountForm)) return;
      var starInfoGiftStep = document.getElementById("star-info-form");
      if (isVisibleEl(starInfoGiftStep)) return;
      try {
        var rawGiftState = sessionStorage.getItem("starmint_star_flow_state");
        if (rawGiftState && JSON.parse(rawGiftState).is_gift) return;
        if (sessionStorage.getItem("starmint_gift_recipient")) return;
      } catch (_giftObserverErr) { }
    }

    var account = document.getElementById("account-info-form");
    var starInfo = document.getElementById("star-info-form");
    var starAccount = document.getElementById("star-account-info-form");
    var hasVisiblePrimaryForm = isVisibleEl(starInfo) || isVisibleEl(account);
    var anyHidden = !starAccount || !isVisibleEl(starAccount) || !hasVisiblePrimaryForm;
    if (!anyHidden) return;
    console.log("[starmint] Auto-opening account form (" + reason + ")");
    if (typeof window.starmintForceShowAccountFormUI === "function") {
      window.starmintForceShowAccountFormUI();
    } else {
      // Inline fallback in case the helper hasn't been defined yet.
      if (starAccount) starAccount.style.display = "block";
      if (account) account.style.display = "none";
      var sf = document.getElementById("star-info-form");
      starmintSetStepDisplay(sf, "block");
      var rf = document.getElementById("recipient-info-form");
      if (rf) rf.style.display = "none";
      var continueToAccountContainer = document.getElementById("star-form-continue-0-container");
      starmintSetStepDisplay(continueToAccountContainer, "block");
      var continueRecipientContainer = document.getElementById("star-form-continue-01-container");
      if (continueRecipientContainer) continueRecipientContainer.style.display = "none";
      var reserveContainer = document.getElementById("star-form-continue-1-container");
      if (reserveContainer) reserveContainer.style.display = "none";
    }
    if (
      !giftFlowActive &&
      typeof window.starmintTriggerFastReservation === "function"
    ) {
      try { window.starmintTriggerFastReservation(); } catch (_e) { }
    }
  }

  function startObserving() {
    var confirmEl = document.getElementById("star-select-confirm-results");
    if (!confirmEl) {
      // DOM may not be ready yet — try again shortly.
      return setTimeout(startObserving, 150);
    }
    try {
      var mo = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].type === "attributes" && mutations[i].attributeName === "style") {
            ensureFormVisible("MutationObserver style change");
            return;
          }
        }
      });
      mo.observe(confirmEl, { attributes: true, attributeFilter: ["style", "class"] });
      console.log("[starmint] MutationObserver attached to #star-select-confirm-results");
    } catch (e) {
      console.warn("[starmint] MutationObserver failed:", e);
    }
    // First check + a couple of safety re-checks for edge cases.
    ensureFormVisible("initial");
    setTimeout(function () { ensureFormVisible("250ms"); }, 250);
    setTimeout(function () { ensureFormVisible("1500ms"); }, 1500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startObserving);
  } else {
    startObserving();
  }
})();

// Brute-force helper: open the registration form for a guest, regardless of helper state.
// Used both by starmintRestoreStarFlowState (after a refresh) and as a defensive backup
// if starmintTriggerFastReservation hasn't been assigned yet for any reason.
function starmintForceShowAccountFormUI() {
  try {
    if (starmintIsGiftFlowActive()) {
      try {
        const raw = sessionStorage.getItem("starmint_star_flow_state");
        if (raw) {
          const state = JSON.parse(raw);
          if (
            state.is_gift &&
            (state.activeStepId === "account-info-form" ||
              state.activeStepId === "recipient-info-form" ||
              state.activeStepId === "reservation-verify-step")
          ) {
            starmintRestoreGiftStepUi(state.activeStepId);
            return;
          }
        }
      } catch (_giftRestoreErr) { }
      if (starmintIsActiveGiftStep()) return;
      if (document.getElementById("gift") && document.getElementById("gift").checked) return;
    }

    var ids = {
      confirm: "star-select-confirm-results",
      starInfo: "star-info-form",
      starAccount: "star-account-info-form",
      recipient: "recipient-info-form",
      account: "account-info-form",
      formForm: "account-info-form-form",
      hl: "account-info-form-headline",
      ph: "account-info-form-preheadline",
      legal: "legal-checkbox",
      claimHl: "claim-star-headline",
      claimPara: "claim-star-paragraph",
      hasAccountP: "has-account-p",
      signupBtn: "signup-claim-star"
    };
    var el = function (k) { return document.getElementById(ids[k]); };

    var confirmEl = el("confirm");
    if (confirmEl) confirmEl.style.display = "block";

    var selectorsStartEl = document.getElementsByClassName("star-selectors-start")[0];
    if (selectorsStartEl) selectorsStartEl.style.display = "none";

    starmintSetStepDisplay(el("starInfo"), "block");
    if (el("starAccount")) el("starAccount").style.display = "block";
    if (el("recipient")) el("recipient").style.display = "none";
    if (el("account")) el("account").style.display = "none";
    var continueToAccountContainer = document.getElementById("star-form-continue-0-container");
    starmintSetStepDisplay(continueToAccountContainer, "block");
    var continueRecipientContainer = document.getElementById("star-form-continue-01-container");
    if (continueRecipientContainer) continueRecipientContainer.style.display = "none";
    var reserveContainer = document.getElementById("star-form-continue-1-container");
    if (reserveContainer) reserveContainer.style.display = "none";

    // Make sure registration sub-blocks are not hidden by the supabase-restore code.
    if (el("formForm")) el("formForm").style.display = "";
    if (el("hl")) el("hl").style.display = "";
    if (el("ph")) el("ph").style.display = "";
    if (el("legal")) el("legal").style.visibility = "visible";
    if (el("claimHl")) el("claimHl").style.visibility = "visible";
    if (el("claimPara")) el("claimPara").style.visibility = "visible";
    if (el("signupBtn")) el("signupBtn").disabled = false;

    if (typeof setActivePage === "function") {
      try { setActivePage(2); } catch (_e) { }
    }
    console.log("[starmint] starmintForceShowAccountFormUI applied");
  } catch (e) {
    console.warn("[starmint] starmintForceShowAccountFormUI failed", e);
  }
}
window.starmintForceShowAccountFormUI = starmintForceShowAccountFormUI;

let usingDetectedLocation = false;
let testing = true;

let loggedInCustomer = false;
let loggedInCustomerID = false;

function starmintReadAccountIdCookie() {
  try {
    var m = document.cookie.match(/(?:^|;\s*)accountId=([^;]*)/);
    return m ? decodeURIComponent(m[1].trim()) : "";
  } catch (_e) {
    return "";
  }
}

function starmintReadShopifyCustomerIdFromLocalStorage() {
  try {
    return String(localStorage.getItem("shopify_customer_id") || "").trim();
  } catch (_e) {
    return "";
  }
}

/** Shopify storefront customer id: Liquid object, section JSON, cookie (theme sets when logged in), or numeric LS. */
function starmintResolveStorefrontCustomerId() {
  var c = window.__STARMINT_CUSTOMER;
  var fromCustomer = c && c.id != null && String(c.id).trim() !== "" ? String(c.id).trim() : "";
  if (fromCustomer) return fromCustomer;
  var sid =
    window.__STARMINT_STAR_SELECTORS__ && window.__STARMINT_STAR_SELECTORS__.customerId != null
      ? String(window.__STARMINT_STAR_SELECTORS__.customerId).trim()
      : "";
  if (sid) return sid;
  var cookieId = starmintReadAccountIdCookie();
  if (cookieId) return cookieId;
  var lsId = starmintReadShopifyCustomerIdFromLocalStorage();
  if (lsId && /^\d+$/.test(lsId)) return lsId;
  return "";
}

let sampleCertificates = {
  "1": "https://cdn.shopify.com/s/files/1/0767/8613/9438/files/certificate-bg-image-v3-optimized600x600.jpg?v=1698243172",
  "2": "https://cdn.shopify.com/s/files/1/0767/8613/9438/files/certificate-bg-image-v4_600x600_b2a251ef-5752-4d30-bfa1-34e060933430.jpg?v=1698243173",
  "loading": "https://cdn.shopify.com/s/files/1/0767/8613/9438/files/loader-star.svg?v=1698243174"
};

(function () {
  var cid = starmintResolveStorefrontCustomerId();
  if (cid) {
    loggedInCustomer = true;
    loggedInCustomerID = String(cid);
    (function () {
      var _btn = document.getElementById("signup-claim-star");
      if (_btn) _btn.innerText = "Reserve Star";
    })();
  }
})();

// STAR FLOW PERSISTENCE HELPERS
function starmintHasRecoverableStarFlowState(state) {
  if (!state) return false;
  const hasStar = !!(state.current_star && (state.current_star.identifier || state.current_star.id));
  const onFlowStep = !!(state.activeStepId && state.activeStepId !== "star-selectors-start");
  const giftMidFlow = !!(state.is_gift || state.giftCheckboxChecked);
  return hasStar || onFlowStep || giftMidFlow;
}

function starmintSavePendingStarForLogin() {
  try {
    if (starmintIsGiftFlowActive()) {
      starmintPersistGiftRecipientInfo(starmintReadRecipientFieldsFromDom());
    }
    starmintSaveStarFlowState();
    const giftCb = document.getElementById("gift");
    const payload = {
      current_star: current_star,
      starName: (document.getElementById("starName")?.value || "").trim(),
      namingDate: (document.getElementById("namingDate")?.value || "").trim(),
      personalMessage: (document.getElementById("personalMessage")?.value || "").trim(),
      is_gift: is_gift || !!(giftCb && giftCb.checked),
      giftCheckboxChecked: !!(giftCb && giftCb.checked),
      activeStepId:
        typeof starmintDetectActiveStarFlowStepId === "function"
          ? starmintDetectActiveStarFlowStepId()
          : "star-select-confirm-results",
      recipientInfo: {
        firstName: rfirstName || (document.getElementById("recFirstName")?.value || "").trim(),
        lastName: rlastName || (document.getElementById("recLastName")?.value || "").trim(),
        email: remail || (document.getElementById("recEmail")?.value || "").trim(),
        phone: rphone || (document.getElementById("recPhone")?.value || "").trim(),
      },
    };
    sessionStorage.setItem("starmint_pending_star", JSON.stringify(payload));
  } catch (_pendingErr) {
    console.warn("[starmint] Could not save pending star for login redirect:", _pendingErr);
  }
}

function starmintSaveStarFlowState() {
  try {
    const activeStepId = starmintDetectActiveStarFlowStepId();
    const state = {
      current_star: current_star,
      reserve_star: reserve_star,
      owned_star: owned_star,
      personalizationStarSource: personalizationStarSource,
      is_gift: is_gift,
      giftCheckboxChecked: !!(document.getElementById("gift") && document.getElementById("gift").checked),
      checkedAndOK: !!checkedAndOK,
      activeStepId: activeStepId,
      return_to: window.location.pathname + window.location.search,
      inputs: {
        starName: document.getElementById("starName")?.value || "",
        namingDate: document.getElementById("namingDate")?.value || "",
        personalMessage: document.getElementById("personalMessage")?.value || "",
        // birthday/zodiac fields if relevant
        birthdayMonth: document.getElementById("birthday-month")?.value || "",
        birthdayDate: document.getElementById("birthday-date")?.value || "",
        // Registration fields
        firstName: document.getElementById("firstName")?.value || "",
        lastName: document.getElementById("lastName")?.value || "",
        email: document.getElementById("email")?.value || "",
        phone: document.getElementById("phone")?.value || "",
        recFirstName: document.getElementById("recFirstName")?.value || rfirstName || "",
        recLastName: document.getElementById("recLastName")?.value || rlastName || "",
        recEmail: document.getElementById("recEmail")?.value || remail || "",
        recPhone: document.getElementById("recPhone")?.value || rphone || ""
      },
      is_verifying: document.getElementById("reservation-verify-step")?.style.display === "block",
      pendingData: window._starReservationPendingData || null,
      timestamp: Date.now(),
      shopifyCustomerId: (typeof starmintResolveStorefrontCustomerId === "function" ? starmintResolveStorefrontCustomerId() : "") || ""
    };
    sessionStorage.setItem("starmint_star_flow_state", JSON.stringify(state));
    console.log("Star flow state saved to session.");
  } catch (e) {
    console.warn("Could not save star flow state:", e);
  }
}

function starmintRestoreStarFlowState() {
  try {
    const raw = sessionStorage.getItem("starmint_star_flow_state");
    if (!raw) return false;

    const state = JSON.parse(raw);
    const age = Date.now() - state.timestamp;
    // Don't restore if data is more than 30 minutes old
    if (age > 30 * 60 * 1000) {
      sessionStorage.removeItem("starmint_star_flow_state");
      return false;
    }

    var nowCid =
      typeof starmintResolveStorefrontCustomerId === "function" ? starmintResolveStorefrontCustomerId() : "";
    var savedCid =
      state.shopifyCustomerId != null && String(state.shopifyCustomerId).trim() !== ""
        ? String(state.shopifyCustomerId).trim()
        : "";
    // Drop stale wizard state: different Shopify customer, logged-out viewer with saved session, or
    // legacy saves (no saved id) while someone is now logged in (avoid guest mid-flow + logged-in mix).
    // Guest saved mid-flow then logged in: restore instead of discarding.
    if (nowCid && !savedCid) {
      if (!starmintHasRecoverableStarFlowState(state)) {
        sessionStorage.removeItem("starmint_star_flow_state");
        return false;
      }
      console.log("[starmint] Restoring guest mid-flow state after login");
      state.shopifyCustomerId = nowCid;
      try {
        sessionStorage.setItem("starmint_star_flow_state", JSON.stringify(state));
      } catch (_persistLoginRestore) { }
    }
    if (!nowCid && savedCid) {
      sessionStorage.removeItem("starmint_star_flow_state");
      return false;
    }
    if (nowCid && savedCid && String(nowCid) !== String(savedCid)) {
      sessionStorage.removeItem("starmint_star_flow_state");
      return false;
    }

    console.log("Restoring star flow state...", state);
    if (state.current_star) Object.assign(current_star, state.current_star);
    if (state.reserve_star) Object.assign(reserve_star, state.reserve_star);
    if (state.owned_star) Object.assign(owned_star, state.owned_star);
    if (state.personalizationStarSource) personalizationStarSource = state.personalizationStarSource;
    if (typeof state.is_gift !== "undefined") is_gift = state.is_gift;
    if (state.giftCheckboxChecked || state.is_gift) {
      is_gift = true;
      const giftCbRestore = document.getElementById("gift");
      if (giftCbRestore) giftCbRestore.checked = true;
    }
    if (typeof state.checkedAndOK !== "undefined") checkedAndOK = !!state.checkedAndOK;

    // Restore inputs
    if (state.inputs) {
      if (document.getElementById("starName")) document.getElementById("starName").value = state.inputs.starName || "";
      if (document.getElementById("namingDate")) document.getElementById("namingDate").value = state.inputs.namingDate || "";
      if (document.getElementById("personalMessage")) document.getElementById("personalMessage").value = state.inputs.personalMessage || "";
      if (document.getElementById("birthday-month")) document.getElementById("birthday-month").value = state.inputs.birthdayMonth || "";
      if (document.getElementById("birthday-date")) {
        if (typeof populateDateOptions === "function") populateDateOptions();
        document.getElementById("birthday-date").value = state.inputs.birthdayDate || "";
      }
      // Registration fields
      if (document.getElementById("firstName")) document.getElementById("firstName").value = state.inputs.firstName || "";
      if (document.getElementById("lastName")) document.getElementById("lastName").value = state.inputs.lastName || "";
      if (document.getElementById("email")) document.getElementById("email").value = state.inputs.email || "";
      if (document.getElementById("phone")) document.getElementById("phone").value = state.inputs.phone || "";
      if (document.getElementById("recFirstName")) document.getElementById("recFirstName").value = state.inputs.recFirstName || "";
      if (document.getElementById("recLastName")) document.getElementById("recLastName").value = state.inputs.recLastName || "";
      if (document.getElementById("recEmail")) document.getElementById("recEmail").value = state.inputs.recEmail || "";
      if (document.getElementById("recPhone")) document.getElementById("recPhone").value = state.inputs.recPhone || "";
      starmintSyncRecipientGlobals({
        firstName: state.inputs.recFirstName || "",
        lastName: state.inputs.recLastName || "",
        email: state.inputs.recEmail || "",
        phone: state.inputs.recPhone || "",
      });
    }

    if (state.pendingData) {
      window._starReservationPendingData = state.pendingData;
    }

    // Reservation-only side-effects (need a real reserved star id).
    if (current_star.id) {
      updateCertificateStarNameDisplay();
      savePreviewContext();
      updatePersonalizationSourceSummary();
    }

    const starSelectConfirmResults = document.getElementById("star-select-confirm-results");
    const selectorsStart = document.getElementsByClassName("star-selectors-start")[0];

    // Steps that live inside #star-select-confirm-results. If the user refreshed while
    // anywhere on that screen, re-open the section AND re-run starmintTriggerFastReservation
    // so the right-hand form (account form / star info / reserve form) reappears even if the
    // star hasn't been reserved yet (i.e. current_star.id is empty pre-reservation).
    const confirmSubSteps = new Set([
      "star-select-confirm-results",
      "star-account-info-form",
      "star-info-form",
      "recipient-info-form",
      "account-info-form",
    ]);

    if (state.is_verifying || state.activeStepId === "reservation-verify-step") {
      if (selectorsStart) selectorsStart.style.display = "none";
      if (document.getElementById("star-info-form")) document.getElementById("star-info-form").style.display = "none";
      if (document.getElementById("star-account-info-form")) document.getElementById("star-account-info-form").style.display = "none";
      if (document.getElementById("reservation-verify-step")) {
        document.getElementById("reservation-verify-step").style.display = "block";
        const email = state.pendingData?.email || state.inputs.email;
        if (email) document.getElementById("res-verify-intro-text").innerHTML = `We've sent a 6-digit verification code to <strong>${email}</strong>.`;
        setTimeout(() => scrollToElement(document.getElementById("reservation-verify-step")), 500);
      }
    } else if (
      starSelectConfirmResults &&
      (current_star.identifier || current_star.id) &&
      confirmSubSteps.has(state.activeStepId)
    ) {
      console.log("[starmint] Restoring confirm-step UI for activeStepId:", state.activeStepId);
      // Re-render the confirm stats (works even when current_star.id is not yet set —
      // i.e. the user reloaded after picking a star but before reserving it).
      const degreeRA = hmsToDegreesString(current_star.ra, 'ra');
      const degreeDEC = hmsToDegreesString(current_star.dec, 'dec');
      const starHTML = `
        <p class="paragraph-color font-size20" style="margin-top:30px">Your star</p>
        <p class="paragraph-color font-size20-600">${current_star.identifier || ""}</p>
        <p class="paragraph-color font-size20">Right Ascension: ${degreeRA}<br />Declination: ${degreeDEC}</p>
      `;
      const statsEl = document.getElementById("star-select-confirm-stats");
      if (statsEl) statsEl.innerHTML = statsEl.innerHTML.includes("Your star") ? statsEl.innerHTML : starHTML;
      // Always overwrite to keep stats consistent with restored star.
      if (statsEl) statsEl.innerHTML = starHTML;

      // Re-render the chart image with the picked star (otherwise it falls back to the
      // hard-coded default chart in Liquid).
      const chartImageEl = document.getElementById("chart-image");
      if (chartImageEl) {
        const chartUrl = current_star.chart && String(current_star.chart).trim();
        const chartHTML = chartUrl
          ? `<img src="${chartUrl}" alt="Star Chart Image For ${current_star.identifier || ""}" class="chart-img-height" data-src-for-chartIdentifier='${current_star.identifier || ""}'>`
          : (window.__STARMINT_STAR_SELECTORS__ && window.__STARMINT_STAR_SELECTORS__.defaultChartUrl
            ? `<img src="${window.__STARMINT_STAR_SELECTORS__.defaultChartUrl}" alt="Star Chart" class="chart-img-height">`
            : "");
        if (chartHTML) chartImageEl.innerHTML = chartHTML;
      }

      starSelectConfirmResults.style.display = "block";
      if (selectorsStart) selectorsStart.style.display = "none";

      starmintRestoreGiftStepUi(state.activeStepId);

      if (nowCid && is_gift) {
        try { starmintApplyLayoutCustomerToStarFlow(); } catch (_layoutErr) { }
      }

      // After login in the gift flow: user was at account-info-form (gifter account step),
      // now they're logged in — auto-trigger the gift reservation instead of showing the form again.
      // starmint_post_login_redirect = "1" is the proof of just-completed login.
      // We don't require nowCid because accounts created before Shopify-linking may lack a Shopify ID;
      // Supabase session tokens in localStorage are sufficient to confirm authentication.
      var _postLoginHasAuth = !!(nowCid || (function () {
        try {
          return !!(localStorage.getItem("supabase_access_token") ||
                    localStorage.getItem("supabase_user") ||
                    localStorage.getItem("supabaseUser"));
        } catch (_) { return false; }
      })());
      if (
        _postLoginHasAuth &&
        is_gift &&
        state.activeStepId === "account-info-form" &&
        sessionStorage.getItem("starmint_post_login_redirect")
      ) {
        sessionStorage.removeItem("starmint_post_login_redirect");
        setTimeout(function () {
          try {
            if (typeof starmintRunLoggedInGiftReservation === "function") {
              var _resolvedEmail = (window.__STARMINT_CUSTOMER && window.__STARMINT_CUSTOMER.email) || (function () {
                try {
                  var _u = JSON.parse(localStorage.getItem("supabase_user") || localStorage.getItem("supabaseUser") || "null");
                  return (_u && _u.email) ? _u.email : "";
                } catch (_) { return ""; }
              })();
              var _resolvedCid = starmintResolveStorefrontCustomerId() || (loggedInCustomerID !== false ? loggedInCustomerID : "") || "";
              starmintRunLoggedInGiftReservation(null, {
                email: _resolvedEmail,
                shopifyAccountID: _resolvedCid,
              });
            }
          } catch (_autoGiftResErr) {
            console.error("[starmint] Auto gift reservation after login failed:", _autoGiftResErr);
          }
        }, 900);
      }

      setTimeout(() => scrollToElement(starSelectConfirmResults), 500);

      if (!is_gift || (state.activeStepId !== "account-info-form" && state.activeStepId !== "recipient-info-form")) {
        try { starmintForceShowAccountFormUI(); } catch (_e) { }
      }

      const triggerWhenReady = function (attempt) {
        if (typeof window.starmintTriggerFastReservation === "function") {
          console.log("[starmint] Re-triggering fast reservation after refresh (attempt " + attempt + ")");
          try {
            if (!is_gift || !starmintIsActiveGiftStep()) {
              const result = window.starmintTriggerFastReservation();
              if (result && typeof result.catch === "function") {
                result.catch(function (err) {
                  console.error("[starmint] starmintTriggerFastReservation threw:", err);
                });
              }
            }
          } catch (err) {
            console.error("[starmint] starmintTriggerFastReservation threw synchronously:", err);
          }
          starmintRestoreGiftStepUi(state.activeStepId);
          return;
        }
        if (attempt >= 25) {
          console.warn("[starmint] starmintTriggerFastReservation never appeared — falling back to forced UI only");
          if (!is_gift) {
            try { starmintForceShowAccountFormUI(); } catch (_e) { }
          } else {
            starmintRestoreGiftStepUi(state.activeStepId);
          }
          return;
        }
        setTimeout(function () { triggerWhenReady(attempt + 1); }, 100);
      };
      setTimeout(function () { triggerWhenReady(1); }, 0);

      setTimeout(function () {
        if (is_gift) {
          starmintRestoreGiftStepUi(state.activeStepId);
          return;
        }
        var ai = document.getElementById("account-info-form");
        var sa = document.getElementById("star-account-info-form");
        var aiHidden = !ai || ai.style.display === "none";
        var saHidden = !sa || sa.style.display === "none";
        if (aiHidden || saHidden) {
          console.warn("[starmint] Account form hidden 1.5s after restore — forcing it back on");
          try { starmintForceShowAccountFormUI(); } catch (_e) { }
        }
      }, 1500);
    } else if (state.activeStepId && state.activeStepId !== "reservation-verify-step") {
      // Generic fallback for non-confirm steps (zodiac/constellation lists, etc).
      const targetStep = document.getElementById(state.activeStepId);
      if (targetStep) {
        if (selectorsStart && state.activeStepId !== "star-selectors-start") {
          selectorsStart.style.display = "none";
        }
        if (STARMINT_CONFIRM_CHILD_STEP_IDS.has(state.activeStepId) && starSelectConfirmResults) {
          starSelectConfirmResults.style.display = "block";
        }
        targetStep.style.display = "block";
      }
    }
    updatePersonalizationSourceSummary();
    sessionStorage.removeItem("starmint_pending_star");

    if (
      sessionStorage.getItem("starmint_post_login_redirect") &&
      nowCid &&
      !is_gift &&
      !current_star.id &&
      typeof reserveStar === "function"
    ) {
      sessionStorage.removeItem("starmint_post_login_redirect");
      var resumeStarName = (state.inputs && state.inputs.starName) || current_star.name || "";
      var resumeNamingDate =
        (state.inputs && state.inputs.namingDate) ||
        (document.getElementById("namingDate") && document.getElementById("namingDate").value) ||
        formattedToday;
      var resumePersonalMessage = (state.inputs && state.inputs.personalMessage) || "";
      if (resumeStarName && resumeNamingDate) {
        setTimeout(function () {
          try {
            starmintApplyLayoutCustomerToStarFlow();
          } catch (_layoutResume) {}
          reserveStar(
            String(resumeStarName).trim(),
            String(resumeNamingDate).trim(),
            String(resumePersonalMessage || "").trim(),
            false,
            { data: { userInfo: { shopifyAccountID: String(nowCid) } } }
          );
        }, 900);
      }
    }

    return true;
  } catch (e) {
    console.warn("Could not restore star flow state:", e);
    return false;
  }
}

function starmintClearStarFlowState() {
  sessionStorage.removeItem("starmint_star_flow_state");
}

var STARMINT_CONFIRM_CHILD_STEP_IDS = new Set([
  "star-select-confirm-results",
  "star-account-info-form",
  "star-info-form",
  "recipient-info-form",
  "account-info-form",
]);

function starmintIsFindAStarPage() {
  return String(window.location.pathname || "").indexOf("select-a-star") !== -1;
}

function starmintIsAnyStarFlowUiVisible() {
  if (starmintIsElementVisible("star-selectors-start")) return true;
  var stepIds = [
    "reservation-verify-step",
    "star-select-confirm-results",
    "star-select-zodiac-results",
    "star-select-constellation-results",
    "star-select-byNightsky-results",
    "star-select-random-results",
    "star-select-byIdentifier-results",
    "star-select-zodiacs-list",
    "constellation-drop",
    "byIdentifier-drop",
    "byNightsky-drop",
    "loading",
  ];
  for (var i = 0; i < stepIds.length; i++) {
    if (starmintIsElementVisible(stepIds[i])) return true;
  }
  return false;
}

function starmintResetFindAStarToStart() {
  starmintClearStarFlowState();
  try {
    sessionStorage.removeItem("starmint_pending_star");
  } catch (_clearPendingErr) {}
  var start = document.getElementById("star-selectors-start");
  if (start) start.style.display = "block";
  var loading = document.getElementById("loading");
  if (loading) loading.style.display = "none";
}

/** If restore/pending-login left every step hidden, show the Find My Star landing again. */
function starmintEnsureFindAStarLandingVisible() {
  if (!starmintIsFindAStarPage()) return;
  if (starmintIsAnyStarFlowUiVisible()) return;
  console.warn("[starmint] No star flow UI visible on Find A Star — resetting to start");
  starmintResetFindAStarToStart();
}
window.starmintEnsureFindAStarLandingVisible = starmintEnsureFindAStarLandingVisible;


// Align with layout theme (header uses same session; avoids section vs layout mismatch).
// Always sync in-memory loggedInCustomer to storefront truth: if we only ever set `true`
// and never `false`, a stale flag skips OTP (createAccount) or mis-routes gift flows.
function starmintApplyLayoutCustomerToStarFlow() {
  try {
    var cid = starmintResolveStorefrontCustomerId();
    if (cid) {
      loggedInCustomer = true;
      loggedInCustomerID = cid;
      if (!window.__STARMINT_CUSTOMER || !window.__STARMINT_CUSTOMER.id) {
        try {
          var sbEmail = "";
          var sbFirst = "";
          var sbLast = "";
          var rawC = localStorage.getItem("supabase_contact");
          if (rawC) {
            var pc = JSON.parse(rawC);
            sbEmail = String(pc.email || pc.email_address || "").trim();
            sbFirst = String(pc.first_name || "").trim();
            sbLast = String(pc.last_name || "").trim();
          }
          window.__STARMINT_CUSTOMER = {
            id: String(cid),
            email: sbEmail,
            firstName: sbFirst,
            lastName: sbLast,
            name: String([sbFirst, sbLast].filter(Boolean).join(" ").trim() || sbFirst || "")
          };
        } catch (_hydrateErr) { }
      }
      var btn = document.getElementById("signup-claim-star");
      if (btn) btn.innerText = "Reserve Star";
      var hasAccountP = document.getElementById("has-account-p");
      if (hasAccountP) hasAccountP.style.display = "none";
      var accountInfoFormForm = document.getElementById("account-info-form-form");
      var accountInfoHeadline = document.getElementById("account-info-form-headline");
      var accountInfoPreheadline = document.getElementById("account-info-form-preheadline");
      if (accountInfoFormForm) accountInfoFormForm.style.display = "none";
      if (accountInfoHeadline) accountInfoHeadline.style.display = "none";
      if (accountInfoPreheadline) accountInfoPreheadline.style.display = "none";
    } else {
      loggedInCustomer = false;
      loggedInCustomerID = false;
      var btnGuest = document.getElementById("signup-claim-star");
      if (btnGuest) btnGuest.innerText = "Create Account";
      var giftCbGuest = document.getElementById("gift");
      if (
        giftCbGuest &&
        giftCbGuest.checked &&
        typeof starmintIsActiveGiftStep === "function" &&
        starmintIsActiveGiftStep()
      ) {
        var guestAccountForm = document.getElementById("account-info-form");
        if (guestAccountForm && guestAccountForm.style.display === "block") {
          var guestFormFields = document.getElementById("account-info-form-form");
          var guestHeadline = document.getElementById("account-info-form-headline");
          var guestPreheadline = document.getElementById("account-info-form-preheadline");
          if (guestFormFields) guestFormFields.style.display = "";
          if (guestHeadline) guestHeadline.style.display = "";
          if (guestPreheadline) guestPreheadline.style.display = "";
        }
      }
    }
  } catch (_e) { }
}
window.starmintApplyLayoutCustomerToStarFlow = starmintApplyLayoutCustomerToStarFlow;
starmintApplyLayoutCustomerToStarFlow();

window.addEventListener("starmint:auth:changed", function (_event) {
  starmintApplyLayoutCustomerToStarFlow();
});

// Prefill account fields from Supabase when tokens exist — but do NOT set loggedInCustomer from Supabase alone.
// Storefront session is starmintResolveStorefrontCustomerId() (Liquid customer, section JSON, accountId cookie, numeric shopify_customer_id in LS).
// Otherwise stale supabase_user makes the form submit skip OTP and call reserveStar with wrong IDs.
try {
  const supabaseUserRaw = localStorage.getItem("supabase_user") || localStorage.getItem("supabaseUser");
  const supabaseContactRaw = localStorage.getItem("supabase_contact");

  const supabaseUser = supabaseUserRaw ? JSON.parse(supabaseUserRaw) : null;
  const supabaseContact = supabaseContactRaw ? JSON.parse(supabaseContactRaw) : null;

  if (supabaseUser) {
    const signupBtn = document.getElementById("signup-claim-star");
    if (signupBtn) {
      signupBtn.innerText =
        window.__STARMINT_CUSTOMER && window.__STARMINT_CUSTOMER.id ? "Reserve Star" : "Create Account";
    }

    const firstNameEl = document.getElementById("firstName");
    const lastNameEl = document.getElementById("lastName");
    const emailEl = document.getElementById("email");
    const phoneEl = document.getElementById("phone");

    if (firstNameEl && supabaseContact?.first_name) firstNameEl.value = supabaseContact.first_name;
    if (lastNameEl && supabaseContact?.last_name) lastNameEl.value = supabaseContact.last_name;
    if (emailEl && supabaseContact?.email) emailEl.value = supabaseContact.email;
    if (phoneEl && supabaseContact?.phone) phoneEl.value = supabaseContact.phone;
  }
} catch (e) {
  console.error("Supabase session restore failed:", e);
}

let rampUpMultiple = 5; // this speeds up on loader for star background on the createAccount/reserveStar fetches

let certificateVersion = "1";

let checkedAndOK = false;


// Variable to keep track of the current animation frame ID
let currentAnimationFrameId = null;

function scrollToElement(element) {
  // If there's an ongoing scroll, cancel it
  if (currentAnimationFrameId) {
    cancelAnimationFrame(currentAnimationFrameId);
    currentAnimationFrameId = null;
  }

  const elementOffset = element.getBoundingClientRect().top + window.scrollY;
  const start = window.scrollY;
  const distance = elementOffset - start;
  const duration = 500; // Duration of the scroll animation in milliseconds
  let startTime = null;

  function scrollStep(timestamp) {
    if (!startTime) startTime = timestamp;
    const timeElapsed = timestamp - startTime;
    const progress = Math.min(timeElapsed / duration, 1);

    // Use an easing function for a smooth effect, here we use a simple linear easing
    // For more easing functions: https://easings.net/
    const easeProgress = progress; // Linear easing for simplicity

    window.scrollTo(0, start + distance * easeProgress);

    if (progress < 1) {
      currentAnimationFrameId = requestAnimationFrame(scrollStep);
    } else {
      currentAnimationFrameId = null; // Reset the animation frame ID when done
    }
  }

  currentAnimationFrameId = requestAnimationFrame(scrollStep);
}

// Example usage: scrollToElement(document.querySelector('#target-element'));


function populateDateOptions() {
  const monthInput = parseInt(document.getElementById("birthday-month").value);
  const dateSelect = document.getElementById("birthday-date");
  dateSelect.innerHTML = ""; // Clear existing options

  // Add the disabled "Day" option
  const dayOption = document.createElement("option");
  dayOption.value = ""; // You can set the value to an empty string or any other value you prefer
  dayOption.textContent = "Day";
  dayOption.disabled = true; // Make it disabled
  dayOption.selected = true;
  dateSelect.appendChild(dayOption);

  // Determine the maximum number of days for the selected month
  let maxDays = 31;
  if (monthInput === 4 || monthInput === 6 || monthInput === 9 || monthInput === 11) {
    maxDays = 30;
  } else if (monthInput === 2) {
    maxDays = 29; // February (considering leap years is not implemented)
  }

  // Generate date options dynamically
  for (let day = 1; day <= maxDays; day++) {
    const option = document.createElement("option");
    option.value = day;
    option.textContent = day;
    dateSelect.appendChild(option);
  }
}


function hmsToDegreesString(coord, type) {
  const raw = String(coord ?? '').trim();
  if (!raw) return '';

  const hasH = /h/i.test(raw);
  const hasD = /d/i.test(raw);

  // Helper: format decimal degrees -> D°M'S"
  const formatDeg = (deg) => {
    const sign = deg < 0 ? '-' : '';
    const abs = Math.abs(deg);
    const d = Math.floor(abs);
    const m = Math.floor((abs * 60) % 60);
    const s = ((abs * 3600) % 60).toFixed(2);
    return `${sign}${d}°${m}'${s}"`;
  };

  // If backend sends DECIMAL only (no h/d), handle it safely:
  if (!hasH && !hasD) {
    const n = parseFloat(raw);
    if (Number.isNaN(n)) {
      throw new Error("Invalid coordinate value.");
    }
    // RA values in your data look like decimal HOURS, so convert to degrees when type === 'ra'
    const deg = (type === 'ra') ? (n * 15) : n;
    return formatDeg(deg);
  }

  // If it IS sexagesimal, parse it
  const sign = raw.startsWith('-') ? -1 : 1;
  const cleaned = raw.replace(/[hmsd]/gi, ' ').trim().replace(/\s+/g, ' ');
  let [a, b, c] = cleaned.split(' ').map(v => parseFloat(v));

  if (!Number.isFinite(a)) a = 0;
  if (!Number.isFinite(b)) b = 0;
  if (!Number.isFinite(c)) c = 0;

  let deg;
  if (hasH) {
    deg = (a + b / 60 + c / 3600) * 15;
  } else {
    deg = sign * (Math.abs(a) + b / 60 + c / 3600);
  }

  return formatDeg(deg);
}




const API_HOST_STAR_SELECTORS_ALL = 'https://star.thestarmint.com/api/';
const SITE_HOST_STAR_SELECTORS_ALL = 'https://star.thestarmint.com';
function getSkyApiBase() {
  const configured = window.__STARMINT_STAR_SELECTORS__?.skyApiBase;
  if (configured) return String(configured).replace(/\/$/, "");
  return API_HOST_STAR_SELECTORS_ALL.replace(/\/$/, "") + "/sky";
}
function formatYmdDate(value) {
  if (value) return String(value).trim();
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
function formatObservationTime(value) {
  const raw = String(value || "").trim();
  if (!raw) return "21:00:00";
  if (/^\d{2}:\d{2}:\d{2}$/.test(raw)) return raw;
  if (/^\d{2}:\d{2}$/.test(raw)) return `${raw}:00`;
  return "21:00:00";
}
//const API_HOST_STAR_SELECTORS_ALL = 'https://e2a0-74-88-190-32.ngrok-free.app/api/';
let selectedStar = window.__STARMINT_STAR_SELECTORS__.selectedStar;
// Dynamically get the current page's URL
let url = window.location.href;
if (!url.includes("select-a-star")) {
  document.getElementsByClassName("circle-outer-container")[0].style.display = "none";
}

const starSelectorsStart = document.getElementsByClassName("star-selectors-start")[0];


function adjustClass() {
  if (window.location.href.includes("select-a-star")) {
    if (window.innerWidth >= 1500) {
      starSelectorsStart.classList.add("large-screen");
    } else {
      starSelectorsStart.classList.remove("large-screen");
    }
  }
}

window.addEventListener("resize", adjustClass);

// Initial call when the page loads
adjustClass();


let current_star = {
  identifier: '',
  ra: '',
  dec: '',
  chart: '',
  id: '',
  name: '',
  certificate: '',
  zodiac: '',
  constellation: '',
  premium: '',
  typ: '*'
}
let reserve_star = {};
let owned_star = {};
let personalizationStarSource = "reserve";
let pendingPersonalizeRequest = null;
let selectedGiftVariantId = "";
let selectedGiftProductSlug = "";
function cloneStarContext(starContext) { return { identifier: starContext?.identifier || "", ra: starContext?.ra || "", dec: starContext?.dec || "", chart: starContext?.chart || "", id: starContext?.id || "", name: starContext?.name || "", certificate: starContext?.certificate || "", zodiac: starContext?.zodiac || "", constellation: starContext?.constellation || "", premium: starContext?.premium || "", typ: starContext?.typ || "*" }; }
function getRegistrationVariantIdForStar(starContext) { return String(starContext?.premium || "") === "2" ? "46442322821422" : "46442303193390"; }
function getActivePersonalizationStar() { if (personalizationStarSource === "owned") { if (owned_star?.id) return cloneStarContext(owned_star); } else if (reserve_star?.id) { return cloneStarContext(reserve_star); } return cloneStarContext(current_star); }
function setCurrentStarFromContext(starContext) { const normalized = cloneStarContext(starContext); current_star = Object.assign({}, current_star, normalized); }
function updatePersonalizationSourceSummary() { const summaryEl = document.getElementById("personalize-source-summary"); const changeBtn = document.getElementById("change-personalize-source"); if (!summaryEl || !changeBtn) return; const activeStar = getActivePersonalizationStar(); if (!activeStar?.id) { summaryEl.style.display = "none"; changeBtn.style.display = "none"; return; } const sourceLabel = personalizationStarSource === "owned" ? "Owned Star" : "Reserve Star"; const starLabel = activeStar.name || activeStar.identifier || "Selected Star"; summaryEl.textContent = "Personalizing with: " + sourceLabel + " - " + starLabel; summaryEl.style.display = "block"; changeBtn.style.display = "inline-flex"; }

function generateAddToCartButtonSettings() {
  let buttons = document.querySelectorAll('.personalize-button-container a');
  const previewContext = getPreviewContext();

  buttons.forEach(button => {
    if (button.getAttribute("data-label") == 'pdp') return;

    const currentHREF = button.getAttribute('href');
    const existingSlug = (button.getAttribute("data-product-slug") || "").trim();
    let productSlug = existingSlug;

    if (!productSlug && currentHREF && !currentHREF.startsWith("#")) {
      const parsedURL = new URL(currentHREF, window.location.origin);
      const currentPath = parsedURL.pathname || "";
      if (currentPath.startsWith("/products/")) {
        productSlug = currentPath.replace(/^\/products\//, "").replace(/\/$/, "");
      }
    }

    // Keep this as a product-page personalization action.
    button.textContent = "Personalize";
    if (productSlug) {
      const targetUrl = new URL("/products/" + productSlug, window.location.origin);
      targetUrl.searchParams.set("starmint_flow", "strict");
      targetUrl.searchParams.set("variantId", String(button.getAttribute("data-variant-id") || ""));
      targetUrl.searchParams.set("quantity", String(quantity || 1));
      // Pass explicit star context so PDP can render instantly without relying only on localStorage.
      if (previewContext?.id) targetUrl.searchParams.set("starId", String(previewContext.id));
      if (previewContext?.name) targetUrl.searchParams.set("starName", String(previewContext.name));
      if (previewContext?.chart) targetUrl.searchParams.set("chart", String(previewContext.chart));
      if (previewContext?.certificate) targetUrl.searchParams.set("certificate", String(previewContext.certificate));
      button.setAttribute("href", targetUrl.pathname + targetUrl.search);
    }
    if (productSlug) {
      button.setAttribute("data-product-slug", productSlug);
    }
    button.classList.remove("js-personalize-gift");
  });
}

// Extract variantId using URLSearchParams
let params = new URLSearchParams(window.location.search);
let product_slug = params.get('product');
let variantId = params.get('variantId');
let quantity = params.get('quantity');



// document.getElementById("url-product-checkout").setAttribute("data-variant-id",variantId)


let productDetailsWrapper = document.getElementById('productDetailsWrapper');
let shopGiftsWrapper = document.getElementById('shopGiftsWrapper');
const previewContextStorageKey = "starmint_preview_context";

function savePreviewContext() {
  try {
    const activeStar = getActivePersonalizationStar();
    const payload = {
      id: activeStar?.id || "",
      name: activeStar?.name || "",
      chart: activeStar?.chart || "",
      certificate: activeStar?.certificate || ""
    };
    localStorage.setItem(previewContextStorageKey, JSON.stringify(payload));
  } catch (previewContextSaveError) {
    console.warn("Unable to save preview context:", previewContextSaveError);
  }
}

function getPreviewContext() {
  const activeStar = getActivePersonalizationStar();
  const live = {
    id: activeStar?.id || "",
    name: activeStar?.name || "",
    chart: activeStar?.chart || "",
    certificate: activeStar?.certificate || ""
  };

  if (live.id && live.chart && live.certificate) {
    return live;
  }

  try {
    const raw = localStorage.getItem(previewContextStorageKey);
    if (!raw) return live;
    const parsed = JSON.parse(raw);
    return {
      id: live.id || parsed?.id || "",
      name: live.name || parsed?.name || "",
      chart: live.chart || parsed?.chart || "",
      certificate: live.certificate || parsed?.certificate || ""
    };
  } catch (previewContextReadError) {
    console.warn("Unable to read preview context:", previewContextReadError);
    return live;
  }
}

function updateCertificateStarNameDisplay() {
  const certificateStarName = document.getElementById("certificate-star-name");
  if (!certificateStarName) return;
  const enteredName = (document.getElementById("starName")?.value || "").trim();
  const bestName = enteredName || current_star?.name || current_star?.identifier || "";
  if (!bestName) return;
  certificateStarName.textContent = "Star Name: " + bestName;
  certificateStarName.style.display = "block";
}

function getUrlFilename(value) {
  if (!value) return "";
  try {
    const parsed = new URL(value, window.location.origin);
    const parts = (parsed.pathname || "").split("/").filter(Boolean);
    return parts.length ? parts[parts.length - 1] : "";
  } catch (_urlParseError) {
    const plainParts = String(value).split("/").filter(Boolean);
    return plainParts.length ? plainParts[plainParts.length - 1] : String(value);
  }
}

function buildProductPreviewCandidates(previewContext, desiredVariantId, productSlug) {
  const normalizedHandle = String(productSlug || "").toLowerCase();
  const isCoasterProduct = normalizedHandle.includes("coaster");
  const previewWorksWithChartOnly =
    normalizedHandle.includes("mug") ||
    normalizedHandle.includes("hoodie") ||
    normalizedHandle.includes("cushion");
  const chartValue = previewContext?.chart || "";
  const certificateValue = previewContext?.certificate || "";
  const starNameValue = previewContext?.name || "";
  const chartFilename = getUrlFilename(chartValue);
  const certificateFilename = getUrlFilename(certificateValue);

  const rawCandidates = [
    { chart: chartValue, certificate: certificateValue },
    { chart: chartFilename, certificate: certificateFilename },
    { chart: '/charts/' + chartFilename, certificate: certificateFilename ? '/certificates/' + certificateFilename : "" }
  ];

  return rawCandidates.filter(candidate => {
    if (!candidate.chart) return false;
    if (isCoasterProduct || previewWorksWithChartOnly) return true;
    return !!candidate.certificate;
  }).map(candidate =>
    API_HOST_STAR_SELECTORS_ALL +
    'productPreview?productId=' + encodeURIComponent(desiredVariantId) +
    '&productHandle=' + encodeURIComponent(productSlug || '') +
    '&starId=' + encodeURIComponent(previewContext.id) +
    '&chart=' + encodeURIComponent(candidate.chart) +
    '&certificate=' + encodeURIComponent(candidate.certificate) +
    '&starName=' + encodeURIComponent(starNameValue)
  );
}

async function addItemsToCart(items) { if (!items?.length) return; const response = await fetch(window.Shopify.routes.root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: items }) }); if (!response.ok) throw new Error("Unable to add items to cart"); return await response.json(); }

function starmintMapAccountStarToMergedItem(star) {
  const starId = String(star?.Id || star?.id || "").trim();
  if (!starId) return null;
  return {
    source: "account",
    item: {
      properties: {
        starId: starId,
        starName: star?.Current_Common_Name_If_Any__c || star?.star_name || star?.name || "",
        starIdentifier: star?.SIMBAD_Star_Identifier__c || star?.star_identifier || "",
        starCoordsRA:
          star?.Right_Ascension_Degrees__c ||
          star?.Right_Ascension_Hours__c ||
          star?.right_ascension_degrees ||
          "",
        starCoordsDEC:
          star?.Declination_Degrees__c ||
          star?.Declination_Hours__c ||
          star?.declination_degrees ||
          "",
        chart: star?.chart || "",
        certificate: star?.certificate || "",
        premium: star?.premium || "",
      },
    },
  };
}

async function starmintFetchAccountStarsForPersonalize(customerId) {
  const id = String(customerId || "").trim();
  if (!id) return [];

  const apiCandidates = [
    API_HOST_STAR_SELECTORS_ALL + "supabase/getPersonalAndGiftedNFTs?shopify_customer_id=" + encodeURIComponent(id),
    API_HOST_STAR_SELECTORS_ALL + "supabase/getMyNFTs?shopify_customer_id=" + encodeURIComponent(id),
  ];

  try {
    const contactRaw = localStorage.getItem("supabase_contact");
    const contact = contactRaw ? JSON.parse(contactRaw) : null;
    const email = String(contact?.email || contact?.email_address || "").trim();
    if (email) {
      apiCandidates.unshift(
        API_HOST_STAR_SELECTORS_ALL + "supabase/getPersonalAndGiftedNFTs?email=" + encodeURIComponent(email),
        API_HOST_STAR_SELECTORS_ALL + "supabase/getMyNFTs?email=" + encodeURIComponent(email)
      );
    }
  } catch (_contactErr) {}

  for (let i = 0; i < apiCandidates.length; i++) {
    try {
      const starsRes = await fetch(apiCandidates[i], { method: "GET" });
      if (!starsRes.ok) continue;
      const starsJson = await starsRes.json();
      const apiStars = Array.isArray(starsJson?.all)
        ? starsJson.all
        : Array.isArray(starsJson?.data)
          ? starsJson.data
          : [];
      if (apiStars.length) return apiStars;
    } catch (_fetchErr) {}
  }

  return [];
}

async function starmintUpdateCartStarList() {
  const listContainer = document.getElementById("cart-star-list-container");
  const listInner = document.getElementById("cart-star-list");
  const fallbackReserveBtn = document.getElementById("source-reserve-star-button");
  if (!listContainer || !listInner) return;

  try {
    const cart = await fetchCartState();
    const registrationIds = [46442322821422, 46442303193390];
    const cartStarItems = (cart?.items || []).filter(item => registrationIds.includes(Number(item.variant_id)));
    const mergedItems = [];
    const seenStarIds = new Set();

    cartStarItems.forEach(item => {
      const starId = String(item?.properties?.starId || "").trim();
      if (starId) seenStarIds.add(starId);
      mergedItems.push({ source: "cart", item: item });
    });

    try {
      const contactRaw = localStorage.getItem("supabase_contact");
      const parsedContact = contactRaw ? JSON.parse(contactRaw) : null;
      const customerId = String(
        (window.__STARMINT_CUSTOMER && window.__STARMINT_CUSTOMER.id) ||
        parsedContact?.shopify_customer_id ||
        localStorage.getItem("shopify_customer_id") ||
        loggedInCustomerID ||
        ""
      ).trim();
      if (customerId) {
        const apiStars = await starmintFetchAccountStarsForPersonalize(customerId);
        for (const star of apiStars) {
          const starId = String(star?.Id || star?.id || "").trim();
          if (!starId || seenStarIds.has(starId)) continue;
          seenStarIds.add(starId);
          const mapped = starmintMapAccountStarToMergedItem(star);
          if (mapped) mergedItems.push(mapped);
        }
      }
    } catch (accountStarErr) {
      console.warn("Could not merge account reserved stars:", accountStarErr);
    }

    if (mergedItems.length === 0) {
      listContainer.style.display = "none";
      if (fallbackReserveBtn) fallbackReserveBtn.style.display = "inline-block";
      return;
    }

    // Hide the static reserve button if we have specific cart items to choose from
    if (fallbackReserveBtn) fallbackReserveBtn.style.display = "none";

    listInner.innerHTML = "";
    mergedItems.forEach(entry => {
      const item = entry.item || {};
      const props = item.properties || {};
      const starId = props.starId || "";
      const starName = props.starName || props.starIdentifier || "Unnamed Star";

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "button button--primary cart-star-item-btn";
      btn.innerHTML = `<span class="star-name">${starName}</span><span class="star-id">${props.starIdentifier || ""}</span>`;
      if (entry.source === "account") {
        btn.setAttribute("title", "Reserved star from your account");
      }

      btn.onclick = () => {
        const starContext = {
          id: starId,
          name: props.starName || "",
          identifier: props.starIdentifier || "",
          ra: props.starCoordsRA || "",
          dec: props.starCoordsDEC || "",
          chart: props.chart || "",
          certificate: props.certificate || ""
        };
        setCurrentStarFromContext(starContext);
        reserve_star = cloneStarContext(starContext);
        personalizationStarSource = "reserve";
        savePreviewContext();
        updatePersonalizationSourceSummary();

        if (pendingPersonalizeRequest?.productSlug && pendingPersonalizeRequest?.variantId) {
          renderProductDetails(pendingPersonalizeRequest.productSlug, pendingPersonalizeRequest.variantId);
        }
        closePersonalizationSourceModal();
      };
      listInner.appendChild(btn);
    });

    listContainer.style.display = "block";
  } catch (e) {
    console.warn("Failed to update cart star list:", e);
    listContainer.style.display = "none";
    if (fallbackReserveBtn) fallbackReserveBtn.style.display = "inline-block";
  }
}

async function openPersonalizationSourceModal(productSlugForPersonalize, variantIdForPersonalize) {
  const modal = document.getElementById("personalization-source-modal");
  if (!modal) return;
  pendingPersonalizeRequest = { productSlug: productSlugForPersonalize || "", variantId: String(variantIdForPersonalize || "") };

  // Update the cart list before showing the modal
  await starmintUpdateCartStarList();

  modal.style.display = "flex";
}
function closePersonalizationSourceModal() { const modal = document.getElementById("personalization-source-modal"); if (!modal) return; modal.style.display = "none"; }
async function fetchCartState() { const response = await fetch(window.Shopify.routes.root + "cart.js", { method: "GET" }); if (!response.ok) throw new Error("Unable to read cart"); return await response.json(); }

/** WeMint / Venly wallet from Supabase contact (used by order webhook minting). */
function starmintWalletAddressForCart() {
  try {
    const raw = localStorage.getItem("supabase_contact");
    if (!raw) return "";
    const c = JSON.parse(raw);
    const w = c && (c.wemint_wallet_address || c.WeMint_Wallet_Address__c || c.wallet_address);
    return w ? String(w).trim() : "";
  } catch (_e) {
    return "";
  }
}
function starmintSanitizeCartPropertyValue(value, maxLen) {
  const max = typeof maxLen === "number" && maxLen > 0 ? maxLen : 255;
  const str = value == null ? "" : String(value);
  if (str.length <= max) return str;
  if (/^https?:\/\//i.test(str)) {
    const parts = str.split("/").filter(Boolean);
    const tail = parts.length ? parts[parts.length - 1] : str;
    return tail.length <= max ? tail : tail.substring(0, max);
  }
  return str.substring(0, max);
}

function starmintSanitizeCartProperties(props) {
  const out = {};
  Object.keys(props || {}).forEach(function (key) {
    const val = props[key];
    if (val == null || val === "") return;
    out[key] = starmintSanitizeCartPropertyValue(val, 255);
  });
  return out;
}

function starmintApplyGiftCartProperties(props, data) {
  const out = Object.assign({}, props || {});
  const giftActive = is_gift || !!(document.getElementById("gift") && document.getElementById("gift").checked);
  if (!giftActive) return out;
  const recipient = starmintResolveGiftRecipient(data || {});
  if (recipient.email) {
    out._isGift = "true";
    out._recipientEmail = recipient.email;
    out._recipientName = recipient.name;
  }
  return out;
}

function starmintBuildCartProperties(starContext, extras, data) {
  const props = starmintApplyGiftCartProperties(
    {
      starName: starContext?.name || "",
      starIdentifier: starContext?.identifier || "",
      starId: String(starContext?.id || "").trim(),
      starCoordsRA: hmsToDegreesString(starContext?.ra || ""),
      starCoordsDEC: hmsToDegreesString(starContext?.dec || ""),
      chart: starContext?.chart || "",
      certificate: starContext?.certificate || "",
      ...(extras || {}),
    },
    data
  );
  return starmintWithWalletCartProperties(starmintSanitizeCartProperties(props));
}

function starmintWithWalletCartProperties(props) {
  const out = Object.assign({}, props || {});
  const w = starmintWalletAddressForCart();
  if (w) out.walletAddress = starmintSanitizeCartPropertyValue(w, 255);
  return out;
}

async function ensureRegistrationInCart(starContext) {
  const starId = String(starContext?.id || "").trim();
  if (!starId) return false;
  const registrationVariantId = Number(getRegistrationVariantIdForStar(starContext));
  const cart = await fetchCartState();
  const alreadyInCart = (cart?.items || []).some(
    (item) =>
      Number(item?.variant_id || 0) === registrationVariantId &&
      String(item?.properties?.starId || "").trim() === starId
  );
  if (alreadyInCart) return false;
  await addItemsToCart([
    {
      id: registrationVariantId,
      quantity: 1,
      properties: starmintBuildCartProperties(starContext, {
        starmintStarSource: "reserve",
      }),
    },
  ]);
  return true;
}
async function handleGiftCheckoutClick(event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }
  const targetVariantId = String(selectedGiftVariantId || "").trim();
  if (!targetVariantId) return;
  const activeStar = getActivePersonalizationStar();
  if (!activeStar?.id) {
    const errTarget = document.getElementById("remove-on-certificate");
    if (errTarget) {
      errTarget.innerText = "Please select a star source first, then personalize again.";
      errTarget.style.display = "block";
    }
    return;
  }
  try {
    await ensureRegistrationInCart(activeStar);
    await addItemsToCart([
      {
        id: Number(targetVariantId),
        quantity: 1,
        properties: starmintBuildCartProperties(activeStar, {
          starmintStarSource: personalizationStarSource,
        }),
      },
    ]);
    window.location.href = "/cart";
  } catch (checkoutError) {
    console.warn("Gift checkout failed:", checkoutError);
  }
}
async function handleCertificateOnlyCheckout(event) { if (event) { event.preventDefault(); event.stopPropagation(); } const reserveContext = reserve_star?.id ? cloneStarContext(reserve_star) : cloneStarContext(current_star); if (!reserveContext?.id) return; try { await ensureRegistrationInCart(reserveContext); window.location.href = "/cart"; } catch (certificateOnlyError) { console.warn("Certificate-only checkout failed:", certificateOnlyError); } }

let latestProductRenderToken = 0;

/** Keep personalization spinner until the browser finishes loading the new preview URL (or timeout). */
function waitForProductPreviewImage(imgEl, timeoutMs) {
  const ms = typeof timeoutMs === "number" && timeoutMs > 0 ? timeoutMs : 30000;
  return new Promise(function (resolve) {
    if (!imgEl) return resolve();
    var finished = false;
    function done() {
      if (finished) return;
      finished = true;
      clearTimeout(timer);
      imgEl.removeEventListener("load", onLoad);
      imgEl.removeEventListener("error", onError);
      resolve();
    }
    function onLoad() {
      done();
    }
    function onError() {
      done();
    }
    var timer = setTimeout(done, ms);
    imgEl.addEventListener("load", onLoad, { once: true });
    imgEl.addEventListener("error", onError, { once: true });
  });
}

async function renderProductDetails(productSlug, variantIdForProduct) {
  if (!productSlug) return;
  if (!productDetailsWrapper || !shopGiftsWrapper) return;
  const renderToken = ++latestProductRenderToken;

  const loaders = document.querySelectorAll('.personalization-loading-overlay');
  const showLoader = () => loaders.forEach(l => l.classList.add('is-active'));
  const hideLoader = () => loaders.forEach(l => l.classList.remove('is-active'));

  showLoader();

  selectedGiftProductSlug = productSlug;
  selectedGiftVariantId = String(variantIdForProduct || "");
  updatePersonalizationSourceSummary();

  productDetailsWrapper.style.display = 'block';
  shopGiftsWrapper.style.display = 'none';

  let apiUrl = window.Shopify.routes.root + 'products/' + productSlug + '.js';
  try {
    const response = await fetch(apiUrl);
    if (renderToken !== latestProductRenderToken) return;
    const product = await response.json();
    if (renderToken !== latestProductRenderToken) return;

    const productTitleEl = document.getElementById('productTitle');
    const productImageEl = document.getElementById('productImage');
    const removeOnCertificateEl = document.getElementById('remove-on-certificate');
    const productCheckoutEl = document.getElementById('product-checkout');
    const checkoutLinkEl = document.getElementById('url-product-checkout');
    if (!productImageEl) return;

    if (productTitleEl) {
      productTitleEl.innerText = product.title;
    }

    const desiredVariantId = String(variantIdForProduct || "");
    const matchingVariant = product.variants.find(variant => String(variant.id) === desiredVariantId);

    let fallbackImage = product.featured_image || "";
    if (matchingVariant && matchingVariant.featured_image && matchingVariant.featured_image.src) {
      fallbackImage = matchingVariant.featured_image.src;
    }

    productImageEl.src = fallbackImage;
    productImageEl.alt = product.title + ' Image';
    if (productCheckoutEl) {
      productCheckoutEl.style.display = "block";
    }
    if (checkoutLinkEl && desiredVariantId) {
      checkoutLinkEl.setAttribute("href", "/cart");
      checkoutLinkEl.setAttribute("data-variant-id", desiredVariantId);
    }

    if (removeOnCertificateEl) {
      removeOnCertificateEl.innerText = "";
      removeOnCertificateEl.style.display = "none";
    }

    // Render selected certificate design on product mockup when available.
    const previewContext = getPreviewContext();
    const normalizedProductSlug = String(productSlug || "").toLowerCase();
    const isCoasterProduct = normalizedProductSlug.includes("coaster");
    const isMugProductSlug = normalizedProductSlug.includes("mug");
    const previewInputsFromChartOnly =
      isMugProductSlug ||
      normalizedProductSlug.includes("hoodie") ||
      normalizedProductSlug.includes("cushion");
    const isFramedProduct =
      normalizedProductSlug.includes("frame") ||
      normalizedProductSlug.includes("framed") ||
      normalizedProductSlug.includes("mounted-print");
    const toSafePreviewImageUrl = (rawUrl) => {
      const value = String(rawUrl || "").trim();
      if (!value) return "";
      if (value.startsWith("data:image/")) return value;
      try {
        const parsed = new URL(value, window.location.origin);
        if (parsed.protocol !== "http:" && parsed.protocol !== "https:") return "";
        return parsed.toString();
      } catch (_err) {
        return "";
      }
    };
    const safeChartUrl = toSafePreviewImageUrl(previewContext?.chart || "");
    const safeCertificateUrl = toSafePreviewImageUrl(previewContext?.certificate || "");

    const canCallPreviewApi = !!previewContext.id && !!desiredVariantId && !!safeChartUrl;
    const hasAnyPreviewFallback = isCoasterProduct || previewInputsFromChartOnly
      ? !!safeChartUrl
      : !!safeCertificateUrl;
    const hasPreviewInputs = canCallPreviewApi || hasAnyPreviewFallback;

    if (hasPreviewInputs) {
      // Coaster preview is chart-first to avoid blank renders from intermittent
      // server-side composition responses.
      if (isCoasterProduct && safeChartUrl) {
        productImageEl.src = safeChartUrl;
        productImageEl.alt = product.title + ' Personalized Star Chart Preview';
        if (removeOnCertificateEl) {
          removeOnCertificateEl.innerText = "";
          removeOnCertificateEl.style.display = "none";
        }
        await waitForProductPreviewImage(productImageEl, 30000);
        hideLoader();
        setTimeout(() => {
          productDetailsWrapper.style.opacity = '1';
          productDetailsWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
        return;
      }

      // Framed previews are certificate-first to avoid blank server-side composites.
      if (isFramedProduct && safeCertificateUrl) {
        productImageEl.src = safeCertificateUrl;
        productImageEl.alt = product.title + ' Personalized Certificate Preview';
        if (removeOnCertificateEl) {
          removeOnCertificateEl.innerText = "";
          removeOnCertificateEl.style.display = "none";
        }
        await waitForProductPreviewImage(productImageEl, 30000);
        hideLoader();
        setTimeout(() => {
          productDetailsWrapper.style.opacity = '1';
          productDetailsWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
        return;
      }

      let appliedPreview = false;
      if (canCallPreviewApi) {
        const previewCandidates = buildProductPreviewCandidates(previewContext, desiredVariantId, productSlug);
        for (const previewUrl of previewCandidates) {
          try {
            const previewResponse = await fetch(previewUrl, { method: "GET" });
            if (renderToken !== latestProductRenderToken) return;
            if (!previewResponse.ok) {
              console.warn('Preview request failed:', previewResponse.status, previewUrl);
              continue;
            }
            const previewData = await previewResponse.json();
            if (renderToken !== latestProductRenderToken) return;
            const previewImage = toSafePreviewImageUrl(
              isMugProductSlug
                ? previewData?.mugFrontPreviewUrl ||
                previewData?.mugFrontPreview ||
                previewData?.imageURL ||
                previewData?.imageUrl ||
                ""
                : previewData?.imageURL || previewData?.imageUrl || ""
            );
            if (previewImage) {
              if (isMugProductSlug) {
                const low = previewImage.toLowerCase();
                if (low.includes("/charts/") || low.includes("/certificates/")) {
                  continue;
                }
              }
              productImageEl.src = previewImage;
              await waitForProductPreviewImage(productImageEl, 30000);
              appliedPreview = true;
              break;
            }
          } catch (previewError) {
            console.warn('Preview request error:', previewError);
          }
        }
      }

      if (renderToken !== latestProductRenderToken) return;

      if (appliedPreview) {
        if (removeOnCertificateEl) {
          removeOnCertificateEl.style.display = "none";
        }
      } else if (removeOnCertificateEl) {
        // Hard fallback when productPreview endpoint is unstable:
        // show the generated certificate design so users still see their personalized output.
        const chartFallback = safeChartUrl;
        const certificateFallback = safeCertificateUrl;
        if (isCoasterProduct && chartFallback) {
          productImageEl.src = chartFallback;
          productImageEl.alt = product.title + ' Personalized Star Chart Preview';
          await waitForProductPreviewImage(productImageEl, 30000);
        } else if ((isFramedProduct || !isCoasterProduct) && certificateFallback) {
          productImageEl.src = certificateFallback;
          productImageEl.alt = product.title + ' Personalized Certificate Preview';
          await waitForProductPreviewImage(productImageEl, 30000);
        }
        removeOnCertificateEl.innerText = "";
        removeOnCertificateEl.style.display = "none";
      }
      hideLoader();
    } else if (removeOnCertificateEl) {
      removeOnCertificateEl.innerText = "Create your certificate first, then click View Options.";
      removeOnCertificateEl.style.display = "block";
    }

    // Fade in and scroll to the preview section
    setTimeout(() => {
      productDetailsWrapper.style.opacity = '1';
      productDetailsWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  } catch (error) {
    console.error('Error fetching the product:', error);
  } finally {
    if (renderToken === latestProductRenderToken) hideLoader();
  }
}

// Called by my-stars modal when user picks a star on select-a-star flow.
window.starmintHandleModalStarSelection = function (payload) {
  try {
    if (!payload) return;
    const starNameInput = document.getElementById("starName");
    const enteredStarName = (starNameInput?.value || "").trim();
    const activeSource = pendingPersonalizeRequest?.source || personalizationStarSource;
    current_star.id = payload.starId || current_star.id;
    // When user picks from my-stars modal, always use the selected star label.
    const selectedModalStarName = (payload.starName || payload.starIdentifier || "").trim();
    current_star.name = selectedModalStarName || enteredStarName || current_star.name || "";
    current_star.identifier = payload.starIdentifier || current_star.identifier;
    current_star.ra = payload.starCoordsRA || current_star.ra;
    current_star.dec = payload.starCoordsDEC || current_star.dec;
    current_star.chart = payload.chartUrl || current_star.chart;
    current_star.certificate = payload.certificateUrl || current_star.certificate;
    if (starNameInput && current_star.name) {
      starNameInput.value = current_star.name;
    }
    if (activeSource === "owned") {
      owned_star = cloneStarContext(current_star);
    } else if (activeSource === "reserve") {
      reserve_star = cloneStarContext(current_star);
    }
    savePreviewContext();
    updateCertificateStarNameDisplay();
    updatePersonalizationSourceSummary();

    const targetProduct = pendingPersonalizeRequest?.productSlug || payload.productSlug || product_slug;
    const targetVariantId = pendingPersonalizeRequest?.variantId || payload.variantId || variantId;
    pendingPersonalizeRequest = null;
    if (targetProduct && targetVariantId) {
      renderProductDetails(targetProduct, targetVariantId);
    }
  } catch (e) {
    console.warn("Unable to apply modal star selection:", e);
  }
};

let variantGiftId;
if (product_slug) {
  renderProductDetails(product_slug, variantId);
} else {
  productDetailsWrapper.style.display = 'none';
  shopGiftsWrapper.style.display = 'none';
  generateAddToCartButtonSettings();
  const firstGiftButton = document.querySelector('.custom-add-to-cart');
  variantGiftId = firstGiftButton ? firstGiftButton.getAttribute('data-variant-id') : null;
}

const checkoutLinkEl = document.getElementById("url-product-checkout");
if (checkoutLinkEl) {
  checkoutLinkEl.addEventListener("click", handleGiftCheckoutClick);
}
const changeSourceBtn = document.getElementById("change-personalize-source");
if (changeSourceBtn) {
  changeSourceBtn.addEventListener("click", function (event) {
    event.preventDefault();
    const fallbackProduct = selectedGiftProductSlug || product_slug || "";
    const fallbackVariant = selectedGiftVariantId || variantId || "";
    openPersonalizationSourceModal(fallbackProduct, fallbackVariant);
  });
}
const sourceReserveBtn = document.getElementById("source-reserve-star-button");
if (sourceReserveBtn) {
  sourceReserveBtn.addEventListener("click", function (event) {
    event.preventDefault();
    personalizationStarSource = "reserve";
    pendingPersonalizeRequest = Object.assign({}, pendingPersonalizeRequest, { source: "reserve" });
    closePersonalizationSourceModal();
    const reserveContext = reserve_star?.id ? cloneStarContext(reserve_star) : cloneStarContext(current_star);
    if (!reserveContext?.id) {
      const reminderEl = document.getElementById("remove-on-certificate");
      if (reminderEl) {
        reminderEl.innerText = "Reserve a star first, then personalize this gift.";
        reminderEl.style.display = "block";
      }
      return;
    }
    setCurrentStarFromContext(reserveContext);
    savePreviewContext();
    updatePersonalizationSourceSummary();
    const targetProduct = pendingPersonalizeRequest?.productSlug || "";
    const targetVariant = pendingPersonalizeRequest?.variantId || "";
    if (targetProduct && targetVariant) {
      renderProductDetails(targetProduct, targetVariant);
      pendingPersonalizeRequest = null;
    }
  });
}
const sourceOwnedBtn = document.getElementById("source-owned-star-button");
if (sourceOwnedBtn) {
  sourceOwnedBtn.addEventListener("click", function (event) {
    event.preventDefault();
    personalizationStarSource = "owned";
    pendingPersonalizeRequest = Object.assign({}, pendingPersonalizeRequest, { source: "owned" });
    updatePersonalizationSourceSummary();
    const targetProduct = pendingPersonalizeRequest?.productSlug || "";
    const targetVariant = pendingPersonalizeRequest?.variantId || "";
    if (owned_star?.id) {
      closePersonalizationSourceModal();
      setCurrentStarFromContext(owned_star);
      savePreviewContext();
      if (targetProduct && targetVariant) {
        setTimeout(function () {
          renderProductDetails(targetProduct, targetVariant);
        }, 0);
        pendingPersonalizeRequest = null;
      }
      return;
    }
    if (typeof window.showModal === "function") {
      closePersonalizationSourceModal();
      window.showModal(event, targetVariant || variantId || "", targetProduct || product_slug || "", 1);
      return;
    }
    if (targetProduct && targetVariant) {
      closePersonalizationSourceModal();
      renderProductDetails(targetProduct, targetVariant);
      pendingPersonalizeRequest = null;
    }
  });
}
const sourceCancelBtn = document.getElementById("source-modal-cancel-button");
if (sourceCancelBtn) {
  sourceCancelBtn.addEventListener("click", function (event) {
    event.preventDefault();
    pendingPersonalizeRequest = null;
    closePersonalizationSourceModal();
  });
}
const sourceNewStarBtn = document.getElementById("source-new-star-button");
if (sourceNewStarBtn) {
  sourceNewStarBtn.addEventListener("click", function (event) {
    event.preventDefault();
    try {
      starmintClearStarFlowState();
    } catch (_e) {}
    window.location.href = "/pages/select-a-star?starmint_fresh=1";
  });
}
const sourceDoneBtn = document.getElementById("source-done-button");
if (sourceDoneBtn) {
  sourceDoneBtn.addEventListener("click", function (event) {
    event.preventDefault();
    const activeStar = getActivePersonalizationStar();
    const targetProduct = pendingPersonalizeRequest?.productSlug || selectedGiftProductSlug || "";
    const targetVariant = pendingPersonalizeRequest?.variantId || selectedGiftVariantId || "";
    closePersonalizationSourceModal();
    if (activeStar?.id && targetProduct && targetVariant) {
      renderProductDetails(targetProduct, targetVariant);
      pendingPersonalizeRequest = null;
    }
  });
}

// Convert products array to JSON

let productsArr = window.__STARMINT_STAR_SELECTORS__.productsArr || [];
// let products = JSON.parse(productsJSON);

let constellationsListFound = false;
let byIdentifiersListFound = false;

let today = new Date();
let dd = String(today.getDate()).padStart(2, '0');
let mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0
let yyyy = today.getFullYear();

let formattedToday = yyyy + '-' + mm + '-' + dd;
let is_gift = false;
let rfirstName = "";
let rlastName = "";
let remail = "";
let rphone = "";
let showDate = false;
let showMessage = false;

function starmintReadRecipientFieldsFromDom() {
  return {
    firstName: (document.getElementById("recFirstName")?.value || "").trim(),
    lastName: (document.getElementById("recLastName")?.value || "").trim(),
    email: (document.getElementById("recEmail")?.value || "").trim(),
    phone: (document.getElementById("recPhone")?.value || "").trim(),
  };
}

function starmintSyncRecipientGlobals(fields) {
  if (!fields) return;
  rfirstName = fields.firstName || "";
  rlastName = fields.lastName || "";
  remail = fields.email || "";
  rphone = fields.phone || "";
}

function starmintNormalizeStarIdentifier(value) {
  return String(value || "")
    .replace(/^\*\s*/, "")
    .replace(/[^\w\s-]/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
}

async function starmintTryRecoverOwnedStar(starIdentifier) {
  const shopifyCustomerId =
    (typeof starmintResolveStorefrontCustomerId === "function" && starmintResolveStorefrontCustomerId()) ||
    loggedInCustomerID ||
    (window.__STARMINT_CUSTOMER && window.__STARMINT_CUSTOMER.id) ||
    null;
  if (!shopifyCustomerId || !starIdentifier) return null;

  const key = starmintNormalizeStarIdentifier(starIdentifier);
  const apiBase =
    (typeof API_HOST_STAR_SELECTORS_ALL !== "undefined" && API_HOST_STAR_SELECTORS_ALL) ||
    "https://star.thestarmint.com/api/";

  try {
    const resp = await window.starmintFetchWithRetry(
      `${apiBase}supabase/getMyNFTs?shopify_customer_id=${encodeURIComponent(String(shopifyCustomerId))}`,
      { method: "GET", headers: {} }
    );
    if (!resp || !resp.ok) return null;
    const json = await resp.json();
    const rows = Array.isArray(json.data) ? json.data : [];
    const owned = rows.find(
      (row) => starmintNormalizeStarIdentifier(row?.star_identifier) === key
    );
    if (owned) {
      console.log("[starmint] Star already owned by you — continuing flow:", owned.id, key);
      return owned;
    }
  } catch (_recoverErr) {
    console.warn("[starmint] Could not recover owned star:", _recoverErr);
  }
  return null;
}

function starmintIsGiftFlowActive() {
  if (typeof is_gift !== "undefined" && is_gift) return true;
  const giftCb = document.getElementById("gift");
  if (giftCb && giftCb.checked) return true;
  try {
    const rawState = sessionStorage.getItem("starmint_star_flow_state");
    if (rawState) {
      const state = JSON.parse(rawState);
      if (state.is_gift || state.giftCheckboxChecked) return true;
    }
    const rawRecipient = sessionStorage.getItem("starmint_gift_recipient");
    if (rawRecipient) {
      const recipient = JSON.parse(rawRecipient);
      if (recipient && recipient.email) return true;
    }
  } catch (_e) { }
  const pending = window._starReservationPendingData;
  if (pending && (pending.is_gift || pending.recipientInfo?.email)) return true;
  return false;
}

function starmintPersistGiftRecipientInfo(fields) {
  const recipientFields = fields || starmintReadRecipientFieldsFromDom();
  starmintSyncRecipientGlobals(recipientFields);
  is_gift = true;
  const giftCb = document.getElementById("gift");
  if (giftCb) giftCb.checked = true;

  const payload = {
    firstName: String(recipientFields.firstName || "").trim(),
    lastName: String(recipientFields.lastName || "").trim(),
    name: [recipientFields.firstName, recipientFields.lastName].filter(Boolean).join(" ").trim(),
    email: String(recipientFields.email || "").trim().toLowerCase(),
    phone: String(recipientFields.phone || "").trim(),
    timestamp: Date.now(),
  };

  try {
    sessionStorage.setItem("starmint_gift_recipient", JSON.stringify(payload));
  } catch (_e) { }

  if (!window._starReservationPendingData) {
    window._starReservationPendingData = {};
  }
  window._starReservationPendingData.is_gift = true;
  window._starReservationPendingData.recipientInfo = payload;

  console.log("[starmint] Gift recipient persisted:", payload.email || "(missing email)");
  return payload;
}

function starmintClearGiftRecipientInfo() {
  try {
    sessionStorage.removeItem("starmint_gift_recipient");
  } catch (_e) { }
  rfirstName = "";
  rlastName = "";
  remail = "";
  rphone = "";
  if (window._starReservationPendingData) {
    window._starReservationPendingData.is_gift = false;
    window._starReservationPendingData.recipientInfo = null;
  }
}

function starmintReadPersistedGiftRecipient() {
  try {
    const raw = sessionStorage.getItem("starmint_gift_recipient");
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return parsed;
  } catch (_e) {
    return null;
  }
}

function starmintResolveGiftRecipient(data) {
  const dom = starmintReadRecipientFieldsFromDom();
  const pending = window._starReservationPendingData || {};
  const persisted = starmintReadPersistedGiftRecipient();
  const fromData = data?.data?.recipientInfo || data?.recipientInfo || pending?.recipientInfo || persisted || null;
  const accounts = data?.accountsData || pending?.accountsData || null;

  const firstName =
    fromData?.firstName ||
    (fromData?.name ? String(fromData.name).trim().split(/\s+/)[0] : "") ||
    accounts?.rfirstName ||
    rfirstName ||
    dom.firstName;
  const lastName =
    fromData?.lastName ||
    (fromData?.name
      ? String(fromData.name).trim().split(/\s+/).slice(1).join(" ")
      : "") ||
    accounts?.rlastName ||
    rlastName ||
    dom.lastName;
  const email = fromData?.email || accounts?.remail || remail || dom.email;
  const phone = fromData?.phone || accounts?.rphone || rphone || dom.phone;

  return {
    firstName: String(firstName || "").trim(),
    lastName: String(lastName || "").trim(),
    name: [firstName, lastName].filter(Boolean).join(" ").trim(),
    email: String(email || "").trim().toLowerCase(),
    phone: String(phone || "").trim(),
  };
}

function starmintBuildGiftReservePayload(userInfo, flatAccountData) {
  const recipient = starmintResolveGiftRecipient(flatAccountData || { data: { userInfo } });
  const payload = {
    ...(flatAccountData || {}),
    data: {
      userInfo: {
        ...(userInfo || {}),
        ...(flatAccountData?.data?.userInfo || {}),
      },
      recipientInfo: {
        firstName: recipient.firstName,
        lastName: recipient.lastName,
        name: recipient.name,
        email: recipient.email,
        phone: recipient.phone || null,
        shopifyAccountID: null,
        accountID: null,
        contactID: null,
      },
    },
  };

  if (flatAccountData?.contact) payload.contact = flatAccountData.contact;
  if (flatAccountData?.auth_user_id) payload.auth_user_id = flatAccountData.auth_user_id;

  if (payload.contact?.email && !payload.data.userInfo.email) {
    payload.data.userInfo.email = payload.contact.email;
  }
  if (payload.contact?.id && !payload.data.userInfo.contactID) {
    payload.data.userInfo.contactID = payload.contact.id;
  }
  if (payload.auth_user_id && !payload.data.userInfo.accountID) {
    payload.data.userInfo.accountID = payload.auth_user_id;
  }

  return payload;
}

function starmintShowGifterAccountFormAfterRecipient() {
  starmintPersistGiftRecipientInfo(starmintReadRecipientFieldsFromDom());

  const recipientInfoForm = document.getElementById("recipient-info-form");
  const accountInfoForm = document.getElementById("account-info-form");
  const starInfoForm = document.getElementById("star-info-form");
  const starAccountInfoForm = document.getElementById("star-account-info-form");
  const confirmResults = document.getElementById("star-select-confirm-results");

  if (confirmResults) confirmResults.style.display = "block";
  if (starAccountInfoForm) starAccountInfoForm.style.display = "block";
  if (recipientInfoForm) recipientInfoForm.style.display = "none";
  if (document.getElementById("star-form-continue-01-container")) {
    document.getElementById("star-form-continue-01-container").style.display = "none";
  }
  if (document.getElementById("star-form-continue-1-container")) {
    document.getElementById("star-form-continue-1-container").style.display = "none";
  }
  if (document.getElementById("star-form-continue-0-container")) {
    document.getElementById("star-form-continue-0-container").style.display = "none";
  }
  if (starInfoForm) starInfoForm.style.display = "none";

  if (accountInfoForm) accountInfoForm.style.display = "block";

  const formForm = document.getElementById("account-info-form-form");
  const headline = document.getElementById("account-info-form-headline");
  const preheadline = document.getElementById("account-info-form-preheadline");
  const hasAccountP = document.getElementById("has-account-p");
  if (formForm) formForm.style.display = "";
  if (headline) headline.style.display = "";
  if (preheadline) preheadline.style.display = "";
  if (hasAccountP) hasAccountP.style.display = "";

  const backBtn = document.getElementById("back-button-to-recipient");
  if (backBtn) backBtn.style.display = "inline-block";

  const legalCheckbox = document.getElementById("legal-checkbox");
  if (legalCheckbox) legalCheckbox.style.visibility = "visible";
  const claimHl = document.getElementById("claim-star-headline");
  const claimPara = document.getElementById("claim-star-paragraph");
  if (claimHl) claimHl.style.visibility = "visible";
  if (claimPara) claimPara.style.visibility = "visible";

  const signupBtn = document.getElementById("signup-claim-star");
  const agreeCb = document.getElementById("agree-checkbox");
  if (signupBtn) {
    signupBtn.style.display = "inline-block";
    signupBtn.innerText = loggedInCustomer ? "Reserve Star" : "Create Account";
    signupBtn.disabled = !(agreeCb && agreeCb.checked);
  }

  if (accountInfoForm && typeof scrollToElement === "function") {
    scrollToElement(accountInfoForm);
  }

  try {
    starmintSaveStarFlowState();
  } catch (_e) { }
}

function starmintRunLoggedInGiftReservation(btnEl, userInfoExtras) {
  starmintSyncRecipientGlobals(starmintReadRecipientFieldsFromDom());
  const giftRecipient = starmintResolveGiftRecipient({});
  if (!giftRecipient.email) {
    const errEl = document.getElementById("err-message-account");
    if (errEl) {
      errEl.innerHTML = "Recipient email is missing. Please go back and enter recipient details.";
    }
    return false;
  }

  const starNameVal = (document.getElementById("starName")?.value || "").trim();
  const namingDateVal = (document.getElementById("namingDate")?.value || "").trim();
  const personalMessageVal = (document.getElementById("personalMessage")?.value || "").trim();

  const reservePayload = starmintBuildGiftReservePayload({
    shopifyAccountID: loggedInCustomerID,
    accountID: userInfoExtras?.accountID || null,
    contactID: userInfoExtras?.contactID || null,
    email: userInfoExtras?.email || (window.__STARMINT_CUSTOMER && window.__STARMINT_CUSTOMER.email) || "",
    full_name: userInfoExtras?.full_name || "",
    ...(userInfoExtras || {}),
  });

  const selectorsStart = document.getElementById("star-selectors-start");
  if (selectorsStart) selectorsStart.style.display = "none";
  document.querySelectorAll(".star-selection-data-results").forEach(function (elem) {
    elem.style.display = "none";
  });

  const loadingEl = document.getElementById("loading");
  if (loadingEl) {
    const loadingText = loadingEl.querySelector("p");
    if (loadingText) loadingText.innerHTML = "Reserving Your Star...";
    loadingEl.style.display = "block";
  }

  if (btnEl) {
    btnEl.disabled = true;
    btnEl.textContent = "Reserving...";
  }

  reserveStar(starNameVal, namingDateVal, personalMessageVal, true, reservePayload);
  return true;
}

function starmintIsActiveGiftStep() {
  if (!starmintIsGiftFlowActive()) return false;
  const stepIds = ["recipient-info-form", "account-info-form", "reservation-verify-step", "star-info-form"];
  return stepIds.some(function (id) {
    return starmintIsElementVisible(id);
  });
}

function starmintIsElementVisible(id) {
  const el = document.getElementById(id);
  if (!el) return false;
  if (el.style.display === "block") return true;
  try {
    return window.getComputedStyle(el).display !== "none";
  } catch (_e) {
    return false;
  }
}

function starmintDetectActiveStarFlowStepId() {
  const stepIds = [
    "reservation-verify-step",
    "account-info-form",
    "recipient-info-form",
    "star-info-form",
    "star-select-confirm-results",
    "star-select-zodiac-results",
    "star-select-constellation-results",
    "star-select-byNightsky-results",
    "star-select-random-results",
    "star-select-byIdentifier-results",
    "star-select-zodiacs-list",
  ];
  for (let i = 0; i < stepIds.length; i++) {
    if (starmintIsElementVisible(stepIds[i])) return stepIds[i];
  }
  return "star-selectors-start";
}

function starmintRestoreGiftStepUi(activeStepId) {
  if (!is_gift) return;

  const giftCheckbox = document.getElementById("gift");
  if (giftCheckbox) giftCheckbox.checked = true;

  if (activeStepId === "recipient-info-form") {
    if (document.getElementById("recipient-info-form")) {
      document.getElementById("recipient-info-form").style.display = "block";
    }
    if (document.getElementById("star-form-continue-01-container")) {
      document.getElementById("star-form-continue-01-container").style.display = "block";
    }
    if (document.getElementById("account-info-form")) {
      document.getElementById("account-info-form").style.display = "none";
    }
    if (document.getElementById("star-info-form")) {
      document.getElementById("star-info-form").style.display = "none";
    }
  } else if (activeStepId === "account-info-form") {
    starmintShowGifterAccountFormAfterRecipient();
  } else if (activeStepId === "star-info-form" && is_gift) {
    if (document.getElementById("star-info-form")) {
      document.getElementById("star-info-form").style.display = "block";
    }
    if (document.getElementById("recipient-info-form")) {
      document.getElementById("recipient-info-form").style.display = "none";
    }
    if (document.getElementById("account-info-form")) {
      document.getElementById("account-info-form").style.display = "none";
    }
    if (document.getElementById("star-form-continue-0-container")) {
      starmintSetStepDisplay(document.getElementById("star-form-continue-0-container"), "block");
    }
  }
}


let certificatesMade = new Set()// used for toggleVersion, store made certificates images url;
let certificateCache = {};
const certificateInFlightByKey = {};
let certificateAutoGenerateTimer = null;
let versionNow = "1";
let certificate;
let certificateRequestSeq = 0;
let certificatePreviewResolveSeq = 0;

/* let _sendNotificationsToRecipient = 0;

const sendWelcomeEmailCheckbox = document.getElementById("sendWelcomeEmail");

sendWelcomeEmailCheckbox.addEventListener("change", function() {
if (sendWelcomeEmailCheckbox.checked) {
    _sendNotificationsToRecipient = 1;
} else {
    _sendNotificationsToRecipient = 0;
}
console.log(_sendNotificationsToRecipient,"_sendNotificationsToRecipient")
}); 
*/




function setCertificatePreviewSource(primaryUrl, fallbackUrl, tertiaryUrl, options) {
  const previewImg = document.getElementById("certificate-preview-image") || document.querySelector("#certificate-container img");
  if (!previewImg) return;
  const previewLoadingEl = document.getElementById("certificate-preview-loading");

  const hidePreviewLoading = function () {
    if (previewLoadingEl) previewLoadingEl.style.display = "none";
    previewImg.classList.add("loaded");
  };
  const hidePreviewLoadingAndClearBlur = function () {
    hidePreviewLoading();
    previewImg.style.filter = "";
  };

  if (previewLoadingEl) {
    previewLoadingEl.style.display = "flex";
    // Reset progress bar animation
    const progressBar = previewLoadingEl.querySelector("#cert-progress-bar");
    if (progressBar) {
      progressBar.style.animation = "none";
      void progressBar.offsetWidth; // trigger reflow
      progressBar.style.animation = null;
    }
  }

  // We only remove the 'loaded' class if we are actually changing to a new image 
  // and not keeping the current one while loading.
  if (!options?.keepCurrentWhileLoading) {
    previewImg.classList.remove("loaded");
  }

  previewImg.onload = hidePreviewLoading;
  previewImg.onerror = hidePreviewLoading;

  const forceRefresh = !!options?.forceRefresh;
  const keepCurrentWhileLoading = !!options?.keepCurrentWhileLoading;
  const retryCount = Number(options?.retryCount || 0);
  const maxRetries = Number(options?.maxRetries || 2);
  const perUrlTimeoutMs = Number(options?.perUrlTimeoutMs || 6000);
  const urls = [primaryUrl, fallbackUrl, tertiaryUrl].filter(Boolean);

  if (!urls.length) {
    hidePreviewLoading();
    return;
  }

  const transparentPlaceholder = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
  // Use the selected style template as a blurred background while generating.
  const stylePlaceholder = sampleCertificates?.[String(versionNow || "1")] || transparentPlaceholder;
  const loadingPlaceholder = stylePlaceholder;

  const toSafeImageUrl = (rawUrl) => {
    const value = String(rawUrl || "").trim();
    if (!value) return "";
    if (value.startsWith("data:image/")) return value;
    try {
      const parsed = new URL(value, window.location.origin);
      // Block unsupported/custom schemes (e.g. web-pixel://) that break <img> loading.
      if (parsed.protocol !== "http:" && parsed.protocol !== "https:") return "";
      return parsed.toString();
    } catch (_err) {
      return "";
    }
  };

  const normalizedUrls = Array.from(new Set(urls))
    .map((rawUrl) => toSafeImageUrl(rawUrl))
    .filter(Boolean)
    .map((safeUrl) => {
      if (!forceRefresh) return safeUrl;
      if (safeUrl.startsWith("data:image/")) return safeUrl;
      return safeUrl + (safeUrl.includes("?") ? "&" : "?") + "ts=" + Date.now();
    });

  const directCertificateLoad = !!options?.directCertificateLoad;
  if (directCertificateLoad && normalizedUrls.length) {
    const activeSeqDirect = ++certificatePreviewResolveSeq;
    const bust = (safeUrl) => {
      if (!safeUrl || safeUrl.startsWith("data:image/")) return safeUrl;
      return safeUrl + (safeUrl.includes("?") ? "&" : "?") + "ts=" + Date.now();
    };
    previewImg.onload = function () {
      if (activeSeqDirect !== certificatePreviewResolveSeq) return;
      hidePreviewLoadingAndClearBlur();
    };
    let fallbackTried = false;
    previewImg.onerror = function () {
      if (activeSeqDirect !== certificatePreviewResolveSeq) return;
      if (!fallbackTried && normalizedUrls.length > 1) {
        fallbackTried = true;
        previewImg.src = bust(normalizedUrls[1]);
      } else {
        hidePreviewLoading();
      }
    };
    previewImg.src = bust(normalizedUrls[0]);
    if (previewImg.complete && previewImg.naturalWidth > 0) {
      hidePreviewLoadingAndClearBlur();
    }
    return;
  }

  const activeSeq = ++certificatePreviewResolveSeq;
  const currentSrc = String(previewImg.getAttribute("src") || "");
  const currentIsLoader = /loader-star\.svg|base64/i.test(currentSrc);

  // If version changed, we must show the new placeholder regardless of keepCurrentWhileLoading
  const versionChanged = window.__lastVersionRequested !== versionNow;
  window.__lastVersionRequested = versionNow;

  const effectiveKeepCurrentWhileLoading = keepCurrentWhileLoading && !currentIsLoader && !versionChanged;

  if (!effectiveKeepCurrentWhileLoading) {
    previewImg.src = loadingPlaceholder;
  }

  const loadImageWithTimeout = (targetUrl) => new Promise((resolve) => {
    const probe = new Image();
    let settled = false;

    const finish = (loadedUrl) => {
      if (settled) return;
      settled = true;
      if (timer) window.clearTimeout(timer);
      probe.onload = null;
      probe.onerror = null;
      resolve(loadedUrl);
    };

    const timer = window.setTimeout(() => finish(null), perUrlTimeoutMs);
    probe.onload = () => finish(targetUrl);
    probe.onerror = () => finish(null);
    probe.src = targetUrl;
  });

  (async () => {
    for (const targetUrl of normalizedUrls) {
      const loadedUrl = await loadImageWithTimeout(targetUrl);
      if (!loadedUrl) continue;
      if (activeSeq !== certificatePreviewResolveSeq) return;
      if (previewImg.src === loadedUrl || previewImg.src === new URL(loadedUrl, window.location.href).href) {
        hidePreviewLoadingAndClearBlur();
      } else {
        previewImg.src = loadedUrl;
        if (previewImg.complete) {
          hidePreviewLoadingAndClearBlur();
        }
      }
      // The onload handler attached above will trigger when src finishes painting (if it changed).
      return;
    }

    if (activeSeq !== certificatePreviewResolveSeq) return;
    if (retryCount < maxRetries && primaryUrl) {
      window.setTimeout(function () {
        setCertificatePreviewSource(primaryUrl, fallbackUrl, tertiaryUrl, {
          forceRefresh: true,
          keepCurrentWhileLoading: true,
          perUrlTimeoutMs: perUrlTimeoutMs,
          retryCount: retryCount + 1,
          maxRetries: maxRetries
        });
      }, 1500);
      return;
    } else {
      hidePreviewLoadingAndClearBlur();
    }
  })();
}

function normalizeNamingDateForCache(value) {
  const rawValue = String(value || "").trim();
  if (!rawValue) return "";
  // Already normalized from date input.
  if (/^\d{4}-\d{2}-\d{2}$/.test(rawValue)) return rawValue;

  // Try to parse human-readable values like "April 20, 2026".
  const parsedDate = new Date(rawValue);
  if (!Number.isNaN(parsedDate.getTime())) {
    const year = parsedDate.getFullYear();
    const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
    const day = String(parsedDate.getDate()).padStart(2, "0");
    return year + "-" + month + "-" + day;
  }

  // Fall back to raw string if parsing fails.
  return rawValue;
}

function getCertificateCacheKeyFor(versionValue, showDateValue, showMessageValue, explicitNamingDate) {
  const namingDateRaw =
    typeof explicitNamingDate === "string" && explicitNamingDate.trim()
      ? explicitNamingDate.trim()
      : (document.getElementById("namingDate")?.value || "").trim();
  const namingDateKey = normalizeNamingDateForCache(namingDateRaw);
  const starId = current_star?.id || "";
  return [
    starId,
    String(versionValue || versionNow),
    showDateValue ? "1" : "0",
    showMessageValue ? "message" : "nomessage",
    namingDateKey,
    "v8"
  ].join("|");
}

function getCertificateCacheKey(explicitNamingDate) {
  return getCertificateCacheKeyFor(versionNow, showDate, showMessage, explicitNamingDate);
}

function buildExpectedCertificateUrl(starId, versionValue) {
  const trimmedStarId = String(starId || "").trim();
  if (!trimmedStarId) return "";
  const showMessageText = showMessage ? "-showMessage" : "";
  const showDateText = showDate ? "-showDate" : "";
  return SITE_HOST_STAR_SELECTORS_ALL + "/certificates/version" + String(versionValue) + "-" + trimmedStarId + showMessageText + showDateText + "-v8-certificate.jpg";
}

/** Preview images are served through the API so nginx does not need /certificates/ static mapping. */
function buildCertificateAssetUrl(starId, versionValue, showDateValue, showMessageValue) {
  const trimmedStarId = String(starId || "").trim();
  if (!trimmedStarId) return "";
  const params = new URLSearchParams({
    starId: trimmedStarId,
    version: String(versionValue || versionNow || "1"),
    showDate: String(!!showDateValue),
    showMessage: String(!!showMessageValue),
  });
  return API_HOST_STAR_SELECTORS_ALL + "certificate/asset?" + params.toString();
}

function resolveCertificatePreviewUrl(options) {
  const apiData = options?.apiData || null;
  const starId = options?.starId || current_star?.id;
  const versionValue = options?.version || versionNow;
  const showDateValue = options?.showDate ?? showDate;
  const showMessageValue = options?.showMessage ?? showMessage;
  const cdnUrl = options?.cdnUrl || apiData?.imageLink || "";

  if (apiData?.previewUrl) return apiData.previewUrl;
  const assetUrl = buildCertificateAssetUrl(
    starId,
    versionValue,
    showDateValue,
    showMessageValue
  );
  if (assetUrl) return assetUrl;
  return cdnUrl;
}

function withCertificateCacheBuster(rawUrl) {
  const value = String(rawUrl || "").trim();
  if (!value || value.startsWith("data:image/")) return value;
  return value + (value.includes("?") ? "&" : "?") + "ts=" + Date.now();
}

function shouldProbeExpectedCertificateUrl(starId) {
  const id = String(starId || "").trim();
  if (!id) return false;
  // UUID ids do not reliably match legacy predictable certificate filenames.
  if (/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(id)) {
    return false;
  }
  return true;
}

function toFullSizeCertificateUrl(rawUrl) {
  const value = String(rawUrl || "").trim();
  if (!value) return "";
  try {
    const parsed = new URL(value, window.location.origin);
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") return "";
    if (!parsed.pathname.includes("/certificates/version")) return "";
    parsed.pathname = parsed.pathname.replace("/certificates/version", "/certificates/full-size/version");
    return parsed.toString();
  } catch (_err) {
    return "";
  }
}

function buildCertificateUrlCandidates(rawUrl) {
  const primary = String(rawUrl || "").trim();
  if (!primary) return [];
  const candidates = new Set();
  const add = (value) => {
    const safe = String(value || "").trim();
    if (!safe) return;
    candidates.add(safe);
  };
  add(primary);
  add(toFullSizeCertificateUrl(primary));
  try {
    const parsed = new URL(primary, window.location.origin);
    // Keep probing on the same trusted host only.
    // Avoid cdn.thestarmint.com probes because current cert chain is invalid there.
    if (parsed.host === "thestarmint.com") {
      parsed.host = "star.thestarmint.com";
      add(parsed.toString());
      if (parsed.pathname.includes("/certificates/version")) {
        parsed.pathname = parsed.pathname.replace("/certificates/version", "/certificates/full-size/version");
        add(parsed.toString());
      }
    }
  } catch (_err) { }
  return Array.from(candidates);
}

function probeImageUrl(url, timeoutMs) {
  return new Promise((resolve) => {
    const value = String(url || "").trim();
    if (!value) return resolve(false);
    const img = new Image();
    let settled = false;
    const done = (ok) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      img.onload = null;
      img.onerror = null;
      resolve(ok);
    };
    const timer = setTimeout(() => done(false), Number(timeoutMs || 1800));
    img.onload = () => done(true);
    img.onerror = () => done(false);
    if (value.startsWith("data:image/")) {
      img.src = value;
    } else {
      img.src = value + (value.includes("?") ? "&" : "?") + "ts=" + Date.now();
    }
  });
}

/** API returns HTTPS certificate URLs our CDN serves; probing with Image() stalls on large JPEGs. */
function isTrustedCertificateImageLink(rawUrl) {
  try {
    const value = String(rawUrl || "").trim();
    const u = new URL(value, window.location.origin);
    if (u.protocol !== "https:") return false;
    if (u.pathname.includes("/api/certificate/asset")) return true;
    if (!u.pathname.includes("/certificates/")) return false;
    const host = (u.hostname || "").toLowerCase();
    return host === "star.thestarmint.com" || host === "thestarmint.com" || host.endsWith(".thestarmint.com");
  } catch (_e) {
    return false;
  }
}

/** Poll backend job status instead of hammering image URLs for minutes. */
async function pollCertificateJobStatus(jobKey, fallbackImageLink, options) {
  const maxAttempts = options?.maxAttempts ?? 40;
  const intervalMs = options?.intervalMs ?? 1500;
  const apiBase = API_HOST_STAR_SELECTORS_ALL;

  if (!jobKey) {
    return fallbackImageLink || "";
  }

  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    try {
      const res = await fetch(
        `${apiBase}certificate/status?jobKey=${encodeURIComponent(jobKey)}`
      );
      const data = await res.json();

      if (data?.status === "ready") {
        return data.previewUrl || data.imageLink || fallbackImageLink;
      }
      if (data?.status === "failed") {
        throw new Error(data.error || "Certificate generation failed");
      }
    } catch (err) {
      if (attempt === maxAttempts - 1) {
        console.warn("[starmint] Certificate status polling failed:", err);
      }
    }

    if (attempt < maxAttempts - 1) {
      await new Promise((resolve) => setTimeout(resolve, intervalMs));
    }
  }

  return fallbackImageLink || "";
}

async function resolveReachableCertificateUrl(rawUrl, options) {
  const primary = String(rawUrl || "").trim();
  const jobKey = options?.jobKey || "";
  const maxAttempts = options?.maxAttempts ?? 8;

  if (jobKey) {
    const polled = await pollCertificateJobStatus(jobKey, primary, {
      maxAttempts: options?.statusMaxAttempts ?? 40,
      intervalMs: options?.statusIntervalMs ?? 1500,
    });
    if (polled) return polled;
  }

  const candidates = buildCertificateUrlCandidates(rawUrl);

  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    for (const candidate of candidates) {
      const ok = await probeImageUrl(candidate, attempt < 2 ? 2500 : 4000);
      if (ok) return candidate;
    }

    if (attempt > 2 && isTrustedCertificateImageLink(primary)) {
      console.log("[starmint] Trusted certificate link, returning early despite probe failure");
      return primary;
    }

    if (attempt < maxAttempts - 1) {
      await new Promise((resolve) => setTimeout(resolve, 1500));
    }
  }

  if (isTrustedCertificateImageLink(primary)) {
    return primary;
  }
  return "";
}

// Preview must use URLs returned by /api/certificate/create (imageLink) or static placeholders.
// There is no GET /api/certificate?file=… on the API; using that pattern always 404s and breaks the <img> chain.

//to see if we made this certificate already;
function findCertificate() {
  const cacheKey = getCertificateCacheKey();
  const cachedCertificateUrl = certificateCache[cacheKey];
  const generateBtn = document.getElementById("generate-certificate-button");
  const postCertificateActions = document.getElementById("post-certificate-actions");

  const loadingPlaceholder = sampleCertificates?.["loading"] || sampleCertificates?.["1"] || "";
  const expectedUrl = buildExpectedCertificateUrl(current_star?.id, versionNow);

  // Legacy "Create certificate" button is no longer rendered; keep this guard
  // for safety in case any cached theme still has it in the DOM.
  if (generateBtn) {
    generateBtn.style.setProperty("display", "none", "important");
    generateBtn.disabled = true;
  }
  if (postCertificateActions) {
    postCertificateActions.style.display = "flex";
    const nextBtn = document.getElementById("choose-gift-button");
    if (nextBtn) {
      nextBtn.style.display = "inline-flex";
      nextBtn.innerHTML = "Next";
    }
  }

  if (cachedCertificateUrl) {
    console.log("Found cached certificate:", cachedCertificateUrl);
    const previewUrl = resolveCertificatePreviewUrl({
      cdnUrl: cachedCertificateUrl,
      starId: current_star?.id,
      version: versionNow,
    });
    setCertificatePreviewSource(
      withCertificateCacheBuster(previewUrl),
      withCertificateCacheBuster(cachedCertificateUrl),
      loadingPlaceholder,
      { keepCurrentWhileLoading: true, perUrlTimeoutMs: 15000, directCertificateLoad: true }
    );
    certificate = cachedCertificateUrl;
    return;
  }

  // No cache found. Show style placeholder and let create API return canonical imageLink.
  console.log("No cache found. Trying generated certificate URL for version:", versionNow);
  setCertificatePreviewSource(loadingPlaceholder, null, null, {
    keepCurrentWhileLoading: true,
    perUrlTimeoutMs: 1200,
    maxRetries: 0
  });

  if (current_star?.id && current_star?.chart) {
    autoGenerateCertificateIfNeeded({ targetVersion: versionNow });
    return;
  }
}


const namingDateInput = document.getElementById('namingDate');
if (namingDateInput) {
  namingDateInput.value = formattedToday;
  namingDateInput.max = formattedToday;
  namingDateInput.min = "1900-01-01";
}

document.addEventListener('DOMContentLoaded', function () {
  // Explicit "start fresh" from Start Over / New Star links — clear persisted mid-flow before restore runs.
  try {
    var u = new URL(window.location.href);
    if (u.pathname.indexOf("select-a-star") !== -1 && u.searchParams.get("starmint_fresh") === "1") {
      starmintClearStarFlowState();
      u.searchParams.delete("starmint_fresh");
      var qs = u.searchParams.toString();
      window.history.replaceState({}, "", u.pathname + (qs ? "?" + qs : "") + u.hash);
    }
  } catch (_freshUrlErr) {}

  // Prevent Enter key from triggering default form submission (which caused unintended login redirects)
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Enter') {
      const target = event.target;
      if (target.tagName === 'INPUT' && target.type !== 'submit' && target.type !== 'button') {
        event.preventDefault();
      }
    }
  });

  starmintRestoreStarFlowState();
  starmintApplyLayoutCustomerToStarFlow();
  setTimeout(function () {
    if (typeof starmintEnsureFindAStarLandingVisible === "function") {
      starmintEnsureFindAStarLandingVisible();
    }
  }, 250);
  setTimeout(function () {
    if (typeof starmintEnsureFindAStarLandingVisible === "function") {
      starmintEnsureFindAStarLandingVisible();
    }
  }, 1500);

  // If guest started star/gift flow then uses header login, preserve selection.
  document.querySelectorAll('a.header__icon--account, a[href*="/account/login"]').forEach(function (link) {
    if (link.id === "login-button") return;
    link.addEventListener("click", function () {
      try {
        if (typeof starmintHasRecoverableStarFlowState === "function") {
          const raw = sessionStorage.getItem("starmint_star_flow_state");
          const state = raw ? JSON.parse(raw) : null;
          if (starmintHasRecoverableStarFlowState(state) || (current_star && current_star.identifier)) {
            starmintSavePendingStarForLogin();
            sessionStorage.setItem("starmint_post_login_redirect", "1");
          }
        }
      } catch (_hdrLoginSave) { }
    });
  });

  // LOGIN POPUP
  const certificateContainer = document.getElementById('certificate-container');
  if (certificateContainer) {
    certificateContainer.addEventListener('contextmenu', function (event) {
      event.preventDefault();
    });
  }

  const certificateStyleGrid = document.querySelector('.certificate-style-grid');
  if (certificateStyleGrid) {
    certificateStyleGrid.addEventListener('click', function (e) {
      const btn = e.target.closest('.certificate-style-option');
      if (!btn || !certificateStyleGrid.contains(btn)) return;
      const v = btn.getAttribute('data-certificate-version');
      if (v) toggleVersion(v);
    });
  }

  const loginButton = document.getElementById('login-button');
  const loginPopup = document.getElementById('login-popup');
  const closeButton = document.getElementById('popup-close-button');
  const loginSubmit = document.getElementById('login-submit-button');
  const loginLoading = document.getElementById('login-form-loading');
  const loginForm = document.getElementById("login-form");
  const congratsNextBtnGlobal = document.getElementById("congrats-next-button");
  const certificateStepWrapperEl = document.getElementById("certificate-step-wrapper");
  const certificateContainerEl = document.getElementById("certificate-container");

  if (congratsNextBtnGlobal) {
    congratsNextBtnGlobal.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      updateCertificateStarNameDisplay();
      // Resolve preview source before showing certificate UI to avoid flash
      // of legacy/static certificate art.
      findCertificate();
      if (certificateStepWrapperEl) {
        certificateStepWrapperEl.style.display = "block";
        certificateStepWrapperEl.scrollIntoView({ behavior: "smooth", block: "start" });
      } else if (certificateContainerEl) {
        certificateContainerEl.style.display = "grid";
        certificateContainerEl.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      congratsNextBtnGlobal.style.display = "none";

      // Kick off certificate generation immediately so the user sees their
      // personalized certificate without having to click "Create".
      autoGenerateCertificateIfNeeded({ targetVersion: versionNow, prewarmBoth: true });
    });
  }

  // Show the login popup when the "Login" button is clicked
  if (loginButton) {
    loginButton.addEventListener('click', function (e) {
      e.preventDefault();
      starmintSavePendingStarForLogin();
      sessionStorage.setItem("starmint_post_login_redirect", "1");
      var returnPath = window.location.pathname + window.location.search;
      window.location.href =
        "/account/login?checkout_url=" +
        encodeURIComponent(returnPath) +
        "&return_to=" +
        encodeURIComponent(returnPath);
    });
  }

  // Close the login popup when the close button is clicked
  if (closeButton) {
    closeButton.addEventListener('click', function () {
      loginPopup.style.display = 'none';
      document.querySelector("body").style.overflow = "initial"
      productDetailsWrapper.style['z-index'] = "initial";
      loginLoading.style.display = "none";
      loginForm.style.display = "block";
    });
  }

  // Handle form submission 
  if (loginSubmit) {

      loginSubmit.addEventListener('click', async function (event) {
      console.log("login clicked");
      event.preventDefault();
      starmintSavePendingStarForLogin();

      const email = document.getElementById('login-email').value.trim();
      const password = document.getElementById('login-password').value.trim();

      if (!email || !password) {
        document.getElementById("login-error").innerHTML = "Please fill out the email and password.";
        return;
      }

      loginForm.style.display = "none";
      loginLoading.style.display = "block";
      document.getElementById("login-error").innerHTML = "";

      let data = null;
      try {
        if (typeof window.starmintAuthLogin === "function") {
          data = await window.starmintAuthLogin(email, password);
        } else {
          const response = await fetch(API_HOST_STAR_SELECTORS_ALL + 'supabase-auth/login', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, password })
          });
          data = await response.json();
          if (data.success && typeof window.starmintSetSupabaseSession === "function") {
            window.starmintSetSupabaseSession(data);
          }
        }
      } catch (loginFetchErr) {
        loginLoading.style.display = "none";
        loginForm.style.display = "block";
        console.error('Error occurred during login:', loginFetchErr);
        alert("An error occurred during login. Please try again.");
        return;
      }

      if (!data || !data.success) {
        loginLoading.style.display = "none";
        loginForm.style.display = "block";
        document.getElementById("login-error").innerHTML = (data && data.message) || "Login failed. Please try again.";
        return;
      }

      if (data.hasShopifyCustomerId === false) {
        await new Promise(function (r) { setTimeout(r, 900); });
        if (typeof window.starmintAuthLogin === "function") {
          data = await window.starmintAuthLogin(email, password);
        }
      }

      if (!data || !data.success || data.hasShopifyCustomerId === false) {
        loginLoading.style.display = "none";
        loginForm.style.display = "block";
        document.getElementById("login-error").innerHTML =
          (data && data.message) ||
          "Your account is active, but the Shopify link is still syncing. Please try again in a moment.";
        return;
      }

            // --- Login successful --- (session + background Shopify login already applied via starmintAuthLogin when available)
            if (typeof window.starmintEmitAuthChanged === "function") {
              window.starmintEmitAuthChanged({
                source: "star_selector_login",
                reason: "ajax_login_success",
                email: data.user?.email || "",
                shopifyCustomerId: data.contact?.shopify_customer_id || ""
              });
            }
            console.log("Login successful for:", data.user.email);

            // Set global logged-in state (Shopify id only — never use Supabase auth user id as shopifyAccountID)
            loggedInCustomer = true;
            loggedInCustomerID = String(data.contact.shopify_customer_id);
            document.getElementById("signup-claim-star").innerText = "Reserve Star";

            // Use email prefix as display name since supabase doesn't return a name
            let customer_name = data.contact?.first_name || data.user.email.split('@')[0];
            let customer_id = String(data.contact.shopify_customer_id);
            if (typeof window.starmintApplyLayoutCustomerToStarFlow === "function") {
              try { window.starmintApplyLayoutCustomerToStarFlow(); } catch (_e) { }
            }
            productDetailsWrapper.style['z-index'] = "initial";
            loginPopup.style.display = 'none';
            document.querySelector("body").style.overflow = "initial";

            document.getElementById("star-select-confirm-results").style.display = "none";
            let link = document.querySelector('.header__icon.header__icon--account');
            if (link) link.setAttribute('href', '/account');

            let starName = document.getElementById("starName").value.trim();
            let namingDate = document.getElementById("namingDate").value.trim();
            let personalMessage = document.getElementById("personalMessage").value.trim();

            if (is_gift) {
              loginLoading.style.display = "none";
              loginForm.style.display = "block";
              loginPopup.style.display = "none";
              document.querySelector("body").style.overflow = "initial";

              document.getElementById("star-select-confirm-results").style.display = "block";
              document.getElementById("star-select-random-results").style.display = "none";

              starmintRunLoggedInGiftReservation(null, {
                accountID: data.user?.id || null,
                contactID: data.contact?.id || null,
                email: data.contact?.email || data.user?.email || "",
                full_name: [data.contact?.first_name, data.contact?.last_name].filter(Boolean).join(" ").trim(),
              });
              return;
            } else {
              let _accountIDs = {
                data: {
                  userInfo: {
                    shopifyAccountID: customer_id,
                    accountID: null,
                    contactID: null
                  },
                  recipientInfo: {
                    shopifyAccountID: null,
                    accountID: null,
                    contactID: null
                  }
                }
              };

              document.getElementById("legal-checkbox").style.visibility = "hidden";
              document.getElementById("claim-star-headline").style.visibility = "hidden";
              document.getElementById("claim-star-paragraph").style.visibility = "hidden";

              let shortFirstName = customer_name.substring(0, 12);
              const loginNameEl = document.getElementById("login-firstName");
              if (loginNameEl) {
                loginNameEl.innerHTML = shortFirstName;
              }

              loginLoading.style.display = "none";
              loginForm.style.display = "block";

              loginPopup.style.display = 'none';
              document.querySelector("body").style.overflow = "initial";

              document.getElementById("account-info-form").style.display = "block";
              document.getElementById("legal-checkbox").style.visibility = "visible";

              let starSelectConfirmResults = document.getElementById("star-select-confirm-results");
              starSelectConfirmResults.style.display = "block";

              document.getElementById("star-select-random-results").style.display = "none";
              document.getElementById("has-account-p").style.display = "none";
              document.getElementById("account-info-form-form").style.display = "none";
              document.getElementById("account-info-form-headline").style.display = "none";
              document.getElementById("account-info-form-preheadline").style.display = "none";

              scrollToElement(starSelectConfirmResults); // 9999

              const signupClaimStar = document.getElementById("signup-claim-star");
              if (signupClaimStar) signupClaimStar.style.display = "none";
              const backBtn2 = document.getElementById("back-button-to-recipient");
              if (backBtn2) backBtn2.style.display = "none";
              setTimeout(function () {
                try { starmintApplyLayoutCustomerToStarFlow(); } catch (_e) {}
                reserveStar(starName, namingDate || formattedToday, personalMessage, false, _accountIDs);
              }, 900);
            }
    });
  } // end login submit 

  const giftCheckbox = document.getElementById("gift");
  const personalMessageInput = document.getElementById("personalMessage");

  const backButtonToRecipient = document.getElementById("back-button-to-recipient");
  backButtonToRecipient.addEventListener("click", function (e) {
    e.preventDefault();

    if (giftCheckbox.checked) {
      is_gift = true;
      let recipientInfoForm = document.getElementById("recipient-info-form");
      recipientInfoForm.style.display = "block";
      let previousContinueContainer = document.getElementById("star-form-continue-01-container");
      previousContinueContainer.style.display = "block";
      try { starmintSaveStarFlowState(); } catch (_e) { }
    } else {
      let starInfoForm = document.getElementById("star-info-form");
      starInfoForm.style.display = "block";
      let previousContinueContainer = document.getElementById("star-form-continue-0-container");
      previousContinueContainer.style.display = "block";
    }

    let accountInfoForm = document.getElementById("account-info-form");
    accountInfoForm.style.display = "none";



    return
  });

  const backButtonToStar = document.getElementById("back-button-to-star-info");
  backButtonToStar.addEventListener("click", function (e) {
    e.preventDefault();

    let recipientInfoForm = document.getElementById("recipient-info-form");
    recipientInfoForm.style.display = "none";

    let starInfoForm = document.getElementById("star-info-form");
    starInfoForm.style.display = "block";

    let previousContinueContainer = document.getElementById("star-form-continue-0-container");
    previousContinueContainer.style.display = "block";

    return
  });



  // Add an event listener to the  gift checkbox
  giftCheckbox.addEventListener("change", function () {
    is_gift = !!giftCheckbox.checked;
    if (!is_gift) {
      starmintClearGiftRecipientInfo();
    }
    try { starmintSaveStarFlowState(); } catch (_giftSaveErr) { }
    // Check if the checkbox is checked
    if (giftCheckbox.checked) {
      // If checked, enable the personalMessage input
      personalMessageInput.removeAttribute("disabled");
      document.getElementById("is_gift_short_desc").style.display = "block";
      document.getElementById("congrats-star-headline").innerHTML = "Congratulations, your star gift is Reserved. Please checkout to finalize purchase."
      document.getElementById("star-certificate-intro-headline").innerHTML = "Select your Certificate Format"
      document.getElementById("star-certificate-intro-sub-headline").innerHTML = "Select your Certificate Format"
      document.getElementById("gift-registration-reminder-1").style.display = "block";
    } else {
      // If unchecked, disable the personalMessage input
      personalMessageInput.setAttribute("disabled", "disabled");
      document.getElementById("is_gift_short_desc").style.display = "none";
      document.getElementById("congrats-star-headline").innerHTML = "Congratulations, your star is reserved. Please checkout to finalize purchase."
      document.getElementById("star-certificate-intro-headline").innerHTML = "Select your Certificate Format"
      document.getElementById("star-certificate-intro-sub-headline").innerHTML = "Select your Certificate Format"
      document.getElementById("gift-registration-reminder-1").style.display = "none";
    }
  });

  // RESTART BUTTON
  const restartButtons = document.querySelectorAll('#restart-button');

  // Add an event listener to each restart button
  restartButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      try {
        var ru = new URL(window.location.href);
        ru.searchParams.set("starmint_fresh", "1");
        window.location.href = ru.pathname + (ru.searchParams.toString() ? "?" + ru.searchParams.toString() : "") + ru.hash;
      } catch (_restartErr) {
        window.location.href = "/pages/select-a-star?starmint_fresh=1";
      }
    });
  });

  // Get references to the checkbox and checkmark
  const agreeCheckbox = document.getElementById('agree-checkbox');

  // Add an event listener to the checkbox
  agreeCheckbox.addEventListener('change', function () {
    const signupButton = document.getElementById('signup-claim-star');
    // Enable or disable the button based on the checkbox state
    signupButton.disabled = !agreeCheckbox.checked;
  });



  // Show Recipient info box if checkbox is clicked


  const starNameInput = document.getElementById('starName');

  document.getElementById("star-form-continue-0").addEventListener("click", async function (e) {
    const btn = this;
    checkedAndOK = false;

    let rawName = (document.getElementById("starName") && document.getElementById("starName").value) || "";
    let starName = String(rawName).trim();

    if (!starName) {
      var idPart = current_star && current_star.identifier != null ? String(current_star.identifier) : "";
      if (idPart) {
        starName = idPart.substring(0, 20).trim();
        document.getElementById("starName").value = starName;
      }
    }

    if (!starName) {
      document.getElementById("err-message-star").innerHTML = "Please put a star name.";
      document.getElementById("err-message-star").style.display = "block";
      document.getElementById("err-message-star").style.color = "red";
      return;
    }
    if (starName.length > 20) {
      document.getElementById("err-message-star").innerHTML = "Your star's name can only be a maximum of 20 characters in length.";
      document.getElementById("err-message-star").style.display = "block";
      document.getElementById("err-message-star").style.color = "red";
      return;
    }

    btn.disabled = true;

    const uniqueAPI = `https://star.thestarmint.com/api/supabase/starNameExists?name=${encodeURIComponent(starName)}`;

    try {
      document.getElementById("err-message-star").innerHTML = "Checking star name availability...";
      document.getElementById("err-message-star").style.display = "block";
      document.getElementById("err-message-star").style.color = "#f4cf7d";
      const response = await window.starmintFetchWithRetry(uniqueAPI, {
        method: 'GET',
        headers: {}
      });

      if (response && response.ok) {
        try {
          await response.json();
        } catch (_jsonErr) {
          checkedAndOK = false;
          document.getElementById("err-message-star").innerHTML = "Could not verify that name right now. Please try again.";
          document.getElementById("err-message-star").style.color = "red";
          document.getElementById("err-message-star").style.display = "block";
          btn.disabled = false;
          return;
        }
        checkedAndOK = true;
        document.getElementById("err-message-star").innerHTML = "";
        document.getElementById("err-message-star").style.display = "none";
      } else {
        checkedAndOK = false;
        console.error("starNameExists request failed:", response && response.status);
        document.getElementById("err-message-star").innerHTML = "Could not verify that name right now. Please try again.";
        document.getElementById("err-message-star").style.color = "red";
        document.getElementById("err-message-star").style.display = "block";
        btn.disabled = false;
        return;
      }
    } catch (error) {
      checkedAndOK = false;
      console.error("Error:", error);
      document.getElementById("err-message-star").innerHTML = "Could not verify that name right now. Please try again.";
      document.getElementById("err-message-star").style.color = "red";
      document.getElementById("err-message-star").style.display = "block";
      btn.disabled = false;
      return;
    }

    if (!checkedAndOK) {
      btn.disabled = false;
      return;
    }

    let namingDate = document.getElementById("namingDate").value;
    let personalMessage = document.getElementById("personalMessage").value;

    let recfirstName = document.getElementById("recFirstName");
    let reclastName = document.getElementById("recLastName");
    let recemail = document.getElementById("recEmail");
    let recphone = document.getElementById("recPhone");

    const cb = document.querySelector("#gift");
    if (cb && cb.checked) {
      is_gift = true;
      document.getElementById("err-message-star").innerHTML = "";
      document.getElementById("star-form-continue-0-container").style.display = "none";
      document.getElementById("star-form-continue-1-container").style.display = "none";
      document.getElementById("star-form-continue-01-container").style.display = "block";
      document.getElementById("recipient-info-form").style.display = "block";
      document.getElementById("account-info-form").style.display = "none";
      document.getElementById("star-info-form").style.display = "none";
    } else {
      is_gift = false;
      starmintClearGiftRecipientInfo();
      if (recfirstName) recfirstName.removeAttribute("required");
      if (reclastName) reclastName.removeAttribute("required");
      if (recemail) recemail.removeAttribute("required");
      if (recphone) recphone.removeAttribute("required");

      document.getElementById("recipient-info-form").style.display = "none";
      document.getElementById("star-form-continue-01-container").style.display = "none";
      document.getElementById("star-form-continue-0-container").style.display = "none";
      document.getElementById("star-form-continue-1-container").style.display = "none";

      document.getElementById("star-info-form").style.display = "none";
      document.getElementById("err-message-star").innerHTML = "";

      // Refresh loggedInCustomer from latest storefront state before deciding
      try { starmintApplyLayoutCustomerToStarFlow(); } catch (_e) {}

      // Also check Supabase session (mirrors starmintTriggerFastReservation's canFastReserve logic):
      // a user whose Shopify ID isn't linked yet still has a valid Supabase session.
      let _sbContactForContinue = null;
      try { _sbContactForContinue = JSON.parse(localStorage.getItem("supabase_contact") || "null"); } catch (_e) {}
      const _sbEmailForContinue = (_sbContactForContinue && (_sbContactForContinue.email || _sbContactForContinue.email_address)) || "";
      const _canReserveNow = loggedInCustomer || !!_sbEmailForContinue;

      if (_canReserveNow) {
        let _accountIDs = { data: { userInfo: { shopifyAccountID: loggedInCustomerID } } };
        document.getElementById("star-selectors-start").style.display = "none";
        document.querySelectorAll(".star-selection-data-results").forEach(function (elem) { elem.style.display = "none"; });
        document.getElementById("loading").querySelector("p").innerHTML = "Reserving Your Star...";
        reserveStar(starName, namingDate || formattedToday, personalMessage, false, _accountIDs);
      } else {
        document.getElementById("account-info-form").style.display = "block";
      }
    }

    try { starmintSaveStarFlowState(); } catch (_continueSaveErr) { }
    btn.disabled = false;
  });

  // Recipient fields are stored in outer-scope rfirstName / rlastName / remail / rphone.

  // Show Recipient info box if checkbox is clicked
  document.getElementById("star-form-continue-01").addEventListener("click", function (e) {
    console.log("[starmint] recipient continue clicked", { is_gift, loggedInCustomer });

    const recipientFields = starmintReadRecipientFieldsFromDom();
    starmintSyncRecipientGlobals(recipientFields);
    rfirstName = recipientFields.firstName;
    rlastName = recipientFields.lastName;
    remail = recipientFields.email;
    rphone = recipientFields.phone;

    const emailRegex = /^[\w.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

    if (!rfirstName) {
      document.getElementById("err-message-account").innerHTML = "First name is required!";
    } else if (!rlastName) {
      document.getElementById("err-message-account").innerHTML = "Last name is required!";
    } else if (!emailRegex.test(remail)) {
      document.getElementById("err-message-account").innerHTML = "Invalid email";
    } else if (rphone && !validatePhoneNumber(normalizePhoneInput(rphone))) {
      document.getElementById("err-message-account").innerHTML = "Invalid phone number";
    } else {
      if (rphone) rphone = normalizePhoneInput(rphone);
      document.getElementById("err-message-account").innerHTML = "";
      is_gift = true;
      const giftCheckboxEl = document.getElementById("gift");
      if (giftCheckboxEl) giftCheckboxEl.checked = true;
      starmintPersistGiftRecipientInfo(recipientFields);
      try { starmintSaveStarFlowState(); } catch (_giftSaveErr) { }

      if (!loggedInCustomer) {
        starmintShowGifterAccountFormAfterRecipient();
        return;
      }

      document.getElementById("recipient-info-form").style.display = "none";
      document.getElementById("star-form-continue-01-container").style.display = "none";
      document.getElementById("star-form-continue-1-container").style.display = "none";

      starmintRunLoggedInGiftReservation(this);
    }

    starName = document.getElementById("starName").value.trim();
    namingDate = document.getElementById("namingDate").value.trim();
    personalMessage = document.getElementById("personalMessage").value.trim();

  })

  let starName = document.getElementById("starName").value.trim();
  let namingDate = document.getElementById("namingDate").value.trim();
  let personalMessage = document.getElementById("personalMessage").value.trim();




  document.getElementById("star-form-continue-1").addEventListener("click", function (e) {
    let starName = document.getElementById("starName").value.trim();
    let namingDate = document.getElementById("namingDate").value.trim();
    let personalMessage = document.getElementById("personalMessage").value.trim();

    if (!namingDate) {
      document.getElementById("err-message-star").innerHTML = "Please choose a naming date.";
      return;
    }
    if (namingDate > formattedToday) {
      document.getElementById("err-message-star").innerHTML = "Naming date cannot be in the future.";
      return;
    }



    if (!starName) {
      document.getElementById("err-message-star").innerHTML = "Please fill in the star name";
    } else if (starName?.length > 20) {
      document.getElementById("err-message-star").innerHTML = "Your star's name can only be a maximum of 20 characters in length.";
    }
    else {
      document.getElementById("err-message-star").innerHTML = "";

      if (!loggedInCustomer) {
        starmintSavePendingStarForLogin();
        var returnPath = window.location.pathname + window.location.search;
        window.location.href =
          "/account/login?checkout_url=" +
          encodeURIComponent(returnPath) +
          "&return_to=" +
          encodeURIComponent(returnPath);
        return;
      }

      let _accountIDs = {
        data: {
          userInfo: { shopifyAccountID: loggedInCustomerID },
        }
      };
      document.getElementById("star-selectors-start").style.display = "none";
      document.querySelectorAll(".star-selection-data-results").forEach(elem => elem.style.display = 'none');
      document.getElementById("loading").querySelector("p").innerHTML = "Reserving Your Star...";
      const currentBtn = this;
      currentBtn.disabled = true;
      currentBtn.textContent = "Reserving...";

      reserveStar(document.getElementById("starName").value.trim(), document.getElementById("namingDate").value.trim(), document.getElementById("personalMessage").value.trim(), false, _accountIDs);
    }

  })

  function addToCart(formData, redirect = false) {
    document.getElementById("loading").style.display = "block";

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(async (response) => {
        let payload = null;
        try {
          payload = await response.json();
        } catch (_jsonErr) {
          payload = null;
        }
        if (!response.ok) {
          const msg =
            (payload && (payload.description || payload.message)) ||
            "Unable to add this item to your cart. Please try again.";
          throw new Error(msg);
        }
        return payload;
      })
      .then(data => {
        document.getElementById("loading").style.display = "none";

        // If the POST request is successful, change the display of the button
        var btn = document.querySelector('.cust-btn');
        if (btn) {
          btn.style.display = 'block';
          btn.style.color = '#000000';
        }
        if (window.location.search) {
          const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
          window.history.replaceState({}, '', newUrl);
        }
        if (redirect) {
          window.location.href = "/cart";
        }

      })
      .catch((error) => {
        console.error('Error:', error);
        document.getElementById("loading").style.display = "none";
        const errTargets = [
          document.getElementById("err-message-account-submit2"),
          document.getElementById("err-message-account"),
          document.getElementById("err-message-star"),
        ].filter(Boolean);
        const errText = error && error.message ? error.message : "Could not add item to cart.";
        errTargets.forEach(function (el, idx) {
          el.innerHTML = errText;
          el.style.display = idx === 0 ? "block" : el.style.display;
          el.style.color = "red";
        });
      });
  }


  function setCookieFunc(name, value, days = 1) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }




  let starAccountInfoForm = document.getElementById("star-account-info-form");

  if (!starAccountInfoForm) {
    console.warn("[starmint] star-account-info-form not found; star selector submit handler not bound.");
  } else starAccountInfoForm.addEventListener("submit", async function (e) {
    e.preventDefault();
    starmintApplyLayoutCustomerToStarFlow();
    console.log("[starmint] signup form submitted", { loggedInCustomer, is_gift });

    document.getElementById("star-selectors-start").style.display = "none";
    document.querySelectorAll(".star-selection-data-results").forEach(elem => elem.style.display = 'none');


    let accountsData = {};


    if (!is_gift) {
      document.getElementById("toggle-group-message").style.display = "none"
    }


    if (loggedInCustomer) {
      const passwordEl = document.getElementById("password");
      const confirmPasswordEl = document.getElementById("confirmPassword");

      if (passwordEl) {
        passwordEl.required = false;
      }
      if (confirmPasswordEl) {
        confirmPasswordEl.required = false;
      }
      console.log('we are in loggedInCustomer flow on line 1930')
      if (is_gift) {
        console.log('we are in loggedInCustomer IS GIFT flow on line 1930')
        const reserveStarNameGift = document.getElementById("starName").value.trim();
        const reserveNamingDateGift = document.getElementById("namingDate").value.trim();
        const reservePersonalMessageGift = document.getElementById("personalMessage").value.trim();

        if (!reserveNamingDateGift) {
          document.getElementById("loading").style.display = "none";
          document.getElementById("signup-claim-star").style.display = "inline-block";
          document.getElementById("err-message-star").innerHTML = "Please choose a naming date.";
          return false;
        }
        if (reserveNamingDateGift > formattedToday) {
          document.getElementById("loading").style.display = "none";
          document.getElementById("signup-claim-star").style.display = "inline-block";
          document.getElementById("err-message-star").innerHTML = "Naming date cannot be in the future.";
          return false;
        }
        if (!reserveStarNameGift) {
          document.getElementById("loading").style.display = "none";
          document.getElementById("signup-claim-star").style.display = "inline-block";
          document.getElementById("err-message-star").innerHTML = "Please fill in the star name";
          return false;
        }
        if (reserveStarNameGift.length > 20) {
          document.getElementById("loading").style.display = "none";
          document.getElementById("signup-claim-star").style.display = "inline-block";
          document.getElementById("err-message-star").innerHTML =
            "Your star's name can only be a maximum of 20 characters in length.";
          return false;
        }

        let _accountIDsGift = starmintBuildGiftReservePayload({
          shopifyAccountID: loggedInCustomerID,
          accountID: null,
          contactID: null,
        });

        document.getElementById("legal-checkbox").style.visibility = "hidden";
        document.getElementById("claim-star-headline").style.visibility = "hidden";
        document.getElementById("claim-star-paragraph").style.visibility = "hidden";

        document.getElementById("loading").querySelector("p").innerHTML = "Reserving Your Star...";
        document.getElementById("loading").style.display = "block";
        document.getElementById("signup-claim-star").style.display = "none";
        document.getElementById("back-button-to-recipient").style.display = "none";

        const currentBtnGift = document.getElementById("signup-claim-star");
        if (currentBtnGift) {
          currentBtnGift.disabled = true;
          currentBtnGift.textContent = "Reserving...";
        }
        reserveStar(reserveStarNameGift, reserveNamingDateGift, reservePersonalMessageGift, true, _accountIDsGift);
        return true;
      } else {
        console.log('we are in loggedInCustomer flow - NOT GIFT on line 1943')
        let _accountIDs = {
          data: {
            userInfo: {
              shopifyAccountID: loggedInCustomerID,
              accountID: null,
              contactID: null
            },
            recipientInfo: {
              shopifyAccountID: null,
              accountID: null,
              contactID: null
            }
          }
        }

        const reserveStarName = document.getElementById("starName").value.trim();
        const reserveNamingDate = document.getElementById("namingDate").value.trim();
        const reservePersonalMessage = document.getElementById("personalMessage").value.trim();

        if (!reserveNamingDate) {
          document.getElementById("loading").style.display = "none";
          document.getElementById("signup-claim-star").style.display = "inline-block";
          document.getElementById("err-message-star").innerHTML = "Please choose a naming date.";
          return false;
        }
        if (reserveNamingDate > formattedToday) {
          document.getElementById("loading").style.display = "none";
          document.getElementById("signup-claim-star").style.display = "inline-block";
          document.getElementById("err-message-star").innerHTML = "Naming date cannot be in the future.";
          return false;
        }
        if (!reserveStarName) {
          document.getElementById("loading").style.display = "none";
          document.getElementById("signup-claim-star").style.display = "inline-block";
          document.getElementById("err-message-star").innerHTML = "Please fill in the star name";
          return false;
        }
        if (reserveStarName.length > 20) {
          document.getElementById("loading").style.display = "none";
          document.getElementById("signup-claim-star").style.display = "inline-block";
          document.getElementById("err-message-star").innerHTML = "Your star's name can only be a maximum of 20 characters in length.";
          return false;
        }

        document.getElementById("legal-checkbox").style.visibility = "hidden";
        document.getElementById("claim-star-headline").style.visibility = "hidden";
        document.getElementById("claim-star-paragraph").style.visibility = "hidden";

        document.getElementById("loading").querySelector("p").innerHTML = "Reserving Your Star...";
        document.getElementById("loading").style.display = "block";
        document.getElementById("signup-claim-star").style.display = "none";
        document.getElementById("back-button-to-recipient").style.display = "none";

        console.log("reserve star body:", reserveStarName, reserveNamingDate, reservePersonalMessage, is_gift, _accountIDs);
        const currentBtn = document.getElementById("signup-claim-star");
        if (currentBtn) {
          currentBtn.disabled = true;
          currentBtn.textContent = "Reserving...";
        }
        reserveStar(reserveStarName, reserveNamingDate, reservePersonalMessage, is_gift, _accountIDs);
        return true;
      }
    } else { // not logged in customer:
      console.log("[starmint] unauthenticated create-account flow started");
      let firstName = document.getElementById("firstName").value.trim();
      let lastName = document.getElementById("lastName").value.trim();
      let email = document.getElementById("email").value.trim();
      let phone = document.getElementById("phone").value.trim();
      let password = document.getElementById("password").value.trim();
      let confirmPassword = document.getElementById("confirmPassword").value.trim();

      // const phoneRegex = /^\d{0,4}-?\d{3}-?\d{3}-?\d{4}$/;
      // format '1-123-456-7890', '123-456-7890', '1234567890', '123-4567890', '123456-7890'
      const emailRegex = /^[\w.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

      if (password !== confirmPassword) {
        document.getElementById("err-message-account-submit").innerHTML = "Passwords do NOT match";
        document.getElementById("password").style.outline = "none";
        document.getElementById("phone").style.outline = "none";
        document.getElementById("email").style.outline = "none";
        document.getElementById("confirmPassword").style.outline = "red solid 3px";
        document.getElementById("err-message-account-submit").style.display = "block";
        return false;
      } else if (password.length < 8) {
        document.getElementById("err-message-account-submit").innerHTML = "Password should have at least 8 characters";
        document.getElementById("confirmPassword").style.outline = "none";
        document.getElementById("phone").style.outline = "none";
        document.getElementById("email").style.outline = "none";
        document.getElementById("password").style.outline = "red solid 3px";
        document.getElementById("err-message-account-submit").style.display = "block";
        return false;
      } else if (!validatePhoneNumber(normalizePhoneInput(phone))) {
        document.getElementById("err-message-account-submit").innerHTML = "Invalid phone number";
        document.getElementById("confirmPassword").style.outline = "none";
        document.getElementById("password").style.outline = "none";
        document.getElementById("email").style.outline = "none";
        document.getElementById("phone").style.outline = "red solid 3px";
        document.getElementById("err-message-account-submit").style.display = "block";
        return false;
      } else if (!emailRegex.test(email)) {
        document.getElementById("err-message-account-submit").innerHTML = "Invalid email";
        document.getElementById("confirmPassword").style.outline = "none";
        document.getElementById("password").style.outline = "none";
        document.getElementById("phone").style.outline = "none";
        document.getElementById("email").style.outline = "red solid 3px";
        document.getElementById("err-message-account-submit").style.display = "block";
        return false;
      }
      phone = normalizePhoneInput(phone);
      accountsData = {
        firstName,
        lastName,
        email,
        phone,
        password,
        shopifyCustomerId:
          (window.__STARMINT_CUSTOMER && window.__STARMINT_CUSTOMER.id) ||
          (window.__STARMINT_STAR_SELECTORS__ && window.__STARMINT_STAR_SELECTORS__.customerId) ||
          (window.Shopify && window.Shopify.customer && window.Shopify.customer.id) ||
          null,
        is_gift,
        rfirstName,
        rlastName,
        remail,
        rphone,
        _sendNotificationsToRecipient: 0
      };

    } // end of if loggedInCustomer

    console.log('we are OUT of loggedInCustomer flow on line 2037')

    document.getElementById("err-message-account-submit").innerHTML = "";

    // hide the form while creating the account
    starAccountInfoForm.style.display = "none";
    document.getElementById("claim-star-headline").style.visibility = "hidden";
    document.getElementById("claim-star-paragraph").style.visibility = "hidden";
    document.getElementById("loading").querySelector("p").innerHTML = window.__STARMINT_STAR_SELECTORS__.createAccountLoadingText || "";

    document.getElementById("loading").style.display = "block";
    document.getElementById("star-info-form").style.display = "none";
    document.getElementById("err-message-star").innerHTML = "";

    // Always read star fields from the DOM here — starName/namingDate/personalMessage
    // were never in scope for the guest branch (only existed in other inner callbacks),
    // so pendingData used to ship undefined and cart line items lost the chosen name.
    const pendingStarName = (document.getElementById("starName")?.value || "").trim();
    const pendingNamingDate = (document.getElementById("namingDate")?.value || "").trim();
    const pendingPersonalMessage = (document.getElementById("personalMessage")?.value || "").trim();
    const pendingStarNameResolved =
      pendingStarName ||
      (String(current_star?.name || "").trim() ? String(current_star.name).trim() : "") ||
      (current_star?.identifier ? String(current_star.identifier).substring(0, 20).trim() : "");

    if (!loggedInCustomer || is_gift) {
      if (!pendingNamingDate) {
        document.getElementById("loading").style.display = "none";
        document.getElementById("signup-claim-star").style.display = "inline-block";
        starAccountInfoForm.style.display = "block";
        document.getElementById("err-message-star").innerHTML = "Please choose a naming date.";
        document.getElementById("err-message-star").style.display = "block";
        return false;
      }
      if (pendingNamingDate > formattedToday) {
        document.getElementById("loading").style.display = "none";
        document.getElementById("signup-claim-star").style.display = "inline-block";
        starAccountInfoForm.style.display = "block";
        document.getElementById("err-message-star").innerHTML = "Naming date cannot be in the future.";
        document.getElementById("err-message-star").style.display = "block";
        return false;
      }
      if (!pendingStarNameResolved) {
        document.getElementById("loading").style.display = "none";
        document.getElementById("signup-claim-star").style.display = "inline-block";
        starAccountInfoForm.style.display = "block";
        document.getElementById("err-message-star").innerHTML = "Please fill in the star name.";
        document.getElementById("err-message-star").style.display = "block";
        return false;
      }
      if (pendingStarNameResolved.length > 20) {
        document.getElementById("loading").style.display = "none";
        document.getElementById("signup-claim-star").style.display = "inline-block";
        starAccountInfoForm.style.display = "block";
        document.getElementById("err-message-star").innerHTML =
          "Your star's name can only be a maximum of 20 characters in length.";
        document.getElementById("err-message-star").style.display = "block";
        return false;
      }
    }

    if (is_gift) {
      const giftRecipient = starmintResolveGiftRecipient({ accountsData });
      if (!giftRecipient.firstName || !giftRecipient.lastName || !giftRecipient.email) {
        document.getElementById("loading").style.display = "none";
        document.getElementById("signup-claim-star").style.display = "inline-block";
        starAccountInfoForm.style.display = "block";
        document.getElementById("err-message-account-submit").innerHTML =
          "Please enter the gift recipient's name and email before continuing.";
        document.getElementById("err-message-account-submit").style.display = "block";
        if (document.getElementById("recipient-info-form")) {
          document.getElementById("recipient-info-form").style.display = "block";
          document.getElementById("account-info-form").style.display = "none";
        }
        return false;
      }
      starmintSyncRecipientGlobals(giftRecipient);
    }

    current_star.name = pendingStarNameResolved;

    // OLD FLOW RESTORED: Create account first so contact record exists
    window._starReservationPendingData = {
      starName: pendingStarNameResolved,
      namingDate: pendingNamingDate,
      personalMessage: pendingPersonalMessage,
      is_gift,
      email: accountsData.email,
      accountsData: accountsData,
      recipientInfo: {
        firstName: rfirstName,
        lastName: rlastName,
        name: [rfirstName, rlastName].filter(Boolean).join(" ").trim(),
        email: remail,
        phone: rphone || null,
      },
    };
    console.log("[starmint] pending reservation data prepared", {
      email: accountsData.email,
      is_gift,
      hasStarName: Boolean(pendingStarNameResolved),
      hasNamingDate: Boolean(pendingNamingDate)
    });

    const apiBase = window.starmintApiHost || (typeof API_HOST_STAR_SELECTORS_ALL !== 'undefined' ? API_HOST_STAR_SELECTORS_ALL : 'https://star.thestarmint.com/api/');

    window.starmintFetchWithRetry(apiBase + "/supabase-auth/createAccount", {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(accountsData)
    })
      .then(res => res.json())
      .then(accountData => {
        if (!accountData.success) {
          throw new Error(accountData.message || "Failed to create account.");
        }
        window._starReservationPendingData.accountData = accountData; // save it for later

        // Switch to verification UI
        document.getElementById("loading").style.display = "none";
        starAccountInfoForm.style.display = "none";
        document.getElementById("reservation-verify-step").style.display = "block";
        document.getElementById("res-verify-intro-text").innerHTML = `We've sent a 6-digit verification code to <strong>${accountsData.email}</strong>.`;

        // Request the code
        if (typeof window.starmintAuthRequestEmailCode === "function") {
          starmintSaveStarFlowState();
          console.log("[starmint] requesting OTP for reservation", { email: accountsData.email });
          window.starmintAuthRequestEmailCode(accountsData.email);
        } else {
          console.error("[starmint] starmintAuthRequestEmailCode is not available");
          document.getElementById("res-verify-message").style.color = "red";
          document.getElementById("res-verify-message").innerText = "OTP service is unavailable. Please refresh and try again.";
        }
      })
      .catch(err => {
        document.getElementById("loading").style.display = "none";
        document.getElementById("err-message-account-submit").innerHTML = err.message || "Error creating account";
        document.getElementById("err-message-account-submit").style.display = "block";
        starAccountInfoForm.style.display = "block";
      });

    return; // STOP HERE! Wait for verify button click.



  })

  // Helper to automatically advance to the account / reservation step.
  // IMPORTANT: defined at outer scope (NOT inside window.reserveStar) so it
  // is available on the first Reserve click. Previously this lived inside
  // reserveStar's body, meaning guests who clicked Reserve before reserveStar
  // had ever run hit `typeof window.starmintTriggerFastReservation === "function"`
  // === false and the right column on the "Reserve Your Star" step rendered
  // empty.
  window.starmintTriggerFastReservation = async () => {
    const giftCb = document.getElementById("gift");
    if ((typeof is_gift !== "undefined" && is_gift) || (giftCb && giftCb.checked)) {
      console.log("[starmint] Gift flow active — skipping fast reservation UI reset");
      return;
    }
    try {
      const rawGiftState = sessionStorage.getItem("starmint_star_flow_state");
      if (rawGiftState) {
        const giftState = JSON.parse(rawGiftState);
        if (giftState.is_gift) {
          console.log("[starmint] Saved gift flow state — skipping fast reservation UI reset");
          return;
        }
      }
    } catch (_giftStateErr) { }

    console.log("[starmint] Triggering fast reservation...");

    let supabaseUserFallback = null;
    try {
      const rawUser = localStorage.getItem("supabase_user") || localStorage.getItem("supabaseUser");
      supabaseUserFallback = rawUser ? JSON.parse(rawUser) : null;
    } catch (e) {
      supabaseUserFallback = null;
    }

    let supabaseContactFallback = null;
    try {
      const rawContact = localStorage.getItem("supabase_contact");
      supabaseContactFallback = rawContact ? JSON.parse(rawContact) : null;
    } catch (_e) {
      supabaseContactFallback = null;
    }

    const supabaseEmail =
      (supabaseUserFallback &&
        (supabaseUserFallback.email ||
          supabaseUserFallback.user_metadata?.email ||
          supabaseUserFallback.new_email)) ||
      (supabaseContactFallback &&
        (supabaseContactFallback.email || supabaseContactFallback.email_address)) ||
      "";

    const shopifyCustomerId =
      (typeof starmintResolveStorefrontCustomerId === "function" && starmintResolveStorefrontCustomerId()) ||
      (window.__STARMINT_CUSTOMER && window.__STARMINT_CUSTOMER.id) ||
      (window.__STARMINT_STAR_SELECTORS__ && window.__STARMINT_STAR_SELECTORS__.customerId) ||
      null;
    const hasShopifySession = !!shopifyCustomerId;
    const hasSupabaseSessionWithEmail =
      !!(supabaseUserFallback && String(supabaseEmail || "").trim());

    // reserveStar needs a resolvable owner email; otherwise show the registration UI
    // (matches Liquid "Complete account setup" when there is no Shopify customer).
    const canFastReserve = hasShopifySession || hasSupabaseSessionWithEmail;

    const namingDateInput = document.getElementById("namingDate");
    if (namingDateInput && !namingDateInput.value) {
      namingDateInput.value = formattedToday;
    }

    const starNameInput = document.getElementById("starName");
    if (starNameInput) {
      const existingName = (starNameInput.value || "").trim();
      const defaultName = (current_star.identifier || "My Star").substring(0, 20);
      const resolvedName = existingName || defaultName;
      starNameInput.value = resolvedName;
      current_star.name = resolvedName;
    }

    const confirmSection = document.getElementById("star-select-confirm-results");
    if (confirmSection) confirmSection.style.display = "block";

    // Make sure the star-selectors landing screen is hidden so the confirm/account UI is visible.
    const selectorsStart = document.getElementsByClassName("star-selectors-start")[0];
    if (selectorsStart) selectorsStart.style.display = "none";

    console.log(
      canFastReserve
        ? "[starmint] Session can fast-reserve, but showing star info first for certificate name entry"
        : "[starmint] Guest / incomplete session — showing star info first"
    );

    const starInfoForm = document.getElementById("star-info-form");
    const starAccountInfoFormEl = document.getElementById("star-account-info-form");
    const recipientInfoForm = document.getElementById("recipient-info-form");
    const accountInfoForm = document.getElementById("account-info-form");
    const continueToAccountContainer = document.getElementById("star-form-continue-0-container");
    const continueRecipientContainer = document.getElementById("star-form-continue-01-container");
    const reserveContainer = document.getElementById("star-form-continue-1-container");

    if (starAccountInfoFormEl) starAccountInfoFormEl.style.display = "block";
    starmintSetStepDisplay(starInfoForm, "block");
    if (recipientInfoForm) recipientInfoForm.style.display = "none";
    if (accountInfoForm) accountInfoForm.style.display = "none";
    starmintSetStepDisplay(continueToAccountContainer, "block");
    if (continueRecipientContainer) continueRecipientContainer.style.display = "none";
    if (reserveContainer) reserveContainer.style.display = "none";

    // Keep account fields ready for the next step.
    const formForm = document.getElementById("account-info-form-form");
    const hl = document.getElementById("account-info-form-headline");
    const ph = document.getElementById("account-info-form-preheadline");
    const hasAccountP = document.getElementById("has-account-p");
    if (formForm) formForm.style.display = "";
    if (hl) hl.style.display = "";
    if (ph) ph.style.display = "";
    if (hasAccountP && !shopifyCustomerId) hasAccountP.style.display = "";

    setActivePage(2);
    if (starAccountInfoFormEl) scrollToElement(starAccountInfoFormEl);

    // Persist so a refresh on this step also reopens the form automatically.
    try { starmintSaveStarFlowState(); } catch (_e) { }
  };

  window.reserveStar = async (starName, namingDate, personalMessage, is_gift_arg, data) => {
    if (window.starmintReserveInFlight) {
      console.warn("[starmint] reserveStar already in progress — skipping duplicate call");
      return;
    }
    window.starmintReserveInFlight = true;

    const isGiftReserve = !!(is_gift_arg || starmintIsGiftFlowActive());
    if (isGiftReserve && !is_gift) {
      is_gift = true;
      console.warn("[starmint] reserveStar: gift flow restored from persisted recipient/session state");
    }

    rampUpMultiple = 200;

    current_star.name = starName;

    document.getElementById("star-selectors-start").style.display = "none";
    document.querySelectorAll(".star-selection-data-results").forEach(elem => elem.style.display = 'none');

    let supabaseContactFallback = null;
    let supabaseUserFallback = null;
    try {
      const rawContact = localStorage.getItem("supabase_contact");
      supabaseContactFallback = rawContact ? JSON.parse(rawContact) : null;
    } catch (e) {
      supabaseContactFallback = null;
    }
    try {
      const rawUser = localStorage.getItem("supabase_user") || localStorage.getItem("supabaseUser");
      supabaseUserFallback = rawUser ? JSON.parse(rawUser) : null;
    } catch (e) {
      supabaseUserFallback = null;
    }

    const fallbackFirstName = (document.getElementById("firstName")?.value || "").trim();
    const fallbackLastName = (document.getElementById("lastName")?.value || "").trim();
    const fallbackFullName = [fallbackFirstName, fallbackLastName].filter(Boolean).join(" ").trim();
    const fallbackEmail = (document.getElementById("email")?.value || "").trim();

    // NOTE: window.starmintTriggerFastReservation is now defined at outer
    // scope (just above this function) so it's available on the very first
    // Reserve click — before reserveStar has ever been invoked.

    const reserveOwnerName =
      data?.data?.userInfo?.full_name ||
      data?.data?.userInfo?.name ||
      data?.userInfo?.full_name ||
      data?.userInfo?.name ||
      data?.contact?.full_name ||
      [data?.contact?.first_name, data?.contact?.last_name].filter(Boolean).join(" ") ||
      supabaseContactFallback?.full_name ||
      fallbackFullName ||
      supabaseContactFallback?.name ||
      [supabaseContactFallback?.first_name, supabaseContactFallback?.last_name].filter(Boolean).join(" ").trim() ||
      "Customer";

    const reserveOwnerEmail =
      data?.data?.userInfo?.email ||
      data?.userInfo?.email ||
      data?.user?.email ||
      data?.contact?.email ||
      (typeof window !== "undefined" && window.__STARMINT_CUSTOMER && window.__STARMINT_CUSTOMER.email
        ? String(window.__STARMINT_CUSTOMER.email).trim()
        : null) ||
      fallbackEmail ||
      supabaseContactFallback?.email ||
      supabaseContactFallback?.email_address ||
      supabaseUserFallback?.email ||
      null;

    if (!reserveOwnerEmail) {
      document.getElementById("loading").style.display = "none";
      document.getElementById("err-message-account-submit2").innerHTML = "We could not detect your account email. Please log in again and retry.";
      document.getElementById("err-message-account-submit2").style.display = "block";
      document.getElementById("err-message-account-submit2").style.color = "red";
      document.getElementById("err-message-account-submit2").style.textAlign = "center";
      document.getElementById("start-again2").style.display = "flex";
      document.getElementById("err-message-account-submit").style.display = "none";
      window.starmintReserveInFlight = false;
      return;
    }

    const reserveRecipient = isGiftReserve ? starmintResolveGiftRecipient(data) : null;

    const reserveDedicatedToName = isGiftReserve
      ? (reserveRecipient?.name || data?.data?.recipientInfo?.name || null)
      : reserveOwnerName;

    const reserveGiftedToEmail = isGiftReserve
      ? (reserveRecipient?.email || data?.data?.recipientInfo?.email || null)
      : null;

    console.log("[starmint] reserveStar gift payload", {
      isGiftReserve,
      gifted_to_email: reserveGiftedToEmail || null,
      dedicated_to_name: reserveDedicatedToName || null,
      owner_email: reserveOwnerEmail || null,
    });

    if (isGiftReserve && !reserveGiftedToEmail) {
      document.getElementById("loading").style.display = "none";
      document.getElementById("err-message-account-submit2").innerHTML =
        "Recipient email is missing. Please go back and enter the gift recipient details.";
      document.getElementById("err-message-account-submit2").style.display = "block";
      document.getElementById("err-message-account-submit2").style.color = "red";
      document.getElementById("err-message-account-submit2").style.textAlign = "center";
      document.getElementById("start-again2").style.display = "flex";
      document.getElementById("err-message-account-submit").style.display = "none";
      window.starmintReserveInFlight = false;
      return;
    }

    // Some catalog stars include a display-only leading "*"
    // (e.g. "* 126 Tau"), which can break backend validation for reserveStar.
    const reserveStarIdentifier = (current_star.identifier || "")
      .replace(/^\*\s*/, "")
      .replace(/[^\w\s-]/g, " ")
      .replace(/\s+/g, " ")
      .trim();
    const reserveRawIdentifier = String(current_star.identifier || "").replace(/^\*\s*/, "").trim();
    const reserveRA = String(current_star.ra || "").trim();
    const reserveDEC = String(current_star.dec || "").trim();
    const toDecimalCoordinate = (inputValue, isRA) => {
      const rawValue = String(inputValue || "").trim();
      if (!rawValue) return "";

      const hasHoursMarker = /h/i.test(rawValue);
      const hasDegreeMarker = /d|°/i.test(rawValue);
      const hasSexagesimalParts = /['"m]/i.test(rawValue) || /\s+\d+/.test(rawValue);

      if (!hasHoursMarker && !hasDegreeMarker && !hasSexagesimalParts) {
        const plain = parseFloat(rawValue);
        if (Number.isNaN(plain)) return "";
        if (isRA && Math.abs(plain) <= 24) {
          return (plain * 15).toFixed(8);
        }
        return plain.toFixed(8);
      }

      const sign = rawValue.trim().startsWith("-") ? -1 : 1;
      const cleaned = rawValue
        .replace(/[^\d.+\-]+/g, " ")
        .trim()
        .replace(/\s+/g, " ");
      const parts = cleaned.split(" ").map((v) => parseFloat(v)).filter((v) => Number.isFinite(v));
      if (!parts.length) return "";

      const a = Math.abs(parts[0] || 0);
      const b = parts[1] || 0;
      const c = parts[2] || 0;

      let decimal;
      if (hasHoursMarker) {
        decimal = (a + (b / 60) + (c / 3600)) * 15;
      } else {
        decimal = a + (b / 60) + (c / 3600);
        // If RA has no explicit marker but looks like hour-based sexagesimal, convert.
        if (isRA && !hasDegreeMarker && a <= 24) {
          decimal = decimal * 15;
        }
      }
      decimal = sign * decimal;
      return decimal.toFixed(8);
    };
    const reserveRADecimal = toDecimalCoordinate(reserveRA, true);
    const reserveDECDecimal = toDecimalCoordinate(reserveDEC, false);

    if (!reserveStarIdentifier && !reserveRawIdentifier) {
      document.getElementById("loading").style.display = "none";
      document.getElementById("err-message-account-submit2").innerHTML = "Unable to reserve star: star identifier is missing. Please reselect your star and retry.";
      document.getElementById("err-message-account-submit2").style.display = "block";
      document.getElementById("err-message-account-submit2").style.color = "red";
      document.getElementById("err-message-account-submit2").style.textAlign = "center";
      document.getElementById("start-again2").style.display = "flex";
      document.getElementById("err-message-account-submit").style.display = "none";
      window.starmintReserveInFlight = false;
      return;
    }
    if (!reserveRA || !reserveDEC) {
      document.getElementById("loading").style.display = "none";
      document.getElementById("err-message-account-submit2").innerHTML = "Unable to reserve star: star coordinates are missing. Please reselect your star and retry.";
      document.getElementById("err-message-account-submit2").style.display = "block";
      document.getElementById("err-message-account-submit2").style.color = "red";
      document.getElementById("err-message-account-submit2").style.textAlign = "center";
      document.getElementById("start-again2").style.display = "flex";
      document.getElementById("err-message-account-submit").style.display = "none";
      window.starmintReserveInFlight = false;
      return;
    }

    await window.starmintFetchWithRetry(API_HOST_STAR_SELECTORS_ALL + 'supabase/reserveStar', {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },

      body: JSON.stringify({

        star_name: starName,
        star_identifier: reserveStarIdentifier || reserveRawIdentifier,
        right_ascension_degrees: reserveRADecimal || reserveRA,
        declination_degrees: reserveDECDecimal || reserveDEC,

        dedicated_to_name: reserveDedicatedToName,
        dedicated_by_name: reserveOwnerName,

        owner_email: reserveOwnerEmail,
        owner_shopify_customer_id:
          data?.data?.userInfo?.shopifyAccountID ||
          data?.contact?.shopify_customer_id ||
          (typeof starmintResolveStorefrontCustomerId === "function" ? starmintResolveStorefrontCustomerId() : null) ||
          null,
        gifted_to_email: reserveGiftedToEmail,

        chart: current_star.chart,
        certificate_version: String(versionNow || "1"),
        naming_date: namingDate,
        show_date: !!showDate,
        show_message: !!showMessage,
        zodiac: current_star.zodiac || "",
        constellation: current_star.constellation || "",
        prewarm_both: true,

        metadata: {
          name: starName,
          date: namingDate,
          message: personalMessage,
          rawRightAscension: reserveRA,
          rawDeclination: reserveDEC,

          typ: current_star.typ,
          zodiac: current_star.zodiac,
          constellation: current_star.constellation,
          originalStarIdentifier: current_star.identifier,

          isGift: isGiftReserve,

          userShopifyAccountID: data?.data?.userInfo?.shopifyAccountID || data?.contact?.shopify_customer_id,
          userAccountId: data?.data?.userInfo?.accountID || data?.auth_user_id || data?.contact?.auth_user_id,
          userContactId: data?.data?.userInfo?.contactID || data?.contact?.id,

          recipientShopifyAccountID: data?.data?.recipientInfo?.shopifyAccountID,
          recipientAccountId: data?.data?.recipientInfo?.accountID,
          recipientContactId: data?.data?.recipientInfo?.contactID
        }

      })

    }).then(async (response) => {
      if (!response.ok) {
        let responseErrorMessage = "This star is not available right now.";
        try {
          const responseData = await response.json();
          responseErrorMessage =
            responseData?.message || responseData?.error || responseErrorMessage;
        } catch (e) {
          try {
            const rawError = await response.text();
            if (rawError && rawError.trim()) {
              responseErrorMessage = rawError.trim();
            }
          } catch (_ignoreTextReadError) {
            // Keep fallback when no readable body.
          }
        }

        if (!responseErrorMessage || responseErrorMessage === "This star is not available right now.") {
          responseErrorMessage = "Unable to reserve this star right now (HTTP " + response.status + ").";
        }

        document.getElementById("loading").style.display = "none";
        document.getElementById("err-message-account-submit2").innerHTML = responseErrorMessage;
        document.getElementById("err-message-account-submit2").style.display = "block";
        document.getElementById("err-message-account-submit2").style.color = "red";
        document.getElementById("err-message-account-submit2").style.textAlign = "center";

        // Friendly help for already reserved
        if (responseErrorMessage.toLowerCase().includes("already reserved")) {
          const recoveredStar = await starmintTryRecoverOwnedStar(
            reserveStarIdentifier || reserveRawIdentifier || current_star.identifier
          );
          if (recoveredStar) {
            return { success: true, data: recoveredStar };
          }
          document.getElementById("err-message-account-submit2").innerHTML = "<strong>Star Already Reserved:</strong> This star is already claimed. Please <a href='#' onclick='try{starmintClearStarFlowState();}catch(e){}window.location.href=\"/pages/select-a-star?starmint_fresh=1\";return false;' style='color: #f4cf7d; text-decoration: underline;'>choose a different star</a> or log in if it is yours.";
        }

        document.getElementById("start-again2").style.display = "flex";

        document.getElementById("err-message-account-submit").style.display = "none";

        // Re-enable buttons on error
        ["star-form-continue-01", "star-form-continue-1", "signup-claim-star"].forEach(id => {
          const btn = document.getElementById(id);
          if (btn) {
            btn.disabled = false;
            btn.textContent = (id === "signup-claim-star") ? "Reserve Star" : "Continue";
          }
        });
        const handledReserveError = new Error(responseErrorMessage);
        handledReserveError.handledReserveError = true;
        throw handledReserveError;
      }
      return response.json();
    })
      .then(async (responseData) => {
        console.log("data from /reserveStar", responseData)
        if (responseData.success == false) {
          const responseErrorMessage = responseData.message || responseData.error || responseData.err || 'This star is already reserved or unavailable. Please choose another star.';

          if (responseErrorMessage.toLowerCase().includes("already reserved")) {
            const recoveredStar = await starmintTryRecoverOwnedStar(
              reserveStarIdentifier || reserveRawIdentifier || current_star.identifier
            );
            if (recoveredStar) {
              responseData = { success: true, data: recoveredStar };
            }
          }

          if (responseData.success !== false) {
            // fall through to success handling below
          } else {
          document.getElementById("loading").style.display = "none";
          document.getElementById("err-message-account-submit2").innerHTML = responseErrorMessage;
          document.getElementById("err-message-account-submit2").style.display = "block";
          document.getElementById("err-message-account-submit2").style.color = "red";
          document.getElementById("err-message-account-submit2").style.textAlign = "center";

          if (responseErrorMessage.toLowerCase().includes("already reserved")) {
            document.getElementById("err-message-account-submit2").innerHTML = "<strong>Star Already Reserved:</strong> This star is already claimed. Please <a href='#' onclick='try{starmintClearStarFlowState();}catch(e){}window.location.href=\"/pages/select-a-star?starmint_fresh=1\";return false;' style='color: #f4cf7d; text-decoration: underline;'>choose a different star</a> or log in if it is yours.";
          }

          if (responseErrorMessage.includes("You can only claim 5")) {
            document.getElementById("err-message-account-submit").style.display = "none";
            let restartButton = document.getElementById("start-again2");
            restartButton.href = "/pages/my-stars";
            restartButton.textContent = "View Your Stars";
            restartButton.style.width = "160px";
            restartButton.style.display = "flex";
          } else {
            document.getElementById("start-again2").style.display = "flex";
          }

          // Re-enable buttons on error
          ["star-form-continue-01", "star-form-continue-1", "signup-claim-star"].forEach(id => {
            const btn = document.getElementById(id);
            if (btn) {
              btn.disabled = false;
              btn.style.display = "inline-block";
              btn.textContent = (id === "signup-claim-star") ? "Reserve Star" : "Continue";
            }
          });

          // document.getElementById("signup-claim-star").style.display = "inline-block";
          const handledReserveError = new Error(responseErrorMessage);
          handledReserveError.handledReserveError = true;
          throw handledReserveError;
          return false;
          }
        }




        // document.getElementById("loading").innerHTML = "";


        document.getElementById("loading").style.display = "block";

        let variantGiftId;
        // Assuming data.data.id is defined and holds the ID value you want to append
        let starIdValue = responseData.data.id;
        console.log('starIdValue!!!, variantId, quantity', starIdValue, variantId, quantity)
        current_star.id = starIdValue
        reserve_star = cloneStarContext(current_star);
        if (!personalizationStarSource) {
          personalizationStarSource = "reserve";
        }

        // Pre-warm certificates in background immediately after reservation
        autoGenerateCertificateIfNeeded({
          targetVersion: versionNow,
          prewarmBoth: true,
          immediate: true,
        });

        document.getElementById("loading").style.display = "none";
        if (typeof window.starmintSyncHeader === 'function') {
          window.starmintSyncHeader();
        }

        const reservedDisplayName =
          String(starName || "").trim() ||
          String(current_star?.name || "").trim() ||
          (document.getElementById("starName") && String(document.getElementById("starName").value || "").trim()) ||
          (current_star?.identifier ? String(current_star.identifier).substring(0, 20).trim() : "");
        current_star.name = reservedDisplayName;

        let propertiesData = starmintBuildCartProperties(
          Object.assign({}, current_star, { name: reservedDisplayName }),
          {},
          data
        );

        let starRegistrationFormData = {
          'items': [{
            'id': current_star.premium == 2 ? '46442322821422' : '46442303193390',
            'quantity': 1,
            'properties': propertiesData
          }
          ]
        };

        // Persist star name and preview context for other pages (like theme.liquid personalization)
        localStorage.setItem("starmint_selected_star_name", reservedDisplayName || "");
        localStorage.setItem("starmint_preview_context", JSON.stringify({
          id: starIdValue?.toString(),
          name: reservedDisplayName || "",
          chart: current_star.chart,
          certificate: current_star.certificate
        }));

        addToCart(starRegistrationFormData, false);
        starmintClearStarFlowState();

        if (!product_slug) {



          // PREVIEW MODAL
          let containers = document.querySelectorAll('.personalize-button-container');

          if (containers) {
            containers.forEach(function (container) {

              let linkElement = container.querySelector('a');

              if (linkElement) {
                let variantId = linkElement.getAttribute('data-variant-id');
                console.log('Variant ID:', variantId);
                let newLinkElement = document.createElement('a');

                newLinkElement.href = '';
                newLinkElement.textContent = 'Preview';
                newLinkElement.classList.add("previewLink");

                // Attach the showPreviewModal function to its click event
                newLinkElement.addEventListener('click', (event) => {
                  event.preventDefault();
                  console.log("variantId, id, chartUrl, certificate", variantId, current_star.id, current_star.chart, current_star.certificate)
                  let target = event.target;
                  if (target) {
                    event.preventDefault();
                    showPreviewModal(event, variantId, current_star.id, current_star.chart, current_star.certificate);

                  }
                });

                // Append the new 'a' element below the container
                container.insertAdjacentElement('afterend', newLinkElement);

              }
            });
          }

          // PREVIEW MODAL END


          // Keep inline gift grid hidden; gift selection happens on collection page.
          shopGiftsWrapper.style.display = 'none';
          productDetailsWrapper.style.display = 'none';

        }

        if (variantId) {
          console.log("variantId, starIdValue, current_star.chart, current_star.certificate", variantId, starIdValue, current_star.chart, current_star.certificate);
          const previewLink = document.getElementById('previewAnchor');
          previewLink.addEventListener('click', (event) => {
            event.preventDefault();  // Prevent the default action
            showPreviewModal(event, variantId, starIdValue, current_star.chart, current_star.certificate);
          });
          previewLink.style.display = "block";
        }
        const normalizeCoord = (val, suffix) => {
          const s = String(val ?? '').trim();
          if (!s) return s;
          // already formatted (has h or d)
          if (/[hd]/i.test(s)) return s;
          // if it contains ' (minutes) or " (seconds) but no h/d, it's still not acceptable => treat as numeric prefix
          const numeric = parseFloat(s.replace(/[^0-9.\-+]/g, ''));
          if (!Number.isNaN(numeric)) return `${numeric}${suffix}`;
          return s;
        };

        const raInput = normalizeCoord(current_star.ra, 'h');
        const decInput = normalizeCoord(current_star.dec, 'd');

        let degreeRA = hmsToDegreesString(raInput);
        let degreeDEC = hmsToDegreesString(decInput);
        console.log(current_star.ra, current_star.dec, degreeRA, degreeDEC, 'we have current star coords here')

        let currentStarIdentifierReplaced = current_star.identifier.replace(/\s/g, '');
        if (typeof current_star?.chart != 'undefined' && current_star?.chart != null && current_star?.chart?.length) {
          imageChartURL = current_star.chart;
          imagechartHTML = `
                          <img
                            src="${current_star.chart}"
                            alt="Star Chart Image For ${current_star.identifier}"
                         
                            data-src-for-chartIdentifier='${currentStarIdentifierReplaced}'
                          >
                        `
          generateCertificate(
            current_star.id,
            current_star.chart,
            showDate,
            showMessage,
            namingDate,
            starName || current_star.name || document.getElementById("starName")?.value?.trim() || ""
          );
          //generateCertificate(starId, chart, showDate, showMessage, namingDate)
        } else {

          let findLoadedChart = document.querySelectorAll(`[data-src-for-chartIdentifier='${currentStarIdentifierReplaced}']`);
          console.log(findLoadedChart, ' is findloadedchart');
          let lastsrcapplied = false,
            srcToApply = '';
          findLoadedChart?.forEach(chart => {
            let src = chart.getAttribute('src');
            if (src && src?.length && lastsrcapplied != src && src.indexOf('starmint-default-chart') === -1) {
              lastsrcapplied = src;
              srcToApply = src;
              current_star.chart = src;
              generateAddToCartButtonSettings();
            }
            // else {
            //   console.log(src, src?.length, lastsrcapplied)
            // }

            // console.log(chart.getAttribute('src'), ' chart src ')
          })

          if (srcToApply != '') {
            console.log(srcToApply, 'have srctoapply')
            imageChartURL = srcToApply;
            imagechartHTML = `
                          <img
                            src="${srcToApply}"
                            alt="Star Chart Image For ${current_star.identifier}"
                           
                            data-src-for-chartIdentifier='${current_star.identifier.replace(/\s/g, '')}'
                          >
                        `
            // generateCertificate(current_star.id, srcToApply, false, false, namingDate);
            generateCertificate(
              starId,
              chart,
              showDate,
              showMessage,
              namingDate,
              starName || current_star.name || document.getElementById("starName")?.value?.trim() || ""
            );
          } else {
            console.log(srcToApply, 'DO NOT have srctoapply')
            imageChartURL = window.__STARMINT_STAR_SELECTORS__.defaultChartUrl;
            imagechartHTML = `
                          <img
                            src="${window.__STARMINT_STAR_SELECTORS__.defaultChartUrl}"
                            alt="Star Chart Image For ${current_star.identifier}"
                           
                            data-src-for-chartIdentifier='${current_star.identifier.replace(/\s/g, '')}'
                            
                          >
                        `
          }
        }



        let starFinishChartImage = document.getElementById("star-finish-chart-image");
        // document.getElementById("star-finish-chart-image").innerHTML = imagechartHTML
        starFinishChartImage.setAttribute("data-src-for-chartIdentifier", current_star.identifier.replace(/\s/g, ''));
        starFinishChartImage.style.backgroundImage = `url(${imageChartURL})`;


        document.getElementById("star-finish-name").innerHTML = "Star Name: " + starName;
        updateCertificateStarNameDisplay();
        document.getElementById("star-finish-identifier").innerHTML = "Your Star <br/><span style='font-weight: 600;'>" + current_star.identifier + "</span>";
        document.getElementById("star-finish-coordinates").innerHTML = `Right Ascension: ${degreeRA}<br />Declination: ${degreeDEC}`
        document.getElementById("star-finish-date").innerHTML = "Date: " + namingDate;
        if (personalMessage) {
          document.getElementById("star-finish-message").innerHTML = "Message: " + personalMessage;
        }
        if (current_star.zodiac) {
          document.getElementById("star-finish-zodiac").innerHTML = "Zodiac: " + current_star.zodiac;
        }
        if (current_star.constellation) {
          document.getElementById("star-finish-constellation").innerHTML = "Constellation: " + current_star.constellation;
        }

        let starSelectFinishContainer = document.getElementById("star-select-finish");
        starSelectFinishContainer.style.display = "block";
        document.getElementById("star-select-confirm-results").style.display = "none";
        // hide the progress bar
        document.getElementsByClassName("circle-outer-container")[0].style.display = "none";

        scrollToElement(starSelectFinishContainer);

        // Keep inline gift UI disabled on this page.
        let productDWrapper = document.getElementById("productDetailsWrapper");
        if (productDWrapper) {
          productDWrapper.style.display = "none";
        }


        // Your formData setup
        let formData = {
          'items': []
        };

        // Populate formData based on variantId (skip if same as registration variant — already added)
        const registrationVariantId =
          current_star.premium == 2 ? "46442322821422" : "46442303193390";
        if (variantId && String(variantId) !== String(registrationVariantId)) {
          console.log("current star:", current_star);
          formData.items.push({
            'id': variantId,
            'quantity': Number(quantity),
            'properties': starmintBuildCartProperties(
              Object.assign({}, current_star, { name: reservedDisplayName }),
              {},
              data
            )
          });

          // Call addToCart immediately
          addToCart(formData);
        }

        function scrollToGenerateCertificateContainer(element) {
          let certificateContainer = document.getElementById("certificate-container");
          if (certificateContainer) {
            const elementOffset = certificateContainer.getBoundingClientRect().top + window.scrollY;
            requestAnimationFrame(() => {
              window.scrollTo({
                top: elementOffset,
                behavior: 'smooth' // You can change this to 'auto' for an instant scroll
              });
            });
          }
        }

        // Get all buttons with the class '.custom-add-to-cart'
        const addToCartButtons = document.querySelectorAll('.custom-add-to-cart');





      }) //END THEN RESPONSE OF RESERVESTAR
      .catch(error => {
        if (!error?.handledReserveError) {
          console.error("reserveStar error:", error);
        }
        document.getElementById("loading").style.display = "none";
        if (!error?.handledReserveError) {
          document.getElementById("err-message-account-submit2").innerHTML = error.message || "An unexpected error occurred while reserving your star. Please try again.";
          document.getElementById("err-message-account-submit2").style.display = "block";
          document.getElementById("err-message-account-submit2").style.color = "red";
          document.getElementById("err-message-account-submit2").style.textAlign = "center";
          document.getElementById("start-again2").style.display = "flex";
        }
      })
      .finally(function () {
        window.starmintReserveInFlight = false;
      });
  }




  function checkImage(url) {
    var img = new Image();
    return new Promise((resolve, reject) => {
      img.onload = function () {
        // Image exists and is valid
        resolve(true);
      };

      img.onerror = function () {
        // Image does not exist or is not valid
        reject(false);
      };

      img.src = url;
    });
  }

  function checkImageWithInterval(url, maxAttempts, intervalTime, callback) {
    let attempts = 0;
    const intervalId = setInterval(function () {
      attempts++;

      checkImage(url)
        .then(function (exists) {
          if (exists) {
            clearInterval(intervalId); // Stop the interval
            callback(true);
          } else if (attempts >= maxAttempts) {
            clearInterval(intervalId); // Stop the interval
            callback(false);
          }
        })
        .catch(function () {
          if (attempts >= maxAttempts) {
            clearInterval(intervalId); // Stop the interval
            callback(false);
          }
        });
    }, intervalTime);
  }


  // Define the zodiac signs and their date ranges 
  let zodiacSigns = {
    "Aries": { startMonth: 3, startDate: 21, endMonth: 4, endDate: 19 },
    "Taurus": { startMonth: 4, startDate: 20, endMonth: 5, endDate: 20 },
    "Gemini": { startMonth: 5, startDate: 21, endMonth: 6, endDate: 20 },
    "Cancer": { startMonth: 6, startDate: 21, endMonth: 7, endDate: 22 },
    "Leo": { startMonth: 7, startDate: 23, endMonth: 8, endDate: 22 },
    "Virgo": { startMonth: 8, startDate: 23, endMonth: 9, endDate: 22 },
    "Libra": { startMonth: 9, startDate: 23, endMonth: 10, endDate: 22 },
    "Scorpio": { startMonth: 10, startDate: 23, endMonth: 11, endDate: 21 },
    "Sagittarius": { startMonth: 11, startDate: 22, endMonth: 12, endDate: 21 },
    "Capricorn": { startMonth: 12, startDate: 22, endMonth: 1, endDate: 19 },
    "Aquarius": { startMonth: 1, startDate: 20, endMonth: 2, endDate: 18 },
    "Pisces": { startMonth: 2, startDate: 19, endMonth: 3, endDate: 20 }
  };



  function get3randomStars(data, selector) {
    console.log(data, selector, ' is the 3 random new stars from data set ');

    let resultsContainer = document.getElementById(selector);
    if (!resultsContainer) return;

    resultsContainer.innerHTML = '';

    // shuffle the stars data, so it returns at most 3 random ones from the data
    data = Array.from(data);
    data = data.sort(() => Math.random() - 0.5);

    const numStars = (data?.length >= 3 ? 3 : data?.length);

    // Show loading state: update header text and disable select buttons once rendered
    const _resultsParent = resultsContainer.closest('.star-selection-data-results') || resultsContainer.parentElement;
    const _foundTextEl = _resultsParent ? Array.from(_resultsParent.querySelectorAll('p.paragraph-color')).find(function (p) { return p.textContent.includes("found these available"); }) : null;
    if (_foundTextEl) _foundTextEl.textContent = "Searching the universe for available stars…";

    let _chartsSettled = 0;
    const _fallbackTimer = setTimeout(function () {
      _onAllChartsSettled();
    }, 15000);

    function _onAllChartsSettled() {
      clearTimeout(_fallbackTimer);
      if (_foundTextEl) _foundTextEl.textContent = "We’ve found these available stars:";
      resultsContainer.querySelectorAll('button[select-star-identifier]').forEach(function (b) { b.disabled = false; });
    }

    function _onChartSettled() {
      _chartsSettled++;
      if (_chartsSettled >= numStars) _onAllChartsSettled();
    }

    for (let x = 0; x < numStars; x++) {
      // Normalize identifiers and DOM ids
      let chartIdentifierOriginal = data[x]?.identifier || `Star-${x + 1}`;
      let chartIdentifier = String(chartIdentifierOriginal).replace(/\s/g, '');

      // Prefer degree fields (random API), fallback to existing coordinate fields (constellation API)
      const raHours = (
        (typeof data[x]?.ra_deg !== 'undefined' && data[x]?.ra_deg !== null)
          ? (Number(data[x].ra_deg) / 15)
          : (data[x]?.coordinates?.unitsRA || data[x]?.coordinates?.ra_string || data[x]?.ra_string || data[x]?.ra)
      );

      const decDeg = (
        (typeof data[x]?.dec_deg !== 'undefined' && data[x]?.dec_deg !== null)
          ? Number(data[x].dec_deg)
          : (data[x]?.coordinates?.unitsDEC || data[x]?.coordinates?.dec_string || data[x]?.dec_string || data[x]?.dec)
      );

      // Create item container — show default chart immediately so users see stars while charts generate
      const defaultChartUrl = window.__STARMINT_STAR_SELECTORS__?.defaultChartUrl || "";
      const itemHtml = `
      <div class='data-results-item'>
        <div id='${chartIdentifier}' class="chart-img-height">
          <img
            src="${defaultChartUrl}"
            alt="Star chart for ${chartIdentifierOriginal}"
            class="chart-img-height chart-img-loading"
          />
        </div>

        <p class="paragraph-color">${chartIdentifierOriginal}</p>

        <button
          id='select-button-${chartIdentifier}'
          class='button button--primary'
          select-star-identifier='${chartIdentifierOriginal}'
          select-star-ra='${raHours}'
          select-star-dec='${decDeg}'
          typ='${data[x]?.typ || ""}'
        >
          Select This Star
        </button>
      </div>
    `;
      resultsContainer.insertAdjacentHTML('beforeend', itemHtml);

      // Fetch the real chart in the background and swap the placeholder when ready
      const chartApiUrl = `https://star.thestarmint.com/api/chart/create?ra=${encodeURIComponent(raHours)}&dec=${encodeURIComponent(decDeg)}&starName=${encodeURIComponent(chartIdentifierOriginal || '')}`;

      // Stagger the requests to avoid slamming the backend with simultaneous generations
      setTimeout(() => {
        window.starmintFetchWithRetry(chartApiUrl, {
          method: 'GET',
          __retry: { silent: true, retries: 3, backoff: 2500 }
        })
          .then(response => response.json())
          .then(chartRes => {
            console.log("data from image char api:", chartRes);

            const imageUrl = chartRes?.imageUrl || chartRes?.imageLink || "";
            const el = document.getElementById(chartIdentifier);
            if (!el) return;

            if (!imageUrl) {
              _onChartSettled();
              return;
            }

            if (current_star.identifier == chartIdentifierOriginal) {
              current_star.chart = imageUrl;
              generateAddToCartButtonSettings();
            }

            const btn = document.getElementById(`select-button-${chartIdentifier}`);
            if (btn) btn.setAttribute('select-star-chart', imageUrl);

            el.innerHTML = `
              <img class='data-result-item-img chart-img-height'
                   src='${imageUrl}'
                   alt="Star Chart Image For ${chartIdentifierOriginal}"
                   onerror="this.onerror=null;this.src='${defaultChartUrl}';"
                   data-src-for-chartIdentifier='${chartIdentifierOriginal}' />
            `;
            _onChartSettled();
          })
          .catch(err => {
            console.log("chart create error after retries:", err);
            _onChartSettled();
          });
      }, x * 1000);
    }
  }


  document.getElementById("star-select-zodiac").addEventListener("click", function (e) { // transition 777
    e.preventDefault();
    setActivePage(1);


    // HIDING OTHER SECTIONS THAT COULD BE VISIBLE
    document.getElementById("star-select-zodiac-results").style.display = "none";
    document.getElementById("star-select-zodiacs-list").style.display = "none";
    document.getElementById("star-select-constellation-results").style.display = "none";
    document.getElementById("constellation-drop").style.display = "none";
    document.getElementById("byIdentifier-drop").style.display = "none";
    document.getElementById("byNightsky-drop").style.display = "none";
    document.getElementById("star-select-byIdentifier-results").style.display = "none";
    document.getElementById("star-select-byNightsky-results").style.display = "none";
    document.getElementById("star-select-random-results").style.display = "none";
    document.getElementById("star-select-confirm-results").style.display = "none";

    console.log("zodiac clicked")
    // PUT ZODIAC SIGN CARD CLICK FUNCTION HERE, TO BE USED FOR SIGN CARD OR THE MONTH/DATE INPUT



    function handleZodiacCardClick(ra, dec, zodiacImage, zodiacDescription, constellationName) {
      // /*SLIDE1*/ document.getElementById("star-selectors-start").style.display = "none";

      setActivePage(2);

      document.getElementById("byZodiacConstellationError").innerHTML = "";
      document.getElementById("byZodiacConstellationError").style.display = "none";

      const zodiacPreviewImage = document.querySelector(".zodiac-results-blurb-image img");
      if (zodiacPreviewImage) {
        zodiacPreviewImage.onerror = function () {
          this.onerror = null;
          this.src = window.__STARMINT_STAR_SELECTORS__.defaultChartUrl;
        };
        zodiacPreviewImage.setAttribute("src", zodiacImage);
      }
      document.querySelector(".zodiac-results-blurb p").innerHTML = zodiacDescription;

      let lowercaseConstellation = constellationName.toLowerCase()

      window.starmintFetchWithRetry(`https://star.thestarmint.com/api/stars/byConstellation?constellation=${lowercaseConstellation}`, {
        method: 'GET',
        headers: {
          // 'Authorization': 'Basic ' + authString 
        }
      }).then(response => response.json())
        .then(data => {
          // Here you can handle your data.
          console.log(data);
          if (data && data?.length > 0) {
            let resultsContainer = document.getElementById("star-select-zodiac-results-inner");
            resultsContainer.innerHTML = '';

            // document.getElementById("reload-star-zodiac").setAttribute("stars", data)
            document.getElementById("reload-star-zodiac").addEventListener("click", function (event) {
              event.preventDefault();
              get3randomStars(data, "star-select-zodiac-results-inner");
              document.querySelectorAll("#star-select-zodiac-results-inner .data-results-item [select-star-identifier]").forEach(starIdentifier => {

                starIdentifier.addEventListener("click", function (e) { // transition
                  e.preventDefault();
                  // init();
                  setActivePage(2);
                  // scrollToElement(document.getElementById("star-select-zodiac-results"));
                  // document.getElementById("star-select-zodiacs-list").style.display = "none";
                  console.log("hey!")
                  current_star.identifier = this.getAttribute('select-star-identifier'),
                    current_star.ra = this.getAttribute('select-star-ra'),
                    current_star.dec = this.getAttribute('select-star-dec');
                  current_star.chart = this.getAttribute('select-star-chart');
                  generateAddToCartButtonSettings();
                  current_star.premium = this.getAttribute('premium');
                  current_star.typ = this.getAttribute('typ');

                  if (typeof window.starmintTriggerFastReservation === "function") {
                    window.starmintTriggerFastReservation();
                  }





                  if (typeof current_star?.chart != 'undefined' && current_star?.chart != null && current_star?.chart?.length) {
                    console.log(current_star, ' is the maybe null')
                    imageChartURL = `${current_star.chart}`;
                    imagechartHTML = `
                                    <img
                                      src="${current_star.chart}"
                                      alt="Star Chart Image For ${current_star.identifier}"
                                      class="chart-img-height"
                                      data-src-for-chartIdentifier='${current_star.identifier}'
                                    >
                                  `
                  } else {
                    console.log('its null lets use default')
                    imageChartURL = window.__STARMINT_STAR_SELECTORS__.defaultChartUrl;
                    imagechartHTML = `
                                    <img
                                      src="${window.__STARMINT_STAR_SELECTORS__.defaultChartUrl}"
                                      alt="Star Chart Image For ${current_star.identifier}"
                                      class="chart-img-height"
                                      data-src-for-chartIdentifier='${current_star.identifier}'
                                    >
                                  `
                  }
                  document.getElementById("chart-image").innerHTML = imagechartHTML;


                  let degreeRA = hmsToDegreesString(current_star.ra, 'ra');
                  let degreeDEC = hmsToDegreesString(current_star.dec, 'dec');
                  console.log("degree RA DEC: ", degreeRA, degreeDEC)
                  let starHTML =
                    `
                                  <p class="paragraph-color font-size20" style="margin-top:30px">Your star</p>
                                  <p class="paragraph-color font-size20-600">${current_star.identifier}</p>
                                  <p class="paragraph-color font-size20">Right Ascension: ${degreeRA}<br />Declination: ${degreeDEC}</p>
                                `
                  document.getElementById("star-select-confirm-stats").innerHTML = starHTML;

                  // document.getElementById("star-select-zodiac-results").style.display = "none";

                  // transition

                  // document.getElementById("star-select-zodiac-results").style.display = "none";

                  let starSelectConfirmResults = document.getElementById("star-select-confirm-results");
                  starSelectConfirmResults.style.display = "block";
                  // AUTOMATION: Fast path to reservation
                  if (typeof window.starmintTriggerFastReservation === "function") {
                    window.starmintTriggerFastReservation();
                  }
                  scrollToElement(starSelectConfirmResults); // 9999


                });

              });
            })
            get3randomStars(data, "star-select-zodiac-results-inner")



            document.getElementById("star-select-zodiac-results").style.display = "block";

            resultsContainer.style.display = "grid";

            scrollToElement(document.getElementById("star-select-zodiac-results"));

            document.querySelectorAll("#star-select-zodiac-results-inner .data-results-item [select-star-identifier]").forEach(starIdentifier => {

              starIdentifier.addEventListener("click", function (e) { // transition
                e.preventDefault();
                // init();
                setActivePage(2);
                // scrollToElement(document.getElementById("star-select-zodiac-results"));
                // document.getElementById("star-select-zodiacs-list").style.display = "none";
                console.log("hey!")
                current_star.identifier = this.getAttribute('select-star-identifier'),
                  current_star.ra = this.getAttribute('select-star-ra'),
                  current_star.dec = this.getAttribute('select-star-dec');
                current_star.chart = this.getAttribute('select-star-chart');
                generateAddToCartButtonSettings();
                current_star.premium = this.getAttribute('premium');
                current_star.typ = this.getAttribute('typ');

                if (typeof window.starmintTriggerFastReservation === "function") {
                  window.starmintTriggerFastReservation();
                }

                document.getElementById("star-select-zodiacs-list").style.display = "none";




                if (typeof current_star?.chart != 'undefined' && current_star?.chart != null && current_star?.chart?.length) {
                  console.log(current_star, ' is the maybe null')
                  imageChartURL = `${current_star.chart}`;
                  imagechartHTML = `
                                    <img
                                      src="${current_star.chart}"
                                      alt="Star Chart Image For ${current_star.identifier}"
                                      class="chart-img-height"
                                      data-src-for-chartIdentifier='${current_star.identifier}'
                                    >
                                  `
                } else {
                  console.log('its null lets use default')
                  imageChartURL = window.__STARMINT_STAR_SELECTORS__.defaultChartUrl;
                  imagechartHTML = `
                                    <img
                                      src="${window.__STARMINT_STAR_SELECTORS__.defaultChartUrl}"
                                      alt="Star Chart Image For ${current_star.identifier}"
                                      class="chart-img-height"
                                      data-src-for-chartIdentifier='${current_star.identifier}'
                                    >
                                  `
                }
                document.getElementById("chart-image").innerHTML = imagechartHTML;


                let degreeRA = hmsToDegreesString(current_star.ra)
                let degreeDEC = hmsToDegreesString(current_star.dec)
                console.log("degree RA DEC: ", degreeRA, degreeDEC)
                let starHTML =
                  `
                                  <p class="paragraph-color font-size20" style="margin-top:30px">Your star</p>
                                  <p class="paragraph-color font-size20-600">${current_star.identifier}</p>
                                  <p class="paragraph-color font-size20">Right Ascension: ${degreeRA}<br />Declination: ${degreeDEC}</p>
                                `
                document.getElementById("star-select-confirm-stats").innerHTML = starHTML;

                // document.getElementById("star-select-zodiac-results").style.display = "none";

                // transition

                // document.getElementById("star-select-zodiac-results").style.display = "none";


                let starSelectConfirmResults = document.getElementById("star-select-confirm-results");
                starSelectConfirmResults.style.display = "block";
                scrollToElement(starSelectConfirmResults);


              });

            });
          } else {
            console.log('could not find constellation data - zodiac')
            document.getElementById("byZodiacConstellationError").innerHTML = "Unfortunately we cannot find any unclaimed stars from this zodiac sign's constellation.";
            document.getElementById("byZodiacConstellationError").style.display = "block";
            scrollToElement(document.getElementById("byZodiacConstellationError"));
          }
        }).catch(error => {
          console.error('Error:', error);
          console.log('could not find constellation data - zodiac 2')
          document.getElementById("byZodiacConstellationError").innerHTML = "Unfortunately we cannot find any unclaimed stars from this zodiac sign's constellation.";
          document.getElementById("byZodiacConstellationError").style.display = "block";
          scrollToElement(document.getElementById("byZodiacConstellationError"));
        });
    }



    window.starmintFetchWithRetry(API_HOST_STAR_SELECTORS_ALL + 'zodiacs/list', {
      method: 'GET',
      headers: {
        // 'Authorization': 'Basic ' + authString
      }
    }).then(response => response.json())
      .then(data => {
        let zodiacHtml = ``;
        let zodiacSings = [];
        data?.map(sign => {
          zodiacHtml += `<div class='zodiac-sign-card background-solid-color' data-zodiac-name='${sign.name}' data-zodiac-ra='${sign.ra}' data-zodiac-dec='${sign.dec}' data-zodiac-description='${sign.description}' data-zodiac-image='${sign.image}' data-zodiac-constellation='${sign.constellation}' ><img src="${SITE_HOST_STAR_SELECTORS_ALL}${sign.image}" /><span class="paragraph-color paragraph-uppercase">${sign.name}</span><small class="paragraph-color">${sign.date}</small></div>`;
          // UPDATE DATA FOR zodiacSigns
          if (sign.name in zodiacSigns) {
            zodiacSigns[sign.name]["ra"] = sign.ra;
            zodiacSigns[sign.name]["dec"] = sign.dec;
            zodiacSigns[sign.name]["image"] = sign.image;
            zodiacSigns[sign.name]["description"] = sign.description;
            zodiacSigns[sign.name]["constellation"] = sign.constellation;

          }
        })
        console.log("zodiacSigns", zodiacSigns);
        document.getElementById("star-select-zodiacs-list-inner").innerHTML = zodiacHtml;
        //document.getElementById("star-selectors-start").style.display = "none";
        document.getElementById("star-select-random-results").style.display = "none";
        document.getElementById("star-select-constellations-list").style.display = "none";
        document.getElementById("constellation-drop").style.display = "none";
        // document.getElementById("star-select-random-confirm").style.display = "none";
        document.getElementById("star-select-constellation-results").style.display = "none";
        document.getElementById("byIdentifier-drop").style.display = "none";
        document.getElementById("byNightsky-drop").style.display = "none";

        // FOR MONTH DATE INPUT
        document.getElementById("birthday-month").addEventListener("change", populateDateOptions);

        document.getElementById("find-star-button").addEventListener("click", function () {
          const monthInput = parseInt(document.getElementById("birthday-month").value);
          const dateInput = parseInt(document.getElementById("birthday-date").value);

          // Check for valid inputs 
          if (isNaN(monthInput) || isNaN(dateInput) || monthInput < 1 || monthInput > 12 || dateInput < 1 || dateInput > 31) {
            alert("Please enter valid month and date values.");
            return;
          }


          // Find the corresponding zodiac sign
          let foundSign = null;
          for (const sign in zodiacSigns) {
            if ((monthInput == zodiacSigns[sign].startMonth && dateInput >= zodiacSigns[sign].startDate) || (monthInput == zodiacSigns[sign].endMonth && dateInput <= zodiacSigns[sign].endDate)) {
              foundSign = zodiacSigns[sign];
              break;
            }
          }
          console.log("foundSign:", foundSign)

          if (!foundSign) {
            alert("Please select a valid birthday month and day.");
            return;
          }

          handleZodiacCardClick(foundSign.ra, foundSign.dec, SITE_HOST_STAR_SELECTORS_ALL + foundSign.image, foundSign.description, foundSign.constellation);

        });

        // Populate date options initially
        populateDateOptions();



        document.querySelectorAll(".zodiac-sign-card").forEach(zodiacCard => {
          const ra = zodiacCard.getAttribute("data-zodiac-ra");
          const dec = zodiacCard.getAttribute("data-zodiac-dec");
          const zodiacImage = SITE_HOST_STAR_SELECTORS_ALL + zodiacCard.getAttribute('data-zodiac-image');
          const zodiacDescription = zodiacCard.getAttribute('data-zodiac-description');
          const constellation = zodiacCard.getAttribute('data-zodiac-constellation');

          zodiacCard.addEventListener("click", function (e) {
            e.preventDefault();
            current_star.zodiac = this.getAttribute('data-zodiac-name');
            current_star.constellation = "";
            console.log("current_star after add zodiac", current_star)
            handleZodiacCardClick(ra, dec, zodiacImage, zodiacDescription, constellation);
            // document.getElementById("reload-star-zodiac").setAttribute("ra", ra)
            // document.getElementById("reload-star-zodiac").setAttribute("dec", dec)

          })
        });


        document.getElementById("star-select-zodiacs-list").style.display = "block";
        scrollToElement(document.getElementById("star-select-zodiacs-list"));   // transition  


        console.log(data, ' is zodiac data');

      }).catch(error => {
        console.error('Error:', error);
      });

  })

  document.querySelectorAll("[select-button-type='random']").forEach(button => {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      setActivePage(1);

      // HIDING OTHER SECTIONS THAT COULD BE VISIBLE
      document.getElementById("star-select-zodiac-results").style.display = "none";
      document.getElementById("star-select-zodiacs-list").style.display = "none";
      document.getElementById("star-select-constellation-results").style.display = "none";
      document.getElementById("constellation-drop").style.display = "none";
      document.getElementById("star-select-constellations-list").style.display = "none";
      document.getElementById("byIdentifier-drop").style.display = "none";
      document.getElementById("star-select-byIdentifier-results").style.display = "none";
      document.getElementById("byNightsky-drop").style.display = "none";
      document.getElementById("star-select-byNightsky-results").style.display = "none";
      document.getElementById("star-select-random-results").style.display = "block";
      document.getElementById("star-select-confirm-results").style.display = "none";


      if (document.getElementById("star-selectors-start")) document.getElementById("star-selectors-start").style.display = "none";

      document.getElementById("star-select-random-results-inner").style.display = "grid";
      document.getElementById("star-select-random-results-inner").innerHTML = '<div style="grid-column: 1 / -1; display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 200px;"><div class="loading-overlay__spinner" style="width: 40px;"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div><p class="paragraph-color" style="margin-top: 1.5rem; font-size: 1.2rem;">Searching the cosmos...</p></div>';


      // var applicationId = 'YOUR_APPLICATION_ID';
      // var applicationSecret = 'YOUR_APPLICATION_SECRET';
      // var authString = btoa(`${applicationId}:${applicationSecret}`);

      window.starmintFetchWithRetry('https://star.thestarmint.com/api/stars/random', {
        method: 'GET',
        __retry: { silent: true, retries: 2, backoff: 800 },
        headers: {
          // 'Authorization': 'Basic ' + authString
        }
      }).then(response => response.json())
        .then(data => {
          if (data && data?.length) {
            // Fast path: reuse shared renderer with built-in fallbacks so
            // random stars load quickly even when chart API is unstable.
            get3randomStars(data, "star-select-random-results-inner");
            document.getElementById("star-select-random-results").style.display = "block";
            scrollToElement(document.getElementById("star-select-random-results"));

            document.querySelectorAll("#star-select-random-results-inner .data-results-item [select-star-identifier]").forEach(starIdentifier => {
              starIdentifier.addEventListener("click", function (e) {
                e.preventDefault();
                setActivePage(2);
                current_star.identifier = this.getAttribute('select-star-identifier');
                current_star.ra = this.getAttribute('select-star-ra');
                current_star.dec = this.getAttribute('select-star-dec');
                current_star.chart = this.getAttribute('select-star-chart');
                checkedAndOK = false;
                document.getElementById("err-message-star").innerHTML = "<br>";
                document.getElementById("err-message-star").style.display = "none";
                document.getElementById("err-message-star").style.color = "red";
                document.getElementById("star-form-continue-0").disabled = false;
                generateAddToCartButtonSettings();
                current_star.premium = this.getAttribute('premium');
                current_star.typ = this.getAttribute('typ');

                document.getElementById("star-select-random-results").style.display = "none";

                if (typeof window.starmintTriggerFastReservation === "function") {
                  window.starmintTriggerFastReservation();
                } else if (typeof window.starmintForceShowAccountFormUI === "function") {
                  window.starmintForceShowAccountFormUI();
                }

                if (typeof current_star?.chart != 'undefined' && current_star?.chart != null && current_star?.chart?.length) {
                  imageChartURL = `${current_star.chart}`;
                  imagechartHTML = `
                              <img
                                src="${current_star.chart}"
                                alt="Star Chart Image For ${current_star.identifier}"
                                class="chart-img-height"
                                data-src-for-chartIdentifier='${current_star.identifier}'
                              >
                            `;
                } else {
                  imageChartURL = window.__STARMINT_STAR_SELECTORS__.defaultChartUrl;
                  imagechartHTML = `
                              <img
                                src="${window.__STARMINT_STAR_SELECTORS__.defaultChartUrl}" 
                                alt="Star Chart Image For ${this.getAttribute('select-star-identifier').replace(/\s/g, '')}" 
                                class="chart-img-height"
                                data-src-for-chartIdentifier='${this.getAttribute('select-star-identifier').replace(/\s/g, '')}'
                              >
                            `;
                }
                document.getElementById("chart-image").innerHTML = imagechartHTML;
                let degreeRA = hmsToDegreesString(current_star.ra);
                let degreeDEC = hmsToDegreesString(current_star.dec);
                let starHTML =
                  `
                          <p class="paragraph-color font-size20" style="margin-top:30px">Your star</p>
                          <p class="paragraph-color font-size20-600">${current_star.identifier}</p>
                          <p class="paragraph-color font-size20">Right Ascension: ${degreeRA}<br />Declination: ${degreeDEC}</p>
                        `;
                document.getElementById("star-select-confirm-stats").innerHTML = starHTML;
                let starSelectConfirmResults = document.getElementById("star-select-confirm-results");
                starSelectConfirmResults.style.display = "block";
                try { starmintSaveStarFlowState(); } catch (_saveFlowErr) { }
                scrollToElement(starSelectConfirmResults);
              });
            });
            return;
          }


        }).catch(error => {
          console.error('Error:', error);
          const randomInner = document.getElementById("star-select-random-results-inner");
          if (randomInner) {
            randomInner.innerHTML = '<p style="color:red; text-align:center; width: 100%; grid-column: 1 / -1; margin-top: 2rem;">Sorry, we encountered an error connecting to the cosmos. Please try again.</p>';
          }
        });
    })
  });






  // START OF CONSTELLATION JS



  document.getElementById("star-select-constellations").addEventListener("click", function (e) { // transition
    e.preventDefault();
    setActivePage(1);


    // HIDING OTHER SECTIONS THAT COULD BE VISIBLE
    document.getElementById("star-select-zodiac-results").style.display = "none";
    document.getElementById("star-select-zodiacs-list").style.display = "none";
    document.getElementById("star-select-constellation-results").style.display = "none";
    document.getElementById("constellation-drop").style.display = "none";
    document.getElementById("byIdentifier-drop").style.display = "none";
    document.getElementById("star-select-byIdentifier-results").style.display = "none";
    document.getElementById("byNightsky-drop").style.display = "none";
    document.getElementById("star-select-byNightsky-results").style.display = "none";
    document.getElementById("star-select-random-results").style.display = "none";
    document.getElementById("star-select-confirm-results").style.display = "none";





    // document.getElementById("star-selectors-start").style.display = "none";




    // document.getElementById("star-select-random-list").style.display = "none";




    if (constellationsListFound) {
      document.getElementById("star-select-constellations-list").style.display = "block";
      document.getElementById("constellation-drop").style.display = "block";
      scrollToElement(document.getElementById("constellation-drop"));   // transition
      console.log('here we are');
      return true;
    }

    fetch('https://star.thestarmint.com/api/constellations/list', {
      method: 'GET',
      headers: {
        // 'Authorization': 'Basic ' + authString
      }
    }).then(response => response.json())
      .then(data => {

        let constellationsHtml = ``;
        data?.map(constellation => {
          constellationsHtml += `<div><div class='constellation-option-card' data-constellation-ra='${constellation.ra.trim()}' data-constellation-dec='${constellation.dec.trim()}' name='${constellation.name}'>${constellation.name}</div></div>`;
        });
        document.getElementById("star-select-constellations-list").innerHTML = constellationsHtml;
        document.getElementById("star-select-constellations-list").style.display = "block";
        document.getElementById("constellation-drop").style.display = "block";
        scrollToElement(document.getElementById("constellation-drop"));   // transition
        // document.getElementById("constellationDropdown").classList.toggle("show");
        // //////

        document.querySelectorAll(".constellation-option-card").forEach(constellationCard => {
          constellationCard.addEventListener("click", function (e) { // transition
            e.preventDefault();
            setActivePage(2);
            // /*SLIDE1*/ document.getElementById("star-selectors-start").style.display = "none";

            document.getElementById("byConstellationDropdownError").innerHTML = "";
            document.getElementById("byConstellationDropdownError").style.display = "none";
            document.getElementById("star-select-constellation-results").style.display = "none";




            let ra = this.getAttribute("data-constellation-ra"),
              dec = this.getAttribute("data-constellation-dec");
            let name = this.getAttribute("name");
            current_star.constellation = name;
            current_star.zodiac = "";
            console.log("current_star after add constellation", current_star)
            document.getElementById("constellation-choice").innerHTML = "Selected Constellation: " + name;

            let lowercaseConstellation = name.toLowerCase();

            window.starmintFetchWithRetry(`https://star.thestarmint.com/api/stars/byConstellation?constellation=${lowercaseConstellation}`, {
              method: 'GET',
              headers: {
                // 'Authorization': 'Basic ' + authString 
              }
            }).then(response => response.json())
              .then(data => {
                // Here you can handle your data.
                console.log(data, ' is our data from const');

                if (data && data?.length) {
                  let resultsContainer = document.getElementById("star-select-constellation-results-inner");
                  resultsContainer.innerHTML = '';

                  document.getElementById("reload-star-constellation").addEventListener("click", function (event) {
                    event.preventDefault();
                    get3randomStars(data, "star-select-constellation-results-inner");
                    document.querySelectorAll("#star-select-constellation-results-inner .data-results-item [select-star-identifier]").forEach(starIdentifier => {
                      starIdentifier.addEventListener("click", function (e) { // transition
                        e.preventDefault();
                        console.log("hey!")
                        setActivePage(2);
                        current_star.identifier = this.getAttribute('select-star-identifier'),
                          current_star.ra = this.getAttribute('select-star-ra'),
                          current_star.dec = this.getAttribute('select-star-dec');
                        current_star.chart = this.getAttribute('select-star-chart');
                        generateAddToCartButtonSettings();
                        current_star.premium = this.getAttribute('premium');
                        current_star.typ = this.getAttribute('typ');

                        if (typeof window.starmintTriggerFastReservation === "function") {
                          window.starmintTriggerFastReservation();
                        }

                        let imageChartURL = '';
                        let imagechartHTML = '';
                        if (typeof current_star?.chart != 'undefined' && current_star?.chart != null && current_star?.chart?.length) {
                          console.log(current_star, ' is the maybe null')
                          imageChartURL = `${current_star.chart}`;
                          imagechartHTML = `
                                  <img
                                    src="${current_star.chart}"
                                    alt="Star Chart Image For ${current_star.identifier}"
                                    class="chart-img-height"
                                    data-src-for-chartIdentifier='${current_star.identifier}'
                                  >
                                `
                        } else {
                          console.log('its null lets use default')
                          imageChartURL = window.__STARMINT_STAR_SELECTORS__.defaultChartUrl;
                          imagechartHTML = `
                                  <img
                                    src="${window.__STARMINT_STAR_SELECTORS__.defaultChartUrl}" 
                                    alt="Star Chart Image For ${current_star.identifier}"
                                    class="chart-img-height"
                                    data-src-for-chartIdentifier='${current_star.identifier}'
                                  >
                                `
                        }

                        // document.getElementById(`select-button-${chartIdentifier}`).setAttribute('select-star-chart',chartUrl)
                        document.getElementById("chart-image").innerHTML = imagechartHTML;

                        let degreeRA = hmsToDegreesString(current_star.ra)
                        let degreeDEC = hmsToDegreesString(current_star.dec)
                        console.log("degree RA DEC: ", degreeRA, degreeDEC)
                        let starHTML =
                          `
                                  <p class="paragraph-color font-size20" style="margin-top:30px">Your star</p>
                                  <p class="paragraph-color font-size20-600">${current_star.identifier}</p>
                            <p class="paragraph-color font-size20">Constellation: ${constellationCard.innerHTML}</p>
                                  <p class="paragraph-color font-size20">Right Ascension: ${degreeRA}<br />Declination: ${degreeDEC}</p>
                                `
                        document.getElementById("star-select-confirm-stats").innerHTML = starHTML;

                        document.getElementById("constellation-drop").style.display = "none";
                        //document.getElementById("star-select-constellation-results").style.display = "none";

                        let starSelectConfirmResults = document.getElementById("star-select-confirm-results");
                        starSelectConfirmResults.style.display = "block";
                        scrollToElement(starSelectConfirmResults); // 9999

                      });
                      resultsContainer.style.display = "grid";
                      // transition                                                                                                                                      
                    });
                  })
                  get3randomStars(data, "star-select-constellation-results-inner");

                  document.getElementById("star-select-constellation-results").style.display = "block";
                  scrollToElement(document.getElementById("star-select-constellation-results")); // transition   
                  //document.getElementById("constellation-drop").style.display = "none"; 

                  document.querySelectorAll("#star-select-constellation-results-inner .data-results-item [select-star-identifier]").forEach(starIdentifier => {
                    starIdentifier.addEventListener("click", function (e) { // transition
                      e.preventDefault();
                      console.log("hey!")
                      setActivePage(2);
                      current_star.identifier = this.getAttribute('select-star-identifier'),
                        current_star.ra = this.getAttribute('select-star-ra'),
                        current_star.dec = this.getAttribute('select-star-dec');
                      current_star.chart = this.getAttribute('select-star-chart');
                      generateAddToCartButtonSettings();
                      current_star.premium = this.getAttribute('premium');
                      current_star.typ = this.getAttribute('typ');

                      if (typeof window.starmintTriggerFastReservation === "function") {
                        window.starmintTriggerFastReservation();
                      }

                      let imageChartURL = '';
                      let imagechartHTML = '';
                      if (typeof current_star?.chart != 'undefined' && current_star?.chart != null && current_star?.chart?.length) {
                        console.log(current_star, ' is the maybe null')
                        imageChartURL = `${current_star.chart}`;
                        imagechartHTML = `
                                <img
                                  src="${current_star.chart}"
                                  alt="Star Chart Image For ${current_star.identifier}"
                                  class="chart-img-height"
                                  data-src-for-chartIdentifier='${current_star.identifier}'
                                >
                              `
                      } else {
                        console.log('its null lets use default')
                        imageChartURL = window.__STARMINT_STAR_SELECTORS__.defaultChartUrl;
                        imagechartHTML = `
                                <img
                                  src="${window.__STARMINT_STAR_SELECTORS__.defaultChartUrl}" 
                                  alt="Star Chart Image For ${current_star.identifier}"
                                  class="chart-img-height"
                                  data-src-for-chartIdentifier='${current_star.identifier}'
                                >
                              `
                      }

                      // document.getElementById(`select-button-${chartIdentifier}`).setAttribute('select-star-chart',chartUrl)
                      document.getElementById("chart-image").innerHTML = imagechartHTML;

                      let degreeRA = hmsToDegreesString(current_star.ra)
                      let degreeDEC = hmsToDegreesString(current_star.dec)
                      console.log("degree RA DEC: ", degreeRA, degreeDEC)
                      let starHTML =
                        `
                                <p class="paragraph-color font-size20" style="margin-top:30px">Your star</p>
                                <p class="paragraph-color font-size20-600">${current_star.identifier}</p>
                          <p class="paragraph-color font-size20">Constellation: ${constellationCard.innerHTML}</p>
                                <p class="paragraph-color font-size20">Right Ascension: ${degreeRA}<br />Declination: ${degreeDEC}</p>
                              `
                      document.getElementById("star-select-confirm-stats").innerHTML = starHTML;

                      document.getElementById("constellation-drop").style.display = "none";
                      scrollToElement(document.getElementById("star-select-confirm-results")); // transition
                      //document.getElementById("star-select-constellation-results").style.display = "none";
                      document.getElementById("star-select-confirm-results").style.display = "block";
                      // 9999
                      scrollToElement(document.getElementById("star-select-confirm-results")); // transition

                    });
                    resultsContainer.style.display = "grid";
                    // transition                                                                                                                                      
                  });
                } else {
                  console.log('could not find constellation data - from const')
                  document.getElementById("byConstellationDropdownError").innerHTML = "Unfortunately we cannot find any unclaimed stars from this constellation.";
                  document.getElementById("byConstellationDropdownError").style.display = "block";
                }

              }).catch(error => {
                console.error('Error:', error);
                console.log('could not find constellation data - from const 2')
                document.getElementById("byConstellationDropdownError").innerHTML = "Unfortunately we cannot find any unclaimed stars from this constellation.";
                document.getElementById("byConstellationDropdownError").style.display = "block";
              });
          });
        })

        constellationsListFound = true;

        console.log(data, ' is constellations data');
      }).catch(error => {
        console.error('Error:', error);
      });


  })

  // END OF CONSTELLATION JS 




  // START OF byIdentifier JS



  document.getElementById("star-select-byIdentifiers").addEventListener("click", function (e) { // transition
    e.preventDefault();
    setActivePage(1);


    // document.getElementById("star-selectors-start").style.display = "none";
    // document.getElementById("star-select-random-list").style.display = "none";



    // HIDING OTHER SECTIONS THAT COULD BE VISIBLE
    document.getElementById("star-select-zodiac-results").style.display = "none";
    document.getElementById("star-select-zodiacs-list").style.display = "none";
    document.getElementById("star-select-constellation-results").style.display = "none";
    document.getElementById("constellation-drop").style.display = "none";
    document.getElementById("star-select-byIdentifier-results").style.display = "none";
    document.getElementById("star-select-random-results").style.display = "none";
    document.getElementById("star-select-confirm-results").style.display = "none";


    document.getElementById("byIdentifier-drop").style.display = "block";
    scrollToElement(document.getElementById("byIdentifier-drop"));

    //  byIdentifierDropdown
    // byIdentifierDropdownSearchInput
    // const byIdentifierSearchButton = document.getElementById("byIdentifierSearchButton")
    // star-selection-byIdentifiers-list
    // star-select-byIdentifier-results
    // star-select-byIdentifier-results-inner

    const byIdentifierDropdownSearchInput = document.getElementById("byIdentifierDropdownSearchInput");

    byIdentifierDropdownSearchInput.addEventListener("input", function (e) {
      e.preventDefault();
      document.getElementById("identifier-error").style.visibility = "hidden"; // Hide the error message
    });


    byIdentifierSearchButton.addEventListener("click", function (e) { // transition
      e.preventDefault();
      setActivePage(2);

      // display loading
      document.getElementById("search-loading").style.display = "block";


      let byIdentifierDropdownSearchInput = document.getElementById("byIdentifierDropdownSearchInput")

      console.log(byIdentifierDropdownSearchInput?.value);
      // /*SLIDE1*/ document.getElementById("star-selectors-start").style.display = "none";


      window.starmintFetchWithRetry(`https://star.thestarmint.com/api/stars/byIdentifier?identifier=${byIdentifierDropdownSearchInput?.value}&radius=15`, {
        method: 'GET',
        headers: {
          // 'Authorization': 'Basic ' + authString 
        }
      }).then(response => response.json())
        .then(data => {
          document.getElementById("search-loading").style.display = "none";
          // Here you can handle your data.
          console.log(data);
          // console.log(data);
          if (data && data?.length) {
            let resultsContainer = document.getElementById("star-select-byIdentifier-results-inner");
            resultsContainer.innerHTML = '';

            document.getElementById("reload-star-identifier").addEventListener("click", function (event) {
              event.preventDefault();
              get3randomStars(data, "star-select-byIdentifier-results-inner");
              document.querySelectorAll("#star-select-byIdentifier-results-inner .data-results-item [select-star-identifier]").forEach(starIdentifier => {
                starIdentifier.addEventListener("click", function (e) { // transition
                  e.preventDefault();
                  console.log("hey!")
                  setActivePage(2);
                  current_star.identifier = this.getAttribute('select-star-identifier'),
                    current_star.ra = this.getAttribute('select-star-ra'),
                    current_star.dec = this.getAttribute('select-star-dec');
                  current_star.chart = this.getAttribute('select-star-chart');
                  generateAddToCartButtonSettings();
                  current_star.premium = this.getAttribute('premium');
                  current_star.typ = this.getAttribute('typ');

                  if (typeof window.starmintTriggerFastReservation === "function") {
                    window.starmintTriggerFastReservation();
                  }

                  console.log("current_star", current_star)

                  let imageChartURL = '';
                  let imagechartHTML = '';
                  if (typeof current_star?.chart != 'undefined' && current_star?.chart != null && current_star?.chart?.length) {
                    console.log(current_star, ' is the maybe null')
                    imageChartURL = `${current_star.chart}`;
                    imagechartHTML = `
                                  <img
                                    src="${current_star.chart}"
                                    alt="Star Chart Image For ${current_star.identifier}"
                                    class="chart-img-height"
                                    data-src-for-chartIdentifier='${current_star.identifier}'
                                  >
                                `
                  } else {
                    console.log('its null lets use default')
                    imageChartURL = window.__STARMINT_STAR_SELECTORS__.defaultChartUrl;
                    imagechartHTML = `
                                  <img
                                    src="${window.__STARMINT_STAR_SELECTORS__.defaultChartUrl}"
                                    alt="Star Chart Image For ${current_star.identifier}"
                                    class="chart-img-height"
                                    data-src-for-chartIdentifier='${current_star.identifier}'
                                  >
                                `
                  }

                  // document.getElementById(`select-button-${chartIdentifier}`).setAttribute('select-star-chart',chartUrl)
                  document.getElementById("chart-image").innerHTML = imagechartHTML;

                  let degreeRA = hmsToDegreesString(current_star.ra)
                  let degreeDEC = hmsToDegreesString(current_star.dec)
                  console.log("degree RA DEC: ", degreeRA, degreeDEC)
                  let starHTML =
                    `
                                  <p class="paragraph-color font-size20" style="margin-top:30px">Your star</p>
                                  <p class="paragraph-color font-size20-600">${current_star.identifier}</p>
                                  <p class="paragraph-color font-size20">Right Ascension: ${degreeRA}<br />Declination: ${degreeDEC}</p>
                                `
                  document.getElementById("star-select-confirm-stats").innerHTML = starHTML;

                  document.getElementById("byIdentifier-drop").style.display = "none";
                  //document.getElementById("star-select-byIdentifier-results").style.display = "none";

                  console.log('star select confirm results showing now')
                  document.getElementById("star-select-confirm-results").style.display = "block";

                  scrollToElement(document.getElementById("star-select-confirm-results")); // transition

                });
                resultsContainer.style.display = "grid";
                // transition                                                                                                                                      
              });
            })

            get3randomStars(data, "star-select-byIdentifier-results-inner")

            // for(x = 0; x < (data?.length >= 3 ? 3 : data?.length); x++) {

            //     let loopPromise = new Promise((resolve, reject) => {

            //         //fetch star chart start
            //         let chartHTML = '';
            //         let chartIdentifierOriginal = data[x].identifier;
            //         let chartIdentifier = chartIdentifierOriginal.replace(/\s/g,'');
            //         let chartUrl = '';
            //         fetch(`https://star.thestarmint.com/api/chart/create?ra=${data[x].coordinates.unitsRA}&dec=${data[x].coordinates.unitsDEC}`, {
            //             method: 'POST',
            //             headers: {
            //                 // 'Authorization': 'Basic ' + authString 
            //             }
            //         }).then(response => response.json())
            //         .then(data => {
            //             console.log("data from image char api:", data);

            //             if(data.imageUrl) {
            //                 chartUrl = data.imageUrl;

            //                 checkImageWithInterval(chartUrl, 5, 1000, function(imageExists) {
            //                     if (imageExists) {
            //                         if(current_star.identifier == chartIdentifierOriginal){
            //                             current_star.chart = chartUrl;
            //                         }

            //                         document.getElementById(`select-button-${chartIdentifier}`).setAttribute('select-star-chart', chartUrl);

            //                         if(chartHTML?.indexOf(`data-src-for-chartIdentifier='${chartIdentifier}'`) === -1) {
            //                             chartHTML += `<img class='data-result-item-img chart-img-height' src='${data.imageUrl}' alt="Star Chart Image For ${chartIdentifierOriginal}" data-src-for-chartIdentifier='${chartIdentifier}'/>`;
            //                         }
            //                         document.getElementById(chartIdentifier).innerHTML = chartHTML;
            //                     } else {
            //                         chartHTML += '<p>Something went wrong getting the char image</p>';
            //                         document.getElementById(chartIdentifier).innerHTML = chartHTML;
            //                     }
            //                 });
            //             } else {
            //                 chartHTML += `<img src="${window.__STARMINT_STAR_SELECTORS__.defaultChartUrl}" class="chart-img-height" />`;
            //                 document.getElementById(chartIdentifier).innerHTML = chartHTML;
            //             }
            //         });

            //         resultsContainer.innerHTML += `
            //             <div class='data-results-item'>
            //                 <div id=${chartIdentifier} class="chart-img-height"> 
            //                     <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; display: block; shape-rendering: auto; animation-play-state: running; animation-delay: 0s;" width="100px" height="50px" viewBox="0 25 100 50" preserveAspectRatio="xMidYMid" loading="lazy">
            //                         <path fill="none" stroke="#f9ae5c" stroke-width="8" stroke-dasharray="42.76482137044271 42.76482137044271" stroke-dashoffset="0" d="M24.3 30C11.4 30 5 43.3 5 50s6.4 20 19.3 20c19.3 0 32.1-40 51.4-40 C88.6 30 95 43.3 95 50s-6.4 20-19.3 20C56.4 70 43.6 30 24.3 30z" stroke-linecap="round" style="transform: scale(0.8); transform-origin: 50px 50px; animation-play-state: running; animation-delay: 0s;">
            //                             <animate begin="0s" attributeName="stroke-dashoffset" repeatCount="indefinite" dur="1s" keyTimes="0;1" values="0;256.58892822265625" style="animation-play-state: running; animation-delay: 0s;"></animate>
            //                         </path>
            //                     </svg>
            //                 </div>
            //                 <p class="paragraph-color">${data[x].identifier} </p>
            //                 <button id='select-button-${chartIdentifier}' class='button button--primary'  select-star-identifier='${data[x].identifier}' select-star-ra='${Number(data[x].ra_deg)/15}' select-star-dec='${Number(data[x].dec_deg)}' typ='${data[x].typ}'>Select This Star</button>
            //             </div>`;
            //     });
            // }


            document.getElementById("star-select-byIdentifier-results").style.display = "block";
            scrollToElement(document.getElementById("star-select-byIdentifier-results")); // transition   
            //document.getElementById("byIdentifier-drop").style.display = "none"; 



            document.querySelectorAll("#star-select-byIdentifier-results-inner .data-results-item [select-star-identifier]").forEach(starIdentifier => {
              starIdentifier.addEventListener("click", function (e) { // transition
                e.preventDefault();
                console.log("hey!")
                setActivePage(2);
                if (typeof window.starmintTriggerFastReservation === "function") {
                  window.starmintTriggerFastReservation();
                }
                //  init();
                current_star.identifier = this.getAttribute('select-star-identifier'),
                  current_star.ra = this.getAttribute('select-star-ra'),
                  current_star.dec = this.getAttribute('select-star-dec');
                current_star.chart = this.getAttribute('select-star-chart');
                generateAddToCartButtonSettings();
                current_star.premium = this.getAttribute('premium');
                current_star.typ = this.getAttribute('typ');

                console.log("current_star", current_star)

                let imageChartURL = '';
                let imagechartHTML = '';
                if (typeof current_star?.chart != 'undefined' && current_star?.chart != null && current_star?.chart?.length) {
                  console.log(current_star, ' is the maybe null')
                  imageChartURL = `${current_star.chart}`;
                  imagechartHTML = `
                                  <img
                                    src="${current_star.chart}"
                                    alt="Star Chart Image For ${current_star.identifier}"
                                    class="chart-img-height"
                                    data-src-for-chartIdentifier='${current_star.identifier}'
                                  >
                                `
                } else {
                  console.log('its null lets use default')
                  imageChartURL = window.__STARMINT_STAR_SELECTORS__.defaultChartUrl;
                  imagechartHTML = `
                                  <img
                                    src="${window.__STARMINT_STAR_SELECTORS__.defaultChartUrl}"
                                    alt="Star Chart Image For ${current_star.identifier}"
                                    class="chart-img-height"
                                    data-src-for-chartIdentifier='${current_star.identifier}'
                                  >
                                `
                }

                // document.getElementById(`select-button-${chartIdentifier}`).setAttribute('select-star-chart',chartUrl)
                document.getElementById("chart-image").innerHTML = imagechartHTML;

                let degreeRA = hmsToDegreesString(current_star.ra)
                let degreeDEC = hmsToDegreesString(current_star.dec)
                console.log("degree RA DEC: ", degreeRA, degreeDEC)
                let starHTML =
                  `
                                  <p class="paragraph-color font-size20" style="margin-top:30px">Your star</p>
                                  <p class="paragraph-color font-size20-600">${current_star.identifier}</p>
                                  <p class="paragraph-color font-size20">Right Ascension: ${degreeRA}<br />Declination: ${degreeDEC}</p>
                                `
                document.getElementById("star-select-confirm-stats").innerHTML = starHTML;

                document.getElementById("byIdentifier-drop").style.display = "none";
                //document.getElementById("star-select-byIdentifier-results").style.display = "none";

                console.log('star select confirm results showing now')
                document.getElementById("star-select-confirm-results").style.display = "block";

                scrollToElement(document.getElementById("star-select-confirm-results")); // transition

              });
              resultsContainer.style.display = "grid";
              // transition                                                                                                                                      
            });
          }

        }).catch(error => {
          console.error('Error:', error);
          // might need to display something for the caught error
          document.getElementById("search-loading").style.display = "none";
          document.getElementById("identifier-error").innerHTML = "No star found, please check the identifier and try again."
          document.getElementById("identifier-error").style.visibility = "visible";

        });
    });




    // console.log(data, ' is byIdentifiers data');
  })




  // END OF byIdentifier JS

  // START OF byNightsky JS

  let starmintNightskyCoords = { latitude: null, longitude: null };
  let added_byNightskySearchButton = false;
  let added_byNightskyDateInputListener = false;

  let byNightskySearchToggleForm = document.getElementById("byNightskySearchToggleForm");
  let byNightskySearchToggleFormOff = document.getElementById("byNightskySearchToggleFormOff");
  let detectedAddressData = document.getElementById("detectedAddressData");

  if (byNightskySearchToggleForm) {
  byNightskySearchToggleForm.addEventListener("click", function (e) {
    e.preventDefault();
    this.style.display = "none"
    detectedAddressData.style.display = "none";
    usingDetectedLocation = false;
    byNightskySearchToggleFormOff.style.display = "inline-block"
    showNightskyDetailForm();
  });
  }

  if (byNightskySearchToggleFormOff) {
  byNightskySearchToggleFormOff.addEventListener("click", function (e) {
    e.preventDefault();
    this.style.display = "none"
    usingDetectedLocation = true;
    detectedAddressData.style.display = "block";
    byNightskySearchToggleForm.style.display = "inline-block"
    document.getElementById("nightSkyAddressFormfields").style.display = 'none';
  });
  }

  function getGeolocationForNightsky() {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      } else {
        reject(new Error("Geolocation is not supported by this browser."));
      }
    });
  }



  function checkLocationForNightsky() {
    getGeolocationForNightsky()
      .then(position => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        // Use latitude and longitude here
        console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);

        showNightskyDetailForm(latitude, longitude);
      })
      .catch(error => {
        // Handle error
        console.error(error.message);

        showNightskyDetailForm();


        //  byNightskyDropdown
        // byNightskyDateInput
        // const byNightskySearchButton = document.getElementById("byNightskySearchButton")
        // star-selection-byNightskys-list
        // star-select-byNightsky-results
        // star-select-byNightsky-results-inner
      });
  }

  function fetchNightskyStars(latitude, longitude, city, state, country) {
    const byNightskyDateInput = document.getElementById("byNightskyDateInput");
    const byNightskyTimeInput = document.getElementById("byNightskyTimeInput");
    const namingDateInput = document.getElementById("namingDate");

    const formattedDate = formatYmdDate(byNightskyDateInput?.value || "");
    const formattedTime = formatObservationTime(byNightskyTimeInput?.value || "");

    if (namingDateInput) {
      namingDateInput.value = formattedDate;
    }



    setActivePage(1);
    // display loading
    const nightskyLoading = document.getElementById("search-loading-nightsky");
    const nightskyError = document.getElementById("nightsky-error");
    if (nightskyLoading) nightskyLoading.style.display = "block";
    if (nightskyError) {
      nightskyError.style.display = "none";
      nightskyError.style.visibility = "hidden";
    }

    const encodedCity = encodeURIComponent(city || "");
    const encodedState = encodeURIComponent(state || "");
    const encodedCountry = encodeURIComponent(country || "");
    const latNum = Number(latitude);
    const lonNum = Number(longitude);
    let nightSkyQueryString;
    if (Number.isFinite(latNum) && Number.isFinite(lonNum)) {
      nightSkyQueryString = `?lat=${encodeURIComponent(latNum)}&lon=${encodeURIComponent(lonNum)}&date=${encodeURIComponent(formattedDate)}&time=${encodeURIComponent(formattedTime)}`;
    } else if (city && country) {
      nightSkyQueryString = `?cityTown=${encodedCity}&state=${encodedState}&country=${encodedCountry}&date=${encodeURIComponent(formattedDate)}&time=${encodeURIComponent(formattedTime)}`;
    } else {
      document.getElementById("search-loading-nightsky").style.display = "none";
      document.getElementById("nightsky-error").innerHTML = "You must choose a city and country, or share your current location to continue."
      document.getElementById("nightsky-error").style.visibility = "visible";
      return false;
    }

    const skyController = new AbortController();
    const skyTimeoutId = setTimeout(() => skyController.abort(), 45000);

    window.starmintFetchWithRetry(`${getSkyApiBase()}/visible-stars${nightSkyQueryString}`, {
      method: 'GET',
      signal: skyController.signal,
      headers: {
        // 'Authorization': 'Basic ' + authString 
      }
    }).then(async (response) => {
      clearTimeout(skyTimeoutId);
      if (!response.ok) {
        let message = "Sky search failed with status " + response.status;
        try {
          const errBody = await response.json();
          if (errBody?.error) message = errBody.error;
        } catch (_e) { }
        throw new Error(message);
      }
      return response.json();
    })
      .then(data => {
        if (nightskyLoading) nightskyLoading.style.display = "none";
        // Here you can handle your data.
        console.log(data);
        // console.log(data);
        if (Array.isArray(data) && data.length) {
          let resultsContainer = document.getElementById("star-select-byNightsky-results-inner");
          if (!resultsContainer) return;
          resultsContainer.innerHTML = '';

          const reloadBtn = document.getElementById("reload-star-nightSky");
          if (reloadBtn && !reloadBtn.dataset.boundNightskyReload) {
            reloadBtn.dataset.boundNightskyReload = "1";
            reloadBtn.addEventListener("click", function (event) {
              event.preventDefault();
              get3randomStars(data, "star-select-byNightsky-results-inner");
              bindNightskyStarPickHandlers();
            });
          }

          get3randomStars(data, "star-select-byNightsky-results-inner");
          bindNightskyStarPickHandlers();

          const resultsPanel = document.getElementById("star-select-byNightsky-results");
          if (resultsPanel) {
            resultsPanel.style.display = "block";
            scrollToElement(resultsPanel);
          }
        } else {
          if (nightskyLoading) nightskyLoading.style.display = "none";
          if (nightskyError) {
            nightskyError.innerHTML = "No star found, please double check your selected date & location and try again.";
            nightskyError.style.display = "block";
            nightskyError.style.visibility = "visible";
          }
        }

      }).catch(error => {
        clearTimeout(skyTimeoutId);
        console.error('Error:', error);
        if (nightskyLoading) nightskyLoading.style.display = "none";
        if (nightskyError) {
          const timedOut = error?.name === "AbortError";
          nightskyError.innerHTML = timedOut
            ? "The sky search took too long. Try again, or use your current location instead of typing a city."
            : (error?.message || "No star found, please double check your selected date & location and try again.");
          nightskyError.style.display = "block";
          nightskyError.style.visibility = "visible";
        }

      });
  }

  function bindNightskyStarPickHandlers() {
    document.querySelectorAll("#star-select-byNightsky-results-inner .data-results-item [select-star-identifier]").forEach(starIdentifier => {
      if (starIdentifier.dataset.boundNightskyPick) return;
      starIdentifier.dataset.boundNightskyPick = "1";
      starIdentifier.addEventListener("click", function (e) {
        e.preventDefault();
        setActivePage(2);
        current_star.identifier = this.getAttribute('select-star-identifier');
        current_star.ra = this.getAttribute('select-star-ra');
        current_star.dec = this.getAttribute('select-star-dec');
        current_star.chart = this.getAttribute('select-star-chart');
        generateAddToCartButtonSettings();
        current_star.premium = this.getAttribute('premium');
        current_star.typ = this.getAttribute('typ');

        if (typeof window.starmintTriggerFastReservation === "function") {
          window.starmintTriggerFastReservation();
        }

        let imagechartHTML = '';
        if (current_star?.chart) {
          imagechartHTML = `
            <img
              src="${current_star.chart}"
              alt="Star Chart Image For ${current_star.identifier}"
              class="chart-img-height"
              data-src-for-chartIdentifier='${current_star.identifier}'
            >
          `;
        } else {
          imagechartHTML = `
            <img
              src="${window.__STARMINT_STAR_SELECTORS__.defaultChartUrl}"
              alt="Star Chart Image For ${current_star.identifier}"
              class="chart-img-height"
              data-src-for-chartIdentifier='${current_star.identifier}'
            >
          `;
        }

        document.getElementById("chart-image").innerHTML = imagechartHTML;

        let degreeRA = hmsToDegreesString(current_star.ra);
        let degreeDEC = hmsToDegreesString(current_star.dec);
        let starHTML =
          `
            <p class="paragraph-color font-size20" style="margin-top:30px">Your star</p>
            <p class="paragraph-color font-size20-600">${current_star.identifier}</p>
            <p class="paragraph-color font-size20">Right Ascension: ${degreeRA}<br />Declination: ${degreeDEC}</p>
          `;
        document.getElementById("star-select-confirm-stats").innerHTML = starHTML;
        document.getElementById("byNightsky-drop").style.display = "none";
        document.getElementById("star-select-confirm-results").style.display = "block";
        scrollToElement(document.getElementById("star-select-confirm-results"));
      });
    });

    const resultsContainer = document.getElementById("star-select-byNightsky-results-inner");
    if (resultsContainer) resultsContainer.style.display = "grid";
  }

  function clickNightskySearchButton() {
    const latitude = starmintNightskyCoords.latitude;
    const longitude = starmintNightskyCoords.longitude;
    console.log(latitude, longitude, 'START nightsky search click');
    document.getElementById("star-select-byNightsky-results").style.display = "none";

    let nightSkyCity = document.getElementById('nightSky-city').value,
      nightSkyState = document.getElementById('nightSky-state').value,
      nightSkyCountry = document.getElementById('nightSky-country').value;

    if (latitude != null && longitude != null) {
      fetchNightskyStars(latitude, longitude, false, false, false);
    } else {
      if (nightSkyCity == '' || nightSkyCountry == '') {
        let ns_error = document.getElementById("nightsky-error");
        ns_error.innerHTML = "You must enter a city and country, or use your current location.";
        ns_error.style.visibility = "unset";
        ns_error.style.display = "block";
      } else {
        fetchNightskyStars(false, false, nightSkyCity, nightSkyState, nightSkyCountry);
      }
    }
  }

  async function updateAddressFromCoordinates(latitude, longitude) {
    const apiURL = `${getSkyApiBase()}/coordinates-to-address?lat=${encodeURIComponent(latitude)}&lon=${encodeURIComponent(longitude)}`;

    let _fetch = await fetch(apiURL)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        if (data.city || data.state || data.country) {
          // Update the DOM elements with the received data
          document.getElementById('detectedCityTown').textContent = data.city || 'City not found';
          const detectedStateEl = document.getElementById('detectedState');
          if (detectedStateEl) {
            if (data.state) {
              detectedStateEl.textContent = data.state;
              detectedStateEl.style.display = '';
            } else {
              detectedStateEl.textContent = '';
              detectedStateEl.style.display = 'none';
            }
          }
          document.getElementById('detectedCountry').textContent = data.country || 'Country not found';

          document.getElementById('nightSky-city').value = data.city || '';
          document.getElementById('nightSky-state').value = data.state || '';

          const countrySelect = document.getElementById('nightSky-country');
          const matchOption = Array.from(countrySelect.options).find(opt => opt.textContent === data.country);

          if (matchOption) {
            countrySelect.value = matchOption.value;
          }

          // Make the container visible
          document.getElementById('detectedAddressData').style.display = 'block';
          return true;
        } else {
          document.getElementById('detectedAddressData').style.display = "none";
          console.error('No address data found');
          return false;
        }
      })
      .catch(error => {
        console.error('Error fetching address:', error);
        return false;
      });

    return _fetch;
  }


  function showNightskyDetailForm(latitude = null, longitude = null) {
    starmintNightskyCoords.latitude = latitude;
    starmintNightskyCoords.longitude = longitude;

    let nightSkyAddressFormfields = document.getElementById("nightSkyAddressFormfields");
    if (latitude == null || longitude == null) {
      console.log('showing address form fields')
      nightSkyAddressFormfields.style.display = "grid"

      usingDetectedLocation = false;
    } else {
      usingDetectedLocation = true;
      updateAddressFromCoordinates(latitude, longitude)
      byNightskySearchToggleForm.style.display = "inline-block";
    }


    document.getElementById("byNightsky-drop").style.display = "block";
    scrollToElement(document.getElementById("byNightsky-drop"));

    const byNightskyDateInput = document.getElementById("byNightskyDateInput");
    const byNightskyTimeInput = document.getElementById("byNightskyTimeInput");

    if (byNightskyDateInput) {
      byNightskyDateInput.value = formatYmdDate(byNightskyDateInput.value || "");
      byNightskyDateInput.max = formatYmdDate("");
    }
    if (byNightskyTimeInput && !byNightskyTimeInput.value) {
      byNightskyTimeInput.value = "21:00";
    }

    if (!added_byNightskyDateInputListener && byNightskyDateInput) {
      byNightskyDateInput.addEventListener("input", function () {
        document.getElementById("nightsky-error").style.visibility = "hidden";
      });
      added_byNightskyDateInputListener = true;
    }

    const byNightskySearchButton = document.getElementById("byNightskySearchButton")
    console.log(added_byNightskySearchButton, 'adding nightsky search click');
    if (!added_byNightskySearchButton && byNightskySearchButton) {
      byNightskySearchButton.addEventListener("click", function () {
        clickNightskySearchButton();
      });
      added_byNightskySearchButton = true;
    }
  }







  document.getElementById("star-select-byNightsky").addEventListener("click", function (e) { // transition
    e.preventDefault();
    setActivePage(1);

    // document.getElementById("star-selectors-start").style.display = "none";
    // document.getElementById("star-select-random-list").style.display = "none";



    // HIDING OTHER SECTIONS THAT COULD BE VISIBLE
    document.getElementById("star-select-zodiac-results").style.display = "none";
    document.getElementById("star-select-zodiacs-list").style.display = "none";
    document.getElementById("star-select-constellation-results").style.display = "none";
    document.getElementById("constellation-drop").style.display = "none";
    document.getElementById("star-select-byIdentifier-results").style.display = "none";
    document.getElementById("star-select-byNightsky-results").style.display = "none";
    document.getElementById("star-select-random-results").style.display = "none";
    document.getElementById("star-select-confirm-results").style.display = "none";

    checkLocationForNightsky(); // checks if geolocation active & if so, send request for visible stars, or show city/state/etc fields





    // console.log(data, ' is byNightskys data');
  })








  // END OF byNightsky JS




  // GENERATE CERTIFICATE BUTTON
  const generateCertificateBtn = document.querySelector("#generate-certificate-button");
  if (generateCertificateBtn) {
    generateCertificateBtn.addEventListener("click", function (e) {
      e.preventDefault();
      generateCertificateBtn.innerHTML = "Creating…";
      generateCertificateBtn.disabled = true;
      console.log("generate certificate clicked");

      let namingDate = document.getElementById("namingDate")?.value?.trim() || "";
      let starName = document.getElementById("starName")?.value?.trim() || "";
      current_star.name = starName;
      generateCertificate(current_star?.id, current_star?.chart, showDate, showMessage, namingDate, starName, { requestedVersion: versionNow });
    });
  }
  // })

  function formatDate(dateString) {
    const [year, month, day] = dateString.split('-');
    const date = new Date(year, month - 1, day);
    const options = { month: 'long', day: 'numeric', year: 'numeric' };

    const formattedDate = date.toLocaleString('en-US', options);

    return formattedDate;
  }

  async function generateCertificate(starId, chart, showDate, showMessage, namingDate, starName, options) {
    if (starName != null && typeof starName === "object" && !Array.isArray(starName) && !(starName instanceof Date)) {
      options = starName;
      starName = "";
    }
    const requestedVersion = String((options && options.requestedVersion) || versionNow);
    const requestSeq = ++certificateRequestSeq;
    const silent = !!(options && options.silent);
    const resolvedStarName =
      (typeof starName === "string" && starName.trim()) ||
      (typeof current_star !== "undefined" &&
        current_star &&
        current_star.name &&
        String(current_star.name).trim()) ||
      (document.getElementById("starName") &&
        document.getElementById("starName").value &&
        document.getElementById("starName").value.trim()) ||
      "";

    if (typeof current_star !== "undefined" && current_star && resolvedStarName) {
      current_star.name = resolvedStarName;
    }

    const namingDateRaw = (namingDate || "").trim() || formattedToday;
    const cacheKey = getCertificateCacheKeyFor(requestedVersion, !!showDate, !!showMessage, namingDateRaw);
    const certificateLoading = document.getElementById("certificate-preview-loading");
    const applyImmediateSuccessUi = function (resolvedUrl) {
      if (!resolvedUrl) return;
      if (requestedVersion === String(versionNow)) {
        current_star.certificate = resolvedUrl;
      }
      certificate = resolvedUrl;
      savePreviewContext();
      generateAddToCartButtonSettings();
      const frameBtn = document.getElementById("frame-certificate-button");
      if (frameBtn) frameBtn.style.display = "inline-block";
      const generateBtn = document.getElementById("generate-certificate-button");
      if (generateBtn) {
        generateBtn.disabled = false;
        if (!silent) generateBtn.style.display = "none";
      }
      const postCertificateActions = document.getElementById("post-certificate-actions");
      if (postCertificateActions) {
        postCertificateActions.style.display = "flex";
        const nextBtn = document.getElementById("choose-gift-button");
        if (nextBtn) {
          nextBtn.style.display = "inline-flex";
          nextBtn.innerHTML = "Next";
        }
      }
      if (certificateLoading && !silent) certificateLoading.style.display = "none";
    };

    if (certificateCache[cacheKey]) {
      const cachedUrl = certificateCache[cacheKey];
      if (requestedVersion === String(versionNow) && cachedUrl) {
        const cachedPreviewUrl = resolveCertificatePreviewUrl({
          cdnUrl: cachedUrl,
          starId,
          version: requestedVersion,
        });
        setCertificatePreviewSource(
          withCertificateCacheBuster(cachedPreviewUrl),
          withCertificateCacheBuster(cachedUrl),
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=",
          {
            keepCurrentWhileLoading: true,
            perUrlTimeoutMs: 15000,
            directCertificateLoad: true
          }
        );
      }
      applyImmediateSuccessUi(cachedUrl);
      return Promise.resolve(cachedUrl);
    }

    if (certificateInFlightByKey[cacheKey]) {
      return certificateInFlightByKey[cacheKey].then(function (resolvedUrl) {
        if (requestedVersion === String(versionNow) && resolvedUrl) {
          const inflightPreviewUrl = resolveCertificatePreviewUrl({
            cdnUrl: resolvedUrl,
            starId,
            version: requestedVersion,
          });
          setCertificatePreviewSource(
            withCertificateCacheBuster(inflightPreviewUrl),
            withCertificateCacheBuster(resolvedUrl),
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=",
            {
              keepCurrentWhileLoading: true,
              perUrlTimeoutMs: 15000,
              directCertificateLoad: true
            }
          );
        }
        applyImmediateSuccessUi(resolvedUrl);
        return resolvedUrl;
      });
    }

    const inflightKey = cacheKey;
    const genPromise = (async function () {

      namingDate = formatDate(namingDateRaw);
      if (!namingDate || namingDate === "Invalid Date") {
        namingDate = formatDate(formattedToday);
      }

      let certificateUrl = '';
      if (!silent && certificateLoading) {
        certificateLoading.style.display = "flex";
        const starterBar = certificateLoading.querySelector("#cert-progress-bar");
        if (starterBar) starterBar.style.width = "10%";

        // Hide the generate button immediately as it's now automatic
        const generateBtn = document.getElementById("generate-certificate-button");
        if (generateBtn) {
          generateBtn.style.display = "none";
        }
      }


      // Show NEXT button even if silent, if we are on the certificate step
      const postActions = document.getElementById("post-certificate-actions");
      if (postActions) {
        postActions.style.display = "flex";
        const nextBtn = document.getElementById("choose-gift-button");
        if (nextBtn) {
          nextBtn.style.display = "inline-flex";
          nextBtn.innerHTML = "Next";
        }
      }

      const selectedStyleThumb = document.querySelector('.certificate-style-option--selected img')?.getAttribute('src') || "";
      const templatePreview =
        selectedStyleThumb ||
        sampleCertificates?.[String(requestedVersion || versionNow || "1")] ||
        sampleCertificates?.["1"] ||
        "";
      const previewImg = document.getElementById("certificate-preview-image") || document.querySelector("#certificate-container img");
      if (previewImg && templatePreview) {
        previewImg.classList.remove("loaded");
        const safeTemplate = String(templatePreview);
        const withTs =
          safeTemplate.startsWith("data:image/")
            ? safeTemplate
            : safeTemplate + (safeTemplate.includes("?") ? "&" : "?") + "ts=" + Date.now();
        previewImg.onerror = function () {
          const fallback = sampleCertificates?.["1"] || sampleCertificates?.["loading"] || "";
          if (!fallback) return;
          previewImg.onerror = null;
          previewImg.src = fallback;
        };
        previewImg.src = withTs;
      }
      let certificateProgressSimTimer = null;
      function clearCertificateProgressSim() {
        if (certificateProgressSimTimer) {
          clearInterval(certificateProgressSimTimer);
          certificateProgressSimTimer = null;
        }
      }

      function updateProgress(percent) {
        if (certificateLoading && !silent) {
          const progressBar = certificateLoading.querySelector("#cert-progress-bar");
          if (progressBar) progressBar.style.width = percent + "%";
        }
      }

      function finalizeSuccessfulGeneration(cdnUrl, previewUrlOverride) {
        clearCertificateProgressSim();
        if (!silent) {
          updateProgress(100);
        }
        const previewUrl = previewUrlOverride || resolveCertificatePreviewUrl({
          cdnUrl,
          starId,
          version: requestedVersion,
        });
        if (requestedVersion === String(versionNow)) {
          current_star.certificate = cdnUrl;
        }
        certificate = cdnUrl;
        savePreviewContext();
        if (cdnUrl) {
          certificateCache[cacheKey] = cdnUrl;
          certificatesMade.add(cdnUrl);
        }
        generateAddToCartButtonSettings();
        const frameBtn = document.getElementById("frame-certificate-button");
        if (frameBtn) frameBtn.style.display = "inline-block";
        const generateBtn = document.getElementById("generate-certificate-button");
        if (generateBtn) {
          generateBtn.disabled = false;
          if (!silent) generateBtn.style.display = "none";
        }

        // Show NEXT button and other actions
        let postCertificateActions = document.getElementById("post-certificate-actions");
        if (postCertificateActions) {
          postCertificateActions.style.display = "flex";
        }

        // TRIGGER SCROLL ANIMATION FOR CONGRATULATIONS
        let starSelectFinish = document.getElementById("star-select-finish");
        if (starSelectFinish) {
          starSelectFinish.classList.add("show-animation");
        }
        let congratsHeadline = document.getElementById("congrats-star-headline");
        if (congratsHeadline) {
          congratsHeadline.classList.add("show-animation");
        }

        if (!silent) {
          setTimeout(() => {
            starSelectFinish?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 300);
        }

        if (requestSeq === certificateRequestSeq && requestedVersion === String(versionNow)) {
          setCertificatePreviewSource(
            withCertificateCacheBuster(previewUrl),
            withCertificateCacheBuster(cdnUrl),
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=",
            {
              keepCurrentWhileLoading: true,
              perUrlTimeoutMs: 15000,
              directCertificateLoad: true
            }
          );
        } else if (silent && requestedVersion === String(versionNow)) {
          setCertificatePreviewSource(
            withCertificateCacheBuster(previewUrl),
            withCertificateCacheBuster(cdnUrl),
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=",
            {
              keepCurrentWhileLoading: true,
              perUrlTimeoutMs: 15000,
              directCertificateLoad: true
            }
          );
        } else if (certificateLoading && !silent) {
          certificateLoading.style.display = "none";
        }
      }

      // Probe expected URL only for legacy id formats.
      const expectedUrl = buildExpectedCertificateUrl(starId, requestedVersion);
      if (expectedUrl && shouldProbeExpectedCertificateUrl(starId)) {
        updateProgress(25);
        console.log("[starmint] Probing expected certificate URL:", expectedUrl);
        const probeResult = await new Promise((resolve) => {
          const img = new Image();
          img.onload = () => resolve(expectedUrl);
          img.onerror = () => resolve(null);
          img.src = expectedUrl + "?ts=" + Date.now();
          setTimeout(() => resolve(null), 6500);
        });

        if (probeResult) {
          updateProgress(100);
          console.log("[starmint] Found existing certificate via probe:", probeResult);
          certificateUrl = probeResult;
          // Small delay so user sees 100%
          await new Promise(r => setTimeout(r, 300));
          finalizeSuccessfulGeneration(certificateUrl);
          return certificateUrl;
        }
      }

      if (!silent) {
        updateProgress(18);
        clearCertificateProgressSim();
        certificateProgressSimTimer = setInterval(function () {
          const progressBar = certificateLoading && certificateLoading.querySelector("#cert-progress-bar");
          if (!progressBar) return;
          const current = Number.parseFloat(progressBar.style.width) || 18;
          const next = Math.min(current + (Math.random() * 6 + 2), 90);
          progressBar.style.width = next + "%";
        }, 380);
      }
      let attempts = 0;
      const maxAttempts = 3;

      const attemptGeneration = async () => {
        while (attempts < maxAttempts) {
          attempts++;
          updateProgress(40 + (attempts * 15));
          try {
            const res = await window.starmintFetchWithRetry(`${API_HOST_STAR_SELECTORS_ALL}certificate/create?starId=${starId}&starName=${encodeURIComponent(resolvedStarName)}&chart=${chart}&showDate=${showDate}&showMessage=${showMessage}&date=${namingDate}&version=${requestedVersion}&zodiac=${current_star.zodiac}&constellation=${current_star.constellation}`, {
              method: 'GET'
            });
            const data = await res.json();
            if (data && data.imageLink) {
              return {
                ...data,
                httpStatus: res.status,
              };
            }
            throw new Error("Missing imageLink in response");
          } catch (err) {
            console.warn(`Certificate attempt ${attempts} failed:`, err);
            if (attempts < maxAttempts) await new Promise(r => setTimeout(r, 2000));
          }
        }
        return null;
      };

      const data = await attemptGeneration();

      if (!data || !data.imageLink) {
        clearCertificateProgressSim();
        if (certificateLoading && !silent) {
          certificateLoading.style.display = "none";
        }
        console.error("Failed to generate certificate after retries");
        // Keep the Next button visible so the user is never stuck on this step.
        const postCertificateActions = document.getElementById("post-certificate-actions");
        if (postCertificateActions) postCertificateActions.style.display = "flex";
        return null;
      }

      console.log("data from generate certificate api:", data);
      const generatedUrl = String(data.imageLink || "").trim();
      let safeGeneratedUrl = "";
      try {
        const parsedGenerated = new URL(generatedUrl, window.location.origin);
        if (parsedGenerated.protocol === "http:" || parsedGenerated.protocol === "https:") {
          safeGeneratedUrl = parsedGenerated.toString();
        }
      } catch (_err) { }

      if (!safeGeneratedUrl) {
        clearCertificateProgressSim();
        console.warn("Ignoring invalid certificate imageLink:", generatedUrl);
        const postCertificateActions = document.getElementById("post-certificate-actions");
        if (postCertificateActions) postCertificateActions.style.display = "flex";
        if (certificateLoading && !silent) {
          certificateLoading.style.display = "none";
        }
        return null;
      }

      updateProgress(Math.max(70, 40 + (attempts * 15)));

      let reachableCertificateUrl = "";
      if (data.status === "ready") {
        reachableCertificateUrl = data.previewUrl || data.imageLink || safeGeneratedUrl;
      } else if (data.status === "processing" || data.httpStatus === 202 || data.jobKey) {
        reachableCertificateUrl = await pollCertificateJobStatus(
          data.jobKey,
          data.previewUrl || safeGeneratedUrl,
          { maxAttempts: 45, intervalMs: 1500 }
        );
      }

      if (!reachableCertificateUrl) {
        reachableCertificateUrl = await resolveReachableCertificateUrl(safeGeneratedUrl, {
          jobKey: data.jobKey,
          maxAttempts: 8,
        });
      }
      if (!reachableCertificateUrl && safeGeneratedUrl) {
        if (!isTrustedCertificateImageLink(safeGeneratedUrl)) {
          console.warn(
            "Certificate image probe timed out or failed; using create API URL so previews can continue:",
            safeGeneratedUrl
          );
        }
        reachableCertificateUrl = safeGeneratedUrl;
      }
      if (!reachableCertificateUrl) {
        console.warn("No usable certificate URL from API result:", safeGeneratedUrl);
        const postCertificateActions = document.getElementById("post-certificate-actions");
        if (postCertificateActions) postCertificateActions.style.display = "flex";
        if (certificateLoading && !silent) {
          certificateLoading.style.display = "none";
        }
        return null;
      }

      const previewUrl = resolveCertificatePreviewUrl({
        apiData: data,
        starId,
        version: requestedVersion,
        cdnUrl: data.imageLink || reachableCertificateUrl,
      });
      certificateUrl = data.imageLink || reachableCertificateUrl;
      finalizeSuccessfulGeneration(certificateUrl, previewUrl);
      return certificateUrl;
    })();

    certificateInFlightByKey[inflightKey] = genPromise;
    genPromise.catch(function () { }).finally(function () {
      delete certificateInFlightByKey[inflightKey];
    });
    return await genPromise;
  }

  // Handle Checkout Button Click
  let checkoutBtn = document.getElementById("checkout-button");
  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", function (e) {
      e.preventDefault();
      window.location.href = "/cart";
    });
  }

  // Handle Choose Gift Button Click
  let chooseGiftBtn = document.getElementById("choose-gift-button");
  if (chooseGiftBtn) {
    chooseGiftBtn.onclick = function (e) {
      e.preventDefault();
      e.stopPropagation();
      updateCertificateStarNameDisplay();
      savePreviewContext();
      generateAddToCartButtonSettings();

      const giftingCheckoutNextContainer = document.getElementById("gifting-checkout-next-container");
      const giftingCheckoutNextButton = document.getElementById("gifting-checkout-next-button");
      if (giftingCheckoutNextContainer) {
        giftingCheckoutNextContainer.style.display = "flex";
      }
      if (giftingCheckoutNextButton) {
        giftingCheckoutNextButton.onclick = function (nextEvent) {
          nextEvent.preventDefault();
          window.location.href = "/cart";
        };
      }
      if (productDetailsWrapper) {
        productDetailsWrapper.style.display = "none";
      }
      if (shopGiftsWrapper) {
        shopGiftsWrapper.style.display = "block";
        setTimeout(function () {
          shopGiftsWrapper.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 50);
      }
      chooseGiftBtn.style.display = "none";
    };
  }

  window.generateCertificate = generateCertificate;

}); // end domcontentloaded

// Auto-trigger real certificate creation as soon as the user has a star.
// This removes the wait time after clicking "Create" later.
function autoGenerateCertificateIfNeeded(options) {
  try {
    if (!current_star || !current_star.id || !current_star.chart) return;
    const namingDate = document.getElementById("namingDate")?.value?.trim() || formattedToday;
    const autoStarName =
      document.getElementById("starName")?.value?.trim() ||
      (current_star?.identifier && String(current_star.identifier).trim()) ||
      (current_star?.name && String(current_star.name).trim()) ||
      "";
    const targetVersion = String((options && options.targetVersion) || versionNow);
    const versionsToBuild = options?.prewarmBoth ? ["1", "2"] : [targetVersion];
    const uniqueVersions = [...new Set(versionsToBuild.map((v) => String(v)))];

    const runAutoGenerate = function () {
      if (typeof window.generateCertificate !== "function") return;
      uniqueVersions.forEach((versionValue) => {
        const cacheKey = getCertificateCacheKeyFor(versionValue, showDate, showMessage, namingDate);
        if (certificateCache[cacheKey] || certificateInFlightByKey[cacheKey]) return;
        window.generateCertificate(
          current_star.id,
          current_star.chart,
          showDate,
          showMessage,
          namingDate,
          autoStarName,
          {
            silent: true,
            requestedVersion: versionValue,
          }
        );
      });
    };

    if (options?.immediate) {
      if (certificateAutoGenerateTimer) {
        clearTimeout(certificateAutoGenerateTimer);
        certificateAutoGenerateTimer = null;
      }
      runAutoGenerate();
      return;
    }

    if (certificateAutoGenerateTimer) {
      clearTimeout(certificateAutoGenerateTimer);
    }
    certificateAutoGenerateTimer = setTimeout(runAutoGenerate, 350);
  } catch (autoGenErr) {
    console.warn("Auto certificate generation failed:", autoGenErr);
  }
}

// Certificate layout version (sync with legacy certificateVersion)
function toggleVersion(version) {
  versionNow = String(version);
  certificateVersion = versionNow;

  document.querySelectorAll(".certificate-style-option").forEach(function (el) {
    var v = el.getAttribute("data-certificate-version");
    var on = v === versionNow;
    el.classList.toggle("certificate-style-option--selected", on);
    el.setAttribute("aria-pressed", on ? "true" : "false");
  });

  findCertificate();
  autoGenerateCertificateIfNeeded({ targetVersion: versionNow });
}

// toggle buttons
const dateToggleEl = document.getElementById("dateToggle");
if (dateToggleEl) {
  dateToggleEl.addEventListener("click", function () {
    showDate = toggleButton(this);
    findCertificate();
    autoGenerateCertificateIfNeeded({ targetVersion: versionNow, prewarmBoth: true });
  });
}

const messageToggleEl = document.getElementById("messageToggle");
if (messageToggleEl) {
  messageToggleEl.addEventListener("click", function () {
    showMessage = toggleButton(this);
    findCertificate();
    autoGenerateCertificateIfNeeded({ targetVersion: versionNow, prewarmBoth: true });
  });
}

function toggleButton(button) {
  if (button.classList.contains('off')) {
    button.classList.remove('off');
    button.querySelector('.text').textContent = 'ON';
    return true
  } else {
    button.classList.add('off');
    button.querySelector('.text').textContent = 'OFF';
    return false
  }
}


// dropdown search
/* When the user clicks on the button,
toggle between hiding and showing the dropdown content */

// ADDITIONAL CODE >>
// Listen on the 'click' event inside the constellationDropdown element"
document.querySelector("#constellationDropdown").addEventListener("click", e => {
  // If the click was triggered by an <a> element:
  if (e.target.nodeName !== "LI") {
    return;
  }
  // Set the value of the selected text to the input value:
  document.querySelector("#constellationDropdownSearchInput").value = e.target.textContent;
})

function filterConstellationDropdown() {
  var input, filter, div, a, i, found;
  input = document.getElementById("constellationDropdownSearchInput");
  filter = input.value.toUpperCase();
  div = document.getElementById("constellationDropdown");
  a = div.getElementsByTagName("div");
  found = false; // Initialize found as false

  for (i = 0; i < a.length; i++) {
    txtValue = a[i].textContent || a[i].innerText;
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      a[i].style.display = "";
      found = true; // Set found to true if a match is found
    } else {
      a[i].style.display = "none";
    }
  }

  // Check after the loop if any constellation was found
  if (!found) {
    // If no constellation found, show the error message
    document.getElementById("byConstellationDropdownError").innerHTML = "No constellation found.";
    document.getElementById("byConstellationDropdownError").style.display = "block";
    document.getElementById("byConstellationDropdownError").style.textAlign = "center";
    document.getElementById("constellationDropdown").style.height = "auto";
    document.getElementById("constellationDropdown").style.marginBottom = "0";
  } else {
    // If at least one constellation is found, hide the error message
    document.getElementById("byConstellationDropdownError").style.display = "none";
    document.getElementById("byConstellationDropdownError").style.textAlign = "left";
    document.getElementById("constellationDropdown").style.height = "600px";
    document.getElementById("constellationDropdown").style.marginBottom = "12rem";
  }
}


// END OF DROPDOWN

function getVisibleStarSelectionScreen() {
  const ids = [
    "star-select-zodiac-results",
    "star-select-random-results",
    "star-select-constellation-results",
    "star-select-byIdentifier-results",
    "star-select-byNightsky-results",
    "star-select-confirm-results"
  ];
  for (const id of ids) {
    const el = document.getElementById(id);
    if (!el) continue;
    const style = window.getComputedStyle(el);
    if (style.display !== "none" && style.visibility !== "hidden") return el;
  }
  return null;
}

function ensurePersonalizeGlobalActions() {
  let actionBar = document.getElementById("starmint-global-screen-actions");
  if (!actionBar) {
    actionBar = document.createElement("div");
    actionBar.id = "starmint-global-screen-actions";
    actionBar.style.display = "none";
    actionBar.style.gap = "0.75rem";
    actionBar.style.marginTop = "1rem";
    actionBar.style.flexWrap = "wrap";
    actionBar.style.justifyContent = "center";
    actionBar.style.alignItems = "center";
    actionBar.style.display = "none";
    actionBar.style.paddingBottom = "0.5rem";
    actionBar.innerHTML = `
                <button type="button" id="starmint-global-new-star-btn" class="button button--primary button-secondary">New Star</button>
                <button type="button" id="starmint-global-done-btn" class="button button--primary">Done</button>
              `;
  }

  const visibleScreen = getVisibleStarSelectionScreen();
  if (!visibleScreen) {
    actionBar.style.display = "none";
    return;
  }

  const hideForIntroScreens =
    visibleScreen.id === "star-select-zodiacs-list" ||
    visibleScreen.id === "constellation-drop" ||
    visibleScreen.id === "byIdentifier-drop" ||
    visibleScreen.id === "byNightsky-drop" ||
    visibleScreen.id === "star-select-confirm-results";
  if (hideForIntroScreens) {
    actionBar.style.display = "none";
    return;
  }

  if (actionBar.parentElement !== visibleScreen) {
    visibleScreen.appendChild(actionBar);
  }
  actionBar.style.display = "flex";

  const newStarBtn = document.getElementById("starmint-global-new-star-btn");
  const doneBtn = document.getElementById("starmint-global-done-btn");
  if (newStarBtn && !newStarBtn.dataset.bound) {
    newStarBtn.dataset.bound = "1";
    newStarBtn.addEventListener("click", function () {
      const restartAny = document.querySelector(".restart-button, .restart-button-alt, #restart-button");
      if (restartAny) {
        restartAny.click();
      } else {
        try {
          starmintClearStarFlowState();
        } catch (_e) {}
        window.location.href = "/pages/select-a-star?starmint_fresh=1";
      }
    });
  }
  if (doneBtn && !doneBtn.dataset.bound) {
    doneBtn.dataset.bound = "1";
    doneBtn.addEventListener("click", function () {
      if (!current_star || !current_star.id) {
        const err = document.getElementById("err-message-account-submit2");
        if (err) {
          err.innerHTML = "Please select a star first, then click Done.";
          err.style.display = "block";
        }
        return;
      }
      const confirmSection = document.getElementById("star-select-confirm-results");
      if (confirmSection) {
        confirmSection.style.display = "block";
        setActivePage(2);
        if (typeof window.starmintTriggerFastReservation === "function") {
          window.starmintTriggerFastReservation();
        }
        scrollToElement(confirmSection);
      }
    });
  }
}

function setActivePage(pageNumber) {
  const circles = document.querySelectorAll('.step-circle');

  // Reset all circles
  circles.forEach(circle => circle.classList.remove('active'));

  // Set active circle
  if (pageNumber >= 0 && pageNumber < circles.length) {
    circles[pageNumber].classList.add('active');
  }
  setTimeout(ensurePersonalizeGlobalActions, 0);
}
setTimeout(ensurePersonalizeGlobalActions, 0);


// toggle password visibility
let passwordVisible = {};
let loginPasswordVisible = false;

function togglePassword(inputField) {
  const passwordInput = document.getElementById(inputField);
  const eyeIcon = document.getElementById(`eyeIcon${inputField}`);
  passwordVisible[inputField] = !passwordVisible[inputField];

  if (passwordVisible[inputField]) {
    passwordInput.type = 'text';
    eyeIcon.innerHTML = STARMINT_SVG_HIDE;
  } else {
    passwordInput.type = 'password';
    eyeIcon.innerHTML = STARMINT_SVG_EYE;
  }
}

let eyeIconpassword = document.getElementById('eyeIconpassword');
if (eyeIconpassword) {
  eyeIconpassword.addEventListener('click', function () {
    togglePassword('password');
  });
}

let eyeIconconfirmPassword = document.getElementById('eyeIconconfirmPassword')
if (eyeIconconfirmPassword) {
  eyeIconconfirmPassword.addEventListener('click', function () {
    togglePassword('confirmPassword');
  });
}

let eyeIconLoginPassword = document.getElementById('eyeIconLoginPassword')
if (eyeIconLoginPassword) {
  eyeIconLoginPassword.addEventListener('click', function () {
    const loginPasswordInput = document.getElementById('login-password');
    const eyeIconLoginPassword = document.getElementById('eyeIconLoginPassword');
    loginPasswordVisible = !loginPasswordVisible;

    if (loginPasswordVisible) {
      loginPasswordInput.type = 'text';
      eyeIconLoginPassword.innerHTML = STARMINT_SVG_HIDE;
    } else {
      loginPasswordInput.type = 'password';
      eyeIconLoginPassword.innerHTML = STARMINT_SVG_EYE;
    }
  });
}


// check star name whether unique
let starNameInput = document.getElementById('starName');
starNameInput.addEventListener('blur', async () => {
  const name = starNameInput.value;
  if (typeof current_star !== 'undefined') {
    current_star.name = name;
    if (typeof savePreviewContext === 'function') savePreviewContext();
  }
});

starNameInput.addEventListener('input', () => {
  console.log("input input");
  document.getElementById("err-message-star").innerHTML = "<br/>";
  document.getElementById("star-form-continue-0").disabled = false;
  checkedAndOK = false;
});

// Function to check if the character is a valid phone number character
function isValidPhoneNumberChar(char) {
  const validChars = '0123456789+';
  return validChars.includes(char);
}

function validatePhoneNumber(phoneNumber) {
  // Regular expression for E.164 format validation
  const phoneRegex = /^\+[1-9]\d{7,14}$/;
  return phoneRegex.test(phoneNumber);
}

function normalizePhoneInput(rawValue) {
  const compact = (rawValue || "").trim().replace(/\s+/g, "");
  if (!compact) return "";

  let digits = compact.replace(/\D/g, "");
  if (!digits) return "";

  if (digits.length === 10) return "+1" + digits;

  if (compact.startsWith("+")) {
    digits = digits.replace(/^0+/, "");
  }

  if (digits.length >= 8 && digits.length <= 15) {
    return "+" + digits;
  }

  return "";
}


// Unified phone number validation function
function phoneNumberValidation(event) {
  const inputField = event.target;
  const inputType = event.type;
  const inputValue = (inputField.value || "").trim();

  if (inputType === 'input' || inputType == "keyup") {
    // Filter out invalid characters as the user types
    const filteredInput = inputValue.split('').filter(isValidPhoneNumberChar).join('');
    inputField.value = filteredInput;
  } else if (inputType === 'blur') {
    // Normalize user input, but never clear it on blur.
    // This avoids "field goes empty" when users type local formats.
    if (!inputValue) return;

    const normalizedValue = normalizePhoneInput(inputValue);
    inputField.value = normalizedValue || inputValue.replace(/\s+/g, "");
  }
}

function toE164Format(phoneNumber) {
  // Strip out all non-digit characters
  let digits = phoneNumber.replace(/\D/g, '');

  // If the number has 10 digits, assume it's a US number and prepend '+1'
  if (digits.length === 10) {
    return '+1' + digits;
  }

  // If the number is longer than 10 digits or starts with '+', assume it's already in or ready for E.164 format
  if (phoneNumber.startsWith('+')) {
    // Here, we assume the number is already formatted or needs no changes
    return phoneNumber;
  }

  // Optionally, handle numbers that start with the country code without '+'
  // For instance, '11234567890' could be converted to '+11234567890'
  // This step is optional and depends on your specific requirements
  if (digits.length > 10 && !phoneNumber.startsWith('+')) {
    return '+' + digits;
  }

  // Return an empty string or null if the number cannot be converted confidently
  return '';
}

// Attach the function to the input fields
document.getElementById('phone').addEventListener('input', phoneNumberValidation);
document.getElementById('phone').addEventListener('keyup', phoneNumberValidation);
document.getElementById('phone').addEventListener('blur', phoneNumberValidation);
document.getElementById('recPhone').addEventListener('input', phoneNumberValidation);
document.getElementById('recPhone').addEventListener('keyup', phoneNumberValidation);
document.getElementById('recPhone').addEventListener('blur', phoneNumberValidation);

// --- Start of Verification Logic for Reservation flow ---
const resVerifySubmitBtn = document.getElementById("res-verify-submit-button");
const resResendBtn = document.getElementById("res-resend-button");
const resVerifyCodeInput = document.getElementById("res-verificationCode");
const resVerifyMsg = document.getElementById("res-verify-message");

if (resVerifySubmitBtn) {
  resVerifySubmitBtn.addEventListener("click", async function () {
    function resetVerifyUiOnFailure(message) {
      document.getElementById("loading").style.display = "none";
      document.getElementById("reservation-verify-step").style.display = "block";
      resVerifyMsg.style.color = "red";
      resVerifyMsg.innerText = message || "Unable to complete reservation. Please try again.";
      resVerifySubmitBtn.disabled = false;
      resVerifySubmitBtn.textContent = "Verify & Reserve";
    }

    const pendingData = window._starReservationPendingData;
    console.log("[starmint] verify-and-reserve clicked", {
      hasPendingData: Boolean(pendingData),
      email: pendingData?.email || null
    });
    if (!pendingData) {
      resVerifyMsg.innerText = "Reservation data lost. Please refresh and try again.";
      return;
    }

    const email = pendingData.email;
    const code = resVerifyCodeInput.value.trim();

    if (!code) {
      resVerifyMsg.innerText = "Please enter the verification code.";
      return;
    }

    resVerifySubmitBtn.disabled = true;
    resVerifySubmitBtn.textContent = "Verifying...";
    resVerifyMsg.innerText = "";

    try {
      const result = await window.starmintAuthVerifyEmailCode(
        email,
        code,
        pendingData?.accountsData?.password || ""
      );
      console.log("[starmint] OTP verify result", { success: Boolean(result?.success), message: result?.message || "" });
      if (result.success) {
        // 1. Set the session
        if (typeof window.starmintSetSupabaseSession === 'function') {
          window.starmintSetSupabaseSession(result);
        }

        resVerifyMsg.style.color = "green";
        resVerifyMsg.innerText = "Verified! Creating account...";

        // 2. We already created the account before requesting OTP.
        let accountData = pendingData.accountData || null;

        // 2.5 Auto-login to establish the session/tokens
        resVerifyMsg.innerText = "Verified! Setting up your session...";
        try {
          if (typeof window.starmintAuthLogin === 'function') {
            const loginRes = await window.starmintAuthLogin(pendingData.email, pendingData.accountsData.password);
            console.log("Auto-login result:", loginRes);

            if (!loginRes.success) {
              console.warn("Auto-login failed:", loginRes.message);
              // If email not confirmed, we need to show error and stop loading
              if (loginRes.message.includes("not been verified") || loginRes.message.includes("Email not confirmed")) {
                document.getElementById("loading").style.display = "none";
                resVerifyMsg.style.color = "red";
                resVerifyMsg.innerText = "Error: " + loginRes.message;
                resVerifySubmitBtn.disabled = false;
                resVerifySubmitBtn.textContent = "Verify & Reserve";
                return;
              }
            }
          }
        } catch (loginErr) {
          console.warn("Auto-login attempt failed, but proceeding to reservation.", loginErr);
        }

        // 3. Finalize Reservation
        document.getElementById("reservation-verify-step").style.display = "none";
        document.getElementById("loading").style.display = "block";
        document.getElementById("loading").querySelector("p").innerHTML = "Claiming Your Star...";

        if (typeof window.reserveStar === 'function') {
          const verifyStarName =
            (pendingData.starName && String(pendingData.starName).trim()) ||
            (document.getElementById("starName") && String(document.getElementById("starName").value || "").trim()) ||
            "";

          const reservePayload = pendingData.is_gift
            ? starmintBuildGiftReservePayload(
                {
                  shopifyAccountID:
                    pendingData.accountsData?.shopifyCustomerId ||
                    (typeof starmintResolveStorefrontCustomerId === "function"
                      ? starmintResolveStorefrontCustomerId()
                      : null),
                  accountID: accountData?.auth_user_id || null,
                  contactID: accountData?.contact?.id || null,
                  email: pendingData.email || accountData?.contact?.email || null,
                  full_name: [pendingData.accountsData?.firstName, pendingData.accountsData?.lastName]
                    .filter(Boolean)
                    .join(" ")
                    .trim(),
                },
                accountData
              )
            : accountData;

          await window.reserveStar(
            verifyStarName,
            pendingData.namingDate,
            pendingData.personalMessage,
            pendingData.is_gift,
            reservePayload
          );
        } else {
          resetVerifyUiOnFailure("Reservation service is unavailable. Please refresh and try again.");
          return;
        }
      } else {
        resetVerifyUiOnFailure(result.message || "Invalid code.");
      }
    } catch (error) {
      console.error("Verification error:", error);
      resetVerifyUiOnFailure(error?.message || "Error verifying code.");
    }
  });
}

if (resResendBtn) {
  resResendBtn.addEventListener("click", async function () {
    const pendingData = window._starReservationPendingData;
    if (!pendingData) return;
    resResendBtn.disabled = true;
    resResendBtn.textContent = "Sending...";
    try {
      await window.starmintAuthRequestEmailCode(pendingData.email);
      alert("Code resent!");
    } catch (e) {
      alert("Error resending code.");
    } finally {
      resResendBtn.disabled = false;
      resResendBtn.textContent = "Resend Code";
    }
  });
}
// --- End of Verification Logic ---

// Block star selection until its chart has loaded.
// Runs in capture phase so it fires before any other click handler.
document.addEventListener("click", function (e) {
  var btn = e.target && e.target.closest ? e.target.closest("button[select-star-identifier]") : null;
  if (!btn) return;
  if (btn.getAttribute("select-star-chart")) return; // chart ready — allow
  // Chart not ready: block the click and show feedback on the button
  e.stopImmediatePropagation();
  e.preventDefault();
  var _origText = btn.textContent;
  btn.textContent = "Chart loading… please wait";
  btn.disabled = true;
  var _poll = setInterval(function () {
    if (btn.getAttribute("select-star-chart")) {
      clearInterval(_poll);
      btn.disabled = false;
      btn.textContent = _origText;
    }
  }, 300);
}, true);




